(function ($, undefined) {

    var LoadSMAPI = sm.portal.vm.custom.callCustomization('LoadRequiredSMAPI');
    if(!sm.portal.utility.isNullOrEmpty(LoadSMAPI)){
        return;
    }
    
    var smapi = window.smapi = window.smapi || {},
        extend = $.extend,
        each = $.each,
        proxy = $.proxy,
        noop = $.noop,
        isFunction = $.isFunction,
        globalize = window.Globalize;
    
    extend(smapi, { community: {} });
    
    function AddressAssociationModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.AddressAssociation', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AddressTypeAssociationModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.AddressAssociation = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AddressAssociation != null && responseData.AddressAssociation.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.AddressAssociation.length; i++) {
                    items.push(new smapi.community.AddressAssociationModel().LoadFromResponse(responseData.AddressAssociation[i]));
                }
                loaded.AddressAssociation(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.AddressTypeAssociation', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ElectronicAddressModel(options) {
        var defaults = {
            ContactID: 0,
            TypeEntryID: null,
            Value: '',
            EffectiveFrom: null,
            EffectiveTo: null,
            DoNotContact: false,
            NoContactReasonID: null,
            AddressTypeID: null,
            AddressTimingTypeID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ContactID = ko.validatedObservable(settings.ContactID);
        this.TypeEntryID = ko.validatedObservable(settings.TypeEntryID);
        this.Value = ko.validatedObservable(settings.Value);
        this.EffectiveFrom = ko.validatedObservable(settings.EffectiveFrom);
        this.EffectiveTo = ko.validatedObservable(settings.EffectiveTo);
        this.DoNotContact = ko.validatedObservable(settings.DoNotContact);
        this.NoContactReasonID = ko.validatedObservable(settings.NoContactReasonID);
        this.AddressTypeID = ko.validatedObservable(settings.AddressTypeID);
        this.AddressTimingTypeID = ko.validatedObservable(settings.AddressTimingTypeID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Contact = ko.observable();
        this.AddressType = ko.observable();
        this.TypeEntry = ko.observable();
        this.Associations = ko.observableArray([]);
        this.NoContactReason = ko.observable();
        this.AddressTimingType = ko.observable();
        var customData = {
            defaults : defaults,
            self : self,
            settings : settings
        }

        sm.portal.vm.custom.callCustomization('UpdateElectronicAddressModelProps', customData);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ContactID != undefined) {
                loaded.ContactID(responseData.ContactID);
            }
            if (responseData.TypeEntryID != undefined) {
                loaded.TypeEntryID(responseData.TypeEntryID);
            }
            if (responseData.Value != undefined) {
                loaded.Value(responseData.Value);
            }
            if (responseData.EffectiveFrom != undefined) {
                loaded.EffectiveFrom(responseData.EffectiveFrom);
            }
            if (responseData.EffectiveTo != undefined) {
                loaded.EffectiveTo(responseData.EffectiveTo);
            }
            if (responseData.DoNotContact != undefined) {
                loaded.DoNotContact(responseData.DoNotContact);
            }
            if (responseData.NoContactReasonID != undefined) {
                loaded.NoContactReasonID(responseData.NoContactReasonID);
            }
            if (responseData.AddressTypeID != undefined) {
                loaded.AddressTypeID(responseData.AddressTypeID);
            }
            if (responseData.AddressTimingTypeID != undefined) {
                loaded.AddressTimingTypeID(responseData.AddressTimingTypeID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Contact != null) {
                loaded.Contact(new smapi.community.ContactModel().LoadFromResponse(responseData.Contact));
            }
            if (responseData.AddressType != null) {
                loaded.AddressType(new smapi.community.AddressTypeAssociationModel().LoadFromResponse(responseData.AddressType));
            }
            if (responseData.TypeEntry != null) {
                loaded.TypeEntry(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.TypeEntry));
            }
            if (responseData.Associations != null && responseData.Associations.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Associations.length; i++) {
                    items.push(new smapi.community.AddressAssociationModel().LoadFromResponse(responseData.Associations[i]));
                }
                loaded.Associations(items);
            }
            if (responseData.NoContactReason != null) {
                loaded.NoContactReason(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.NoContactReason));
            }
            if (responseData.AddressTimingType != null) {
                loaded.AddressTimingType(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.AddressTimingType));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.ElectronicAddress', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ContactID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TypeEntryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Value.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.EffectiveFrom.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EffectiveTo.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.NoContactReasonID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AddressTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AddressTimingTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function RegionModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.Region', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CountryModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            CountryCode: '',
            RegionID: null,
            SortOrder: 0,
            ISOCode: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.CountryCode = ko.validatedObservable(settings.CountryCode);
        this.RegionID = ko.validatedObservable(settings.RegionID);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.ISOCode = ko.validatedObservable(settings.ISOCode);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Region = ko.observable();
        this.GoverningDistrict = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.CountryCode != undefined) {
                loaded.CountryCode(responseData.CountryCode);
            }
            if (responseData.RegionID != undefined) {
                loaded.RegionID(responseData.RegionID);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.ISOCode != undefined) {
                loaded.ISOCode(responseData.ISOCode);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Region != null) {
                loaded.Region(new smapi.community.RegionModel().LoadFromResponse(responseData.Region));
            }
            if (responseData.GoverningDistrict != null && responseData.GoverningDistrict.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.GoverningDistrict.length; i++) {
                    items.push(new smapi.community.GoverningDistrictModel().LoadFromResponse(responseData.GoverningDistrict[i]));
                }
                loaded.GoverningDistrict(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.Country', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.CountryCode.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 15,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '15')
            }
        });
        this.RegionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ISOCode.extend({
            maxLength: {
                params: 10,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '10')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function UTCTimezoneModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            BusinessMeaningName: '',
            UTCOffsetHours: 0,
            UTCOffsetMinutes: 0,
            ExampleCountryList: '',
            SystemProtected: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.UTCOffsetHours = ko.validatedObservable(settings.UTCOffsetHours);
        this.UTCOffsetMinutes = ko.validatedObservable(settings.UTCOffsetMinutes);
        this.ExampleCountryList = ko.validatedObservable(settings.ExampleCountryList);
        this.SystemProtected = ko.validatedObservable(settings.SystemProtected);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.UTCOffsetHours != undefined) {
                loaded.UTCOffsetHours(responseData.UTCOffsetHours);
            }
            if (responseData.UTCOffsetMinutes != undefined) {
                loaded.UTCOffsetMinutes(responseData.UTCOffsetMinutes);
            }
            if (responseData.ExampleCountryList != undefined) {
                loaded.ExampleCountryList(responseData.ExampleCountryList);
            }
            if (responseData.SystemProtected != undefined) {
                loaded.SystemProtected(responseData.SystemProtected);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.UTCTimezone', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.UTCOffsetHours.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.UTCOffsetMinutes.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ExampleCountryList.extend({
            maxLength: {
                params: 200,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '200')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function MailingAddressModel(options) {
        var defaults = {
            ContactID: 0,
            Address1: '',
            Address2: '',
            Address3: '',
            City: '',
            StateID: null,
            PostalCode: '',
            County: '',
            CountryID: null,
            TypeEntryID: null,
            AddressTypeID: null,
            EffectiveFrom: null,
            EffectiveTo: null,
            ValidatedWhen: null,
            AddressTimingTypeID: null,
            DoNotContact: false,
            NoContactReasonID: null,
            NCOAIsInvalid: false,
            NCOADateCheck: null,
            NCOACode: 0,
            Latitude: 0,
            Longitude: 0,
            GEOCode: '',
            UnitNumber: '',
            Floor: '',
            BuildingName: '',
            StreetNumber: '',
            StreetName: '',
            StreetAddress: '',
            StreetDirection: '',
            StreetSuffixName: '',
            PostOfficeBoxNumber: '',
            Municipality: '',
            GoverningDistrictName: '',
            CareOf: '',
            Miscellaneous1: '',
            Miscellaneous2: '',
            Miscellaneous3: '',
            TextValue: '',
            HTMLValue: '',
            StreetSuffixID: null,
            MailingAddressTemplateID: null,
            UTCTimezoneID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ContactID = ko.validatedObservable(settings.ContactID);
        this.Address1 = ko.validatedObservable(settings.Address1);
        this.Address2 = ko.validatedObservable(settings.Address2);
        this.Address3 = ko.validatedObservable(settings.Address3);
        this.City = ko.validatedObservable(settings.City);
        this.StateID = ko.validatedObservable(settings.StateID);
        this.PostalCode = ko.validatedObservable(settings.PostalCode);
        this.County = ko.validatedObservable(settings.County);
        this.CountryID = ko.validatedObservable(settings.CountryID);
        this.TypeEntryID = ko.validatedObservable(settings.TypeEntryID);
        this.AddressTypeID = ko.validatedObservable(settings.AddressTypeID);
        this.EffectiveFrom = ko.validatedObservable(settings.EffectiveFrom);
        this.EffectiveTo = ko.validatedObservable(settings.EffectiveTo);
        this.ValidatedWhen = ko.validatedObservable(settings.ValidatedWhen);
        this.AddressTimingTypeID = ko.validatedObservable(settings.AddressTimingTypeID);
        this.DoNotContact = ko.validatedObservable(settings.DoNotContact);
        this.NoContactReasonID = ko.validatedObservable(settings.NoContactReasonID);
        this.NCOAIsInvalid = ko.validatedObservable(settings.NCOAIsInvalid);
        this.NCOADateCheck = ko.validatedObservable(settings.NCOADateCheck);
        this.NCOACode = ko.validatedObservable(settings.NCOACode);
        this.Latitude = ko.validatedObservable(settings.Latitude);
        this.Longitude = ko.validatedObservable(settings.Longitude);
        this.GEOCode = ko.validatedObservable(settings.GEOCode);
        this.UnitNumber = ko.validatedObservable(settings.UnitNumber);
        this.Floor = ko.validatedObservable(settings.Floor);
        this.BuildingName = ko.validatedObservable(settings.BuildingName);
        this.StreetNumber = ko.validatedObservable(settings.StreetNumber);
        this.StreetAddress = ko.validatedObservable(settings.StreetAddress);
        this.StreetName = ko.validatedObservable(settings.StreetName);
        this.StreetDirection = ko.validatedObservable(settings.StreetDirection);
        this.StreetSuffixName = ko.validatedObservable(settings.StreetSuffixName);
        this.PostOfficeBoxNumber = ko.validatedObservable(settings.PostOfficeBoxNumber);
        this.Municipality = ko.validatedObservable(settings.Municipality);
        this.GoverningDistrictName = ko.validatedObservable(settings.GoverningDistrictName);
        this.CareOf = ko.validatedObservable(settings.CareOf);
        this.Miscellaneous1 = ko.validatedObservable(settings.Miscellaneous1);
        this.Miscellaneous2 = ko.validatedObservable(settings.Miscellaneous2);
        this.Miscellaneous3 = ko.validatedObservable(settings.Miscellaneous3);
        this.TextValue = ko.validatedObservable(settings.TextValue);
        this.HTMLValue = ko.validatedObservable(settings.HTMLValue);
        this.StreetSuffixID = ko.validatedObservable(settings.StreetSuffixID);
        this.MailingAddressTemplateID = ko.validatedObservable(settings.MailingAddressTemplateID);
        this.UTCTimezoneID = ko.validatedObservable(settings.UTCTimezoneID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.UTCTimezone = ko.observable();
        this.StreetSuffix = ko.observable();
        this.MailingAddressTemplate = ko.observable();
        this.Contact = ko.observable();
        this.GoverningDistrict = ko.observable();
        this.Country = ko.observable();
        this.AddressType = ko.observable();
        this.Associations = ko.observableArray([]);
        this.TypeEntry = ko.observable();
        this.AddressTimingType = ko.observable();
        this.NoContactReason = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ContactID != undefined) {
                loaded.ContactID(responseData.ContactID);
            }
            if (responseData.Address1 != undefined) {
                loaded.Address1(responseData.Address1);
            }
            if (responseData.Address2 != undefined) {
                loaded.Address2(responseData.Address2);
            }
            if (responseData.Address3 != undefined) {
                loaded.Address3(responseData.Address3);
            }
            if (responseData.City != undefined) {
                loaded.City(responseData.City);
            }
            if (responseData.StateID != undefined) {
                loaded.StateID(responseData.StateID);
            }
            if (responseData.PostalCode != undefined) {
                loaded.PostalCode(responseData.PostalCode);
            }
            if (responseData.County != undefined) {
                loaded.County(responseData.County);
            }
            if (responseData.CountryID != undefined) {
                loaded.CountryID(responseData.CountryID);
            }
            if (responseData.TypeEntryID != undefined) {
                loaded.TypeEntryID(responseData.TypeEntryID);
            }
            if (responseData.AddressTypeID != undefined) {
                loaded.AddressTypeID(responseData.AddressTypeID);
            }
            if (responseData.EffectiveFrom != undefined) {
                loaded.EffectiveFrom(responseData.EffectiveFrom);
            }
            if (responseData.EffectiveTo != undefined) {
                loaded.EffectiveTo(responseData.EffectiveTo);
            }
            if (responseData.ValidatedWhen != undefined) {
                loaded.ValidatedWhen(responseData.ValidatedWhen);
            }
            if (responseData.AddressTimingTypeID != undefined) {
                loaded.AddressTimingTypeID(responseData.AddressTimingTypeID);
            }
            if (responseData.DoNotContact != undefined) {
                loaded.DoNotContact(responseData.DoNotContact);
            }
            if (responseData.NoContactReasonID != undefined) {
                loaded.NoContactReasonID(responseData.NoContactReasonID);
            }
            if (responseData.NCOAIsInvalid != undefined) {
                loaded.NCOAIsInvalid(responseData.NCOAIsInvalid);
            }
            if (responseData.NCOADateCheck != undefined) {
                loaded.NCOADateCheck(responseData.NCOADateCheck);
            }
            if (responseData.NCOACode != undefined) {
                loaded.NCOACode(responseData.NCOACode);
            }
            if (responseData.Latitude != undefined) {
                loaded.Latitude(responseData.Latitude);
            }
            if (responseData.Longitude != undefined) {
                loaded.Longitude(responseData.Longitude);
            }
            if (responseData.GEOCode != undefined) {
                loaded.GEOCode(responseData.GEOCode);
            }
            if (responseData.UnitNumber != undefined) {
                loaded.UnitNumber(responseData.UnitNumber);
            }
            if (responseData.Floor != undefined) {
                loaded.Floor(responseData.Floor);
            }
            if (responseData.BuildingName != undefined) {
                loaded.BuildingName(responseData.BuildingName);
            }
            if (responseData.StreetNumber != undefined) {
                loaded.StreetNumber(responseData.StreetNumber);
            }
            if (responseData.StreetName != undefined) {
                loaded.StreetName(responseData.StreetName);
            }
            if (responseData.StreetAddress != undefined) {
                loaded.StreetAddress(responseData.StreetAddress);
            }
            if (responseData.StreetDirection != undefined) {
                loaded.StreetDirection(responseData.StreetDirection);
            }
            if (responseData.StreetSuffixName != undefined) {
                loaded.StreetSuffixName(responseData.StreetSuffixName);
            }
            if (responseData.PostOfficeBoxNumber != undefined) {
                loaded.PostOfficeBoxNumber(responseData.PostOfficeBoxNumber);
            }
            if (responseData.Municipality != undefined) {
                loaded.Municipality(responseData.Municipality);
            }
            if (responseData.GoverningDistrictName != undefined) {
                loaded.GoverningDistrictName(responseData.GoverningDistrictName);
            }
            if (responseData.CareOf != undefined) {
                loaded.CareOf(responseData.CareOf);
            }
            if (responseData.Miscellaneous1 != undefined) {
                loaded.Miscellaneous1(responseData.Miscellaneous1);
            }
            if (responseData.Miscellaneous2 != undefined) {
                loaded.Miscellaneous2(responseData.Miscellaneous2);
            }
            if (responseData.Miscellaneous3 != undefined) {
                loaded.Miscellaneous3(responseData.Miscellaneous3);
            }
            if (responseData.TextValue != undefined) {
                loaded.TextValue(responseData.TextValue);
            }
            if (responseData.HTMLValue != undefined) {
                loaded.HTMLValue(responseData.HTMLValue);
            }
            if (responseData.StreetSuffixID != undefined) {
                loaded.StreetSuffixID(responseData.StreetSuffixID);
            }
            if (responseData.MailingAddressTemplateID != undefined) {
                loaded.MailingAddressTemplateID(responseData.MailingAddressTemplateID);
            }
            if (responseData.UTCTimezoneID != undefined) {
                loaded.UTCTimezoneID(responseData.UTCTimezoneID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.UTCTimezone != null) {
                loaded.UTCTimezone(new smapi.community.UTCTimezoneModel().LoadFromResponse(responseData.UTCTimezone));
            }
            if (responseData.StreetSuffix != null) {
                loaded.StreetSuffix(new smapi.community.StreetSuffixModel().LoadFromResponse(responseData.StreetSuffix));
            }
            if (responseData.MailingAddressTemplate != null) {
                loaded.MailingAddressTemplate(new smapi.community.MailingAddressTemplateModel().LoadFromResponse(responseData.MailingAddressTemplate));
            }
            if (responseData.Contact != null) {
                loaded.Contact(new smapi.community.ContactModel().LoadFromResponse(responseData.Contact));
            }
            if (responseData.GoverningDistrict != null) {
                loaded.GoverningDistrict(new smapi.community.GoverningDistrictModel().LoadFromResponse(responseData.GoverningDistrict));
            }
            if (responseData.Country != null) {
                loaded.Country(new smapi.community.CountryModel().LoadFromResponse(responseData.Country));
            }
            if (responseData.AddressType != null) {
                loaded.AddressType(new smapi.community.AddressTypeAssociationModel().LoadFromResponse(responseData.AddressType));
            }
            if (responseData.Associations != null && responseData.Associations.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Associations.length; i++) {
                    items.push(new smapi.community.AddressAssociationModel().LoadFromResponse(responseData.Associations[i]));
                }
                loaded.Associations(items);
            }
            if (responseData.TypeEntry != null) {
                loaded.TypeEntry(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.TypeEntry));
            }
            if (responseData.AddressTimingType != null) {
                loaded.AddressTimingType(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.AddressTimingType));
            }
            if (responseData.NoContactReason != null) {
                loaded.NoContactReason(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.NoContactReason));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.MailingAddress', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ContactID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Address1.extend({
            maxLength: {
                params: 80,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '80')
            }
        });
        this.Address2.extend({
            maxLength: {
                params: 80,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '80')
            }
        });
        this.Address3.extend({
            maxLength: {
                params: 80,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '80')
            }
        });
        this.City.extend({
            maxLength: {
                params: 60,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '60')
            }
        });
        this.StateID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PostalCode.extend({
            maxLength: {
                params: 10,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '10')
            }
        });
        this.County.extend({
            maxLength: {
                params: 60,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '60')
            }
        });
        this.CountryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TypeEntryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AddressTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EffectiveFrom.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EffectiveTo.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ValidatedWhen.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AddressTimingTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.NoContactReasonID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.NCOADateCheck.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.NCOACode.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Latitude.extend({
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Longitude.extend({
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GEOCode.extend({
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            }
        });
        this.UnitNumber.extend({
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            }
        });
        this.Floor.extend({
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            }
        });
        this.BuildingName.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.StreetNumber.extend({
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            }
        });
        this.StreetName.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.StreetAddress.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.StreetDirection.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.StreetSuffixName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.PostOfficeBoxNumber.extend({
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            }
        });
        this.Municipality.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.GoverningDistrictName.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.CareOf.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Miscellaneous1.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Miscellaneous2.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Miscellaneous3.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.TextValue.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.HTMLValue.extend({
            maxLength: {
                params: 2000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '2000')
            }
        });
        this.StreetSuffixID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MailingAddressTemplateID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.UTCTimezoneID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PhoneNumberModel(options) {
        var defaults = {
            ContactID: 0,
            Number: '',
            Extension: '',
            CountryPrefixCode: '',
            AreaCityCode: '',
            TypeEntryID: null,
            EffectiveFrom: null,
            EffectiveTo: null,
            AddressTypeID: null,
            AddressTimingTypeID: null,
            DoNotContact: false,
            NoContactReasonID: null,
            PhoneCarrierID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ContactID = ko.validatedObservable(settings.ContactID);
        this.Number = ko.validatedObservable(settings.Number);
        this.Extension = ko.validatedObservable(settings.Extension);
        this.CountryPrefixCode = ko.validatedObservable(settings.CountryPrefixCode);
        this.AreaCityCode = ko.validatedObservable(settings.AreaCityCode);
        this.TypeEntryID = ko.validatedObservable(settings.TypeEntryID);
        this.EffectiveFrom = ko.validatedObservable(settings.EffectiveFrom);
        this.EffectiveTo = ko.validatedObservable(settings.EffectiveTo);
        this.AddressTypeID = ko.validatedObservable(settings.AddressTypeID);
        this.AddressTimingTypeID = ko.validatedObservable(settings.AddressTimingTypeID);
        this.DoNotContact = ko.validatedObservable(settings.DoNotContact);
        this.NoContactReasonID = ko.validatedObservable(settings.NoContactReasonID);
        this.PhoneCarrierID = ko.validatedObservable(settings.PhoneCarrierID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Contact = ko.observable();
        this.AddressType = ko.observable();
        this.PhoneCarrier = ko.observable();
        this.Associations = ko.observableArray([]);
        this.TypeEntry = ko.observable();
        this.AddressTimingType = ko.observable();
        this.NoContactReason = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ContactID != undefined) {
                loaded.ContactID(responseData.ContactID);
            }
            if (responseData.Number != undefined) {
                loaded.Number(responseData.Number);
            }
            if (responseData.Extension != undefined) {
                loaded.Extension(responseData.Extension);
            }
            if (responseData.CountryPrefixCode != undefined) {
                loaded.CountryPrefixCode(responseData.CountryPrefixCode);
            }
            if (responseData.AreaCityCode != undefined) {
                loaded.AreaCityCode(responseData.AreaCityCode);
            }
            if (responseData.TypeEntryID != undefined) {
                loaded.TypeEntryID(responseData.TypeEntryID);
            }
            if (responseData.EffectiveFrom != undefined) {
                loaded.EffectiveFrom(responseData.EffectiveFrom);
            }
            if (responseData.EffectiveTo != undefined) {
                loaded.EffectiveTo(responseData.EffectiveTo);
            }
            if (responseData.AddressTypeID != undefined) {
                loaded.AddressTypeID(responseData.AddressTypeID);
            }
            if (responseData.AddressTimingTypeID != undefined) {
                loaded.AddressTimingTypeID(responseData.AddressTimingTypeID);
            }
            if (responseData.DoNotContact != undefined) {
                loaded.DoNotContact(responseData.DoNotContact);
            }
            if (responseData.NoContactReasonID != undefined) {
                loaded.NoContactReasonID(responseData.NoContactReasonID);
            }
            if (responseData.PhoneCarrierID != undefined) {
                loaded.PhoneCarrierID(responseData.PhoneCarrierID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Contact != null) {
                loaded.Contact(new smapi.community.ContactModel().LoadFromResponse(responseData.Contact));
            }
            if (responseData.AddressType != null) {
                loaded.AddressType(new smapi.community.AddressTypeAssociationModel().LoadFromResponse(responseData.AddressType));
            }
            if (responseData.PhoneCarrier != null) {
                loaded.PhoneCarrier(new smapi.community.PhoneCarrierModel().LoadFromResponse(responseData.PhoneCarrier));
            }
            if (responseData.Associations != null && responseData.Associations.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Associations.length; i++) {
                    items.push(new smapi.community.AddressAssociationModel().LoadFromResponse(responseData.Associations[i]));
                }
                loaded.Associations(items);
            }
            if (responseData.TypeEntry != null) {
                loaded.TypeEntry(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.TypeEntry));
            }
            if (responseData.AddressTimingType != null) {
                loaded.AddressTimingType(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.AddressTimingType));
            }
            if (responseData.NoContactReason != null) {
                loaded.NoContactReason(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.NoContactReason));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.PhoneNumber', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ContactID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Number.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            }
        });
        this.Extension.extend({
            maxLength: {
                params: 10,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '10')
            }
        });
        this.CountryPrefixCode.extend({
            maxLength: {
                params: 3,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '3')
            }
        });
        this.AreaCityCode.extend({
            maxLength: {
                params: 5,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '5')
            }
        });
        this.TypeEntryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EffectiveFrom.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EffectiveTo.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AddressTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AddressTimingTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.NoContactReasonID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PhoneCarrierID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ContactNoteModel(options) {
        var defaults = {
            ContactID: 0,
            CategoryID: null,
            NoteDate: null,
            Subject: '',
            Note: '',
            UserContactNoteGID: null,
            ContactTypeID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ContactID = ko.validatedObservable(settings.ContactID);
        this.CategoryID = ko.validatedObservable(settings.CategoryID);
        this.NoteDate = ko.validatedObservable(settings.NoteDate);
        this.Subject = ko.validatedObservable(settings.Subject);
        this.Note = ko.validatedObservable(settings.Note);
        this.UserContactNoteGID = ko.validatedObservable(settings.UserContactNoteGID);
        this.ContactTypeID = ko.validatedObservable(settings.ContactTypeID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Contact = ko.observable();
        this.Category = ko.observable();
        this.ContactType = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ContactID != undefined) {
                loaded.ContactID(responseData.ContactID);
            }
            if (responseData.CategoryID != undefined) {
                loaded.CategoryID(responseData.CategoryID);
            }
            if (responseData.NoteDate != undefined) {
                loaded.NoteDate(responseData.NoteDate);
            }
            if (responseData.Subject != undefined) {
                loaded.Subject(responseData.Subject);
            }
            if (responseData.Note != undefined) {
                loaded.Note(responseData.Note);
            }
            if (responseData.UserContactNoteGID != undefined) {
                loaded.UserContactNoteGID(responseData.UserContactNoteGID);
            }
            if (responseData.ContactTypeID != undefined) {
                loaded.ContactTypeID(responseData.ContactTypeID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Contact != null) {
                loaded.Contact(new smapi.community.ContactModel().LoadFromResponse(responseData.Contact));
            }
            if (responseData.Category != null) {
                loaded.Category(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.Category));
            }
            if (responseData.ContactType != null) {
                loaded.ContactType(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.ContactType));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.ContactNote', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ContactID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CategoryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.NoteDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.Subject.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 120,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '120')
            }
        });
        this.Note.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.UserContactNoteGID.extend({
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.ContactTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ContactInterestModel(options) {
        var defaults = {
            ContactID: 0,
            EntryDate: null,
            CategoryID: null,
            InterestID: null,
            RankedChoice: 0,
            Narrative: '',
            ContactTypeID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ContactID = ko.validatedObservable(settings.ContactID);
        this.EntryDate = ko.validatedObservable(settings.EntryDate);
        this.CategoryID = ko.validatedObservable(settings.CategoryID);
        this.InterestID = ko.validatedObservable(settings.InterestID);
        this.RankedChoice = ko.validatedObservable(settings.RankedChoice);
        this.Narrative = ko.validatedObservable(settings.Narrative);
        this.ContactTypeID = ko.validatedObservable(settings.ContactTypeID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Contact = ko.observable();
        this.Category = ko.observable();
        this.Interests = ko.observable();
        this.ContactType = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ContactID != undefined) {
                loaded.ContactID(responseData.ContactID);
            }
            if (responseData.EntryDate != undefined) {
                loaded.EntryDate(responseData.EntryDate);
            }
            if (responseData.CategoryID != undefined) {
                loaded.CategoryID(responseData.CategoryID);
            }
            if (responseData.InterestID != undefined) {
                loaded.InterestID(responseData.InterestID);
            }
            if (responseData.RankedChoice != undefined) {
                loaded.RankedChoice(responseData.RankedChoice);
            }
            if (responseData.Narrative != undefined) {
                loaded.Narrative(responseData.Narrative);
            }
            if (responseData.ContactTypeID != undefined) {
                loaded.ContactTypeID(responseData.ContactTypeID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Contact != null) {
                loaded.Contact(new smapi.community.ContactModel().LoadFromResponse(responseData.Contact));
            }
            if (responseData.Category != null) {
                loaded.Category(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.Category));
            }
            if (responseData.Interests != null) {
                loaded.Interests(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.Interests));
            }
            if (responseData.ContactType != null) {
                loaded.ContactType(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.ContactType));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.ContactInterest', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ContactID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EntryDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.CategoryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.InterestID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RankedChoice.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ContactTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function EventManagementModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.EventManagement', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function EventTypeModel(options) {
        var defaults = {
            ClassType: 0,
            EventManagementID: 0,
            EventTypeDate: null,
            Note: '',
            PersonID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.EventManagementID = ko.validatedObservable(settings.EventManagementID);
        this.EventTypeDate = ko.validatedObservable(settings.EventTypeDate);
        this.Note = ko.validatedObservable(settings.Note);
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        this.EventManagement = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.EventManagementID != undefined) {
                loaded.EventManagementID(responseData.EventManagementID);
            }
            if (responseData.EventTypeDate != undefined) {
                loaded.EventTypeDate(responseData.EventTypeDate);
            }
            if (responseData.Note != undefined) {
                loaded.Note(responseData.Note);
            }
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.EventManagement != null) {
                loaded.EventManagement(new smapi.community.EventManagementModel().LoadFromResponse(responseData.EventManagement));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.EventType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EventManagementID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EventTypeDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.Note.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ContactGreetingTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            FormatRuleSetGID: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.FormatRuleSetGID = ko.validatedObservable(settings.FormatRuleSetGID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.FormatRuleSetGID != undefined) {
                loaded.FormatRuleSetGID(responseData.FormatRuleSetGID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.ContactGreetingType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.FormatRuleSetGID.extend({
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ContactPronounSetModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            FamiliarPersonal: '',
            FormalPersonal: '',
            FamiliarImpersonal: '',
            FormalImpersonal: '',
            FamiliarPosessive: '',
            FormalPosessive: '',
            FamiliarImpersonalPosessive: '',
            FormalImpersonalPosessive: '',
            FamiliarReflexive: '',
            FormalReflexive: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.FamiliarPersonal = ko.validatedObservable(settings.FamiliarPersonal);
        this.FormalPersonal = ko.validatedObservable(settings.FormalPersonal);
        this.FamiliarImpersonal = ko.validatedObservable(settings.FamiliarImpersonal);
        this.FormalImpersonal = ko.validatedObservable(settings.FormalImpersonal);
        this.FamiliarPosessive = ko.validatedObservable(settings.FamiliarPosessive);
        this.FormalPosessive = ko.validatedObservable(settings.FormalPosessive);
        this.FamiliarImpersonalPosessive = ko.validatedObservable(settings.FamiliarImpersonalPosessive);
        this.FormalImpersonalPosessive = ko.validatedObservable(settings.FormalImpersonalPosessive);
        this.FamiliarReflexive = ko.validatedObservable(settings.FamiliarReflexive);
        this.FormalReflexive = ko.validatedObservable(settings.FormalReflexive);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.FamiliarPersonal != undefined) {
                loaded.FamiliarPersonal(responseData.FamiliarPersonal);
            }
            if (responseData.FormalPersonal != undefined) {
                loaded.FormalPersonal(responseData.FormalPersonal);
            }
            if (responseData.FamiliarImpersonal != undefined) {
                loaded.FamiliarImpersonal(responseData.FamiliarImpersonal);
            }
            if (responseData.FormalImpersonal != undefined) {
                loaded.FormalImpersonal(responseData.FormalImpersonal);
            }
            if (responseData.FamiliarPosessive != undefined) {
                loaded.FamiliarPosessive(responseData.FamiliarPosessive);
            }
            if (responseData.FormalPosessive != undefined) {
                loaded.FormalPosessive(responseData.FormalPosessive);
            }
            if (responseData.FamiliarImpersonalPosessive != undefined) {
                loaded.FamiliarImpersonalPosessive(responseData.FamiliarImpersonalPosessive);
            }
            if (responseData.FormalImpersonalPosessive != undefined) {
                loaded.FormalImpersonalPosessive(responseData.FormalImpersonalPosessive);
            }
            if (responseData.FamiliarReflexive != undefined) {
                loaded.FamiliarReflexive(responseData.FamiliarReflexive);
            }
            if (responseData.FormalReflexive != undefined) {
                loaded.FormalReflexive(responseData.FormalReflexive);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.ContactPronounSet', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.FamiliarPersonal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 15,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '15')
            }
        });
        this.FormalPersonal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 15,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '15')
            }
        });
        this.FamiliarImpersonal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 15,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '15')
            }
        });
        this.FormalImpersonal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 15,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '15')
            }
        });
        this.FamiliarPosessive.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 15,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '15')
            }
        });
        this.FormalPosessive.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 15,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '15')
            }
        });
        this.FamiliarImpersonalPosessive.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 15,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '15')
            }
        });
        this.FormalImpersonalPosessive.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 15,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '15')
            }
        });
        this.FamiliarReflexive.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 15,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '15')
            }
        });
        this.FormalReflexive.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 15,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '15')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ContactGreetingModel(options) {
        var defaults = {
            ContactID: 0,
            ContactGreetingTypeID: null,
            Greeting: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ContactID = ko.validatedObservable(settings.ContactID);
        this.ContactGreetingTypeID = ko.validatedObservable(settings.ContactGreetingTypeID);
        this.Greeting = ko.validatedObservable(settings.Greeting);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Contact = ko.observable();
        this.ContactGreetingType = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ContactID != undefined) {
                loaded.ContactID(responseData.ContactID);
            }
            if (responseData.ContactGreetingTypeID != undefined) {
                loaded.ContactGreetingTypeID(responseData.ContactGreetingTypeID);
            }
            if (responseData.Greeting != undefined) {
                loaded.Greeting(responseData.Greeting);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Contact != null) {
                loaded.Contact(new smapi.community.ContactModel().LoadFromResponse(responseData.Contact));
            }
            if (responseData.ContactGreetingType != null) {
                loaded.ContactGreetingType(new smapi.community.ContactGreetingTypeModel().LoadFromResponse(responseData.ContactGreetingType));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.ContactGreeting', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ContactID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ContactGreetingTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Greeting.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function MailingAddressTemplateModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            DefaultSiteTemplate: false,
            ShowForAllCountries: false,
            CapitalizeName: false,
            UseNamePrefix: false,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.DefaultSiteTemplate = ko.validatedObservable(settings.DefaultSiteTemplate);
        this.ShowForAllCountries = ko.validatedObservable(settings.ShowForAllCountries);
        this.CapitalizeName = ko.validatedObservable(settings.CapitalizeName);
        this.UseNamePrefix = ko.validatedObservable(settings.UseNamePrefix);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Countries = ko.observableArray([]);
        this.Fields = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.DefaultSiteTemplate != undefined) {
                loaded.DefaultSiteTemplate(responseData.DefaultSiteTemplate);
            }
            if (responseData.ShowForAllCountries != undefined) {
                loaded.ShowForAllCountries(responseData.ShowForAllCountries);
            }
            if (responseData.CapitalizeName != undefined) {
                loaded.CapitalizeName(responseData.CapitalizeName);
            }
            if (responseData.UseNamePrefix != undefined) {
                loaded.UseNamePrefix(responseData.UseNamePrefix);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Countries != null && responseData.Countries.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Countries.length; i++) {
                    items.push(new smapi.community.MailingAddressTemplateCountryModel().LoadFromResponse(responseData.Countries[i]));
                }
                loaded.Countries(items);
            }
            if (responseData.Fields != null && responseData.Fields.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Fields.length; i++) {
                    items.push(new smapi.community.MailingAddressTemplateFieldModel().LoadFromResponse(responseData.Fields[i]));
                }
                loaded.Fields(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.MailingAddressTemplate', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function MailingAddressTemplateCountryModel(options) {
        var defaults = {
            DefaultCountryTemplate: false,
            CountryID: null,
            MailingAddressTemplateID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.DefaultCountryTemplate = ko.validatedObservable(settings.DefaultCountryTemplate);
        this.CountryID = ko.validatedObservable(settings.CountryID);
        this.MailingAddressTemplateID = ko.validatedObservable(settings.MailingAddressTemplateID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Country = ko.observable();
        this.MailingAddressTemplate = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.DefaultCountryTemplate != undefined) {
                loaded.DefaultCountryTemplate(responseData.DefaultCountryTemplate);
            }
            if (responseData.CountryID != undefined) {
                loaded.CountryID(responseData.CountryID);
            }
            if (responseData.MailingAddressTemplateID != undefined) {
                loaded.MailingAddressTemplateID(responseData.MailingAddressTemplateID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Country != null) {
                loaded.Country(new smapi.community.CountryModel().LoadFromResponse(responseData.Country));
            }
            if (responseData.MailingAddressTemplate != null) {
                loaded.MailingAddressTemplate(new smapi.community.MailingAddressTemplateModel().LoadFromResponse(responseData.MailingAddressTemplate));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.MailingAddressTemplateCountry', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.CountryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MailingAddressTemplateID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function MailingAddressTemplateFieldModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            LabelResourceKey: '',
            MailingLabelRowOrdinal: 0,
            MailingLabelColumnOrdinal: 0,
            TemplateFormRowOrdinal: 0,
            UseInMailingLabel: false,
            CapitalizeInMailingLabel: false,
            AbbreviateInMailingLabel: false,
            MailingAddressTemplateID: null,
            IsRequired: false,
            CustomCSSClass: '',
            FieldTypeID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.LabelResourceKey = ko.validatedObservable(settings.LabelResourceKey);
        this.MailingLabelRowOrdinal = ko.validatedObservable(settings.MailingLabelRowOrdinal);
        this.MailingLabelColumnOrdinal = ko.validatedObservable(settings.MailingLabelColumnOrdinal);
        this.TemplateFormRowOrdinal = ko.validatedObservable(settings.TemplateFormRowOrdinal);
        this.UseInMailingLabel = ko.validatedObservable(settings.UseInMailingLabel);
        this.CapitalizeInMailingLabel = ko.validatedObservable(settings.CapitalizeInMailingLabel);
        this.AbbreviateInMailingLabel = ko.validatedObservable(settings.AbbreviateInMailingLabel);
        this.MailingAddressTemplateID = ko.validatedObservable(settings.MailingAddressTemplateID);
        this.IsRequired = ko.validatedObservable(settings.IsRequired);
        this.CustomCSSClass = ko.validatedObservable(settings.CustomCSSClass);
        this.FieldTypeID = ko.validatedObservable(settings.FieldTypeID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.MailingAddressTemplate = ko.observable();
        this.FieldType = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.LabelResourceKey != undefined) {
                loaded.LabelResourceKey(responseData.LabelResourceKey);
            }
            if (responseData.MailingLabelRowOrdinal != undefined) {
                loaded.MailingLabelRowOrdinal(responseData.MailingLabelRowOrdinal);
            }
            if (responseData.MailingLabelColumnOrdinal != undefined) {
                loaded.MailingLabelColumnOrdinal(responseData.MailingLabelColumnOrdinal);
            }
            if (responseData.TemplateFormRowOrdinal != undefined) {
                loaded.TemplateFormRowOrdinal(responseData.TemplateFormRowOrdinal);
            }
            if (responseData.UseInMailingLabel != undefined) {
                loaded.UseInMailingLabel(responseData.UseInMailingLabel);
            }
            if (responseData.CapitalizeInMailingLabel != undefined) {
                loaded.CapitalizeInMailingLabel(responseData.CapitalizeInMailingLabel);
            }
            if (responseData.AbbreviateInMailingLabel != undefined) {
                loaded.AbbreviateInMailingLabel(responseData.AbbreviateInMailingLabel);
            }
            if (responseData.MailingAddressTemplateID != undefined) {
                loaded.MailingAddressTemplateID(responseData.MailingAddressTemplateID);
            }
            if (responseData.IsRequired != undefined) {
                loaded.IsRequired(responseData.IsRequired);
            }
            if (responseData.CustomCSSClass != undefined) {
                loaded.CustomCSSClass(responseData.CustomCSSClass);
            }
            if (responseData.FieldTypeID != undefined) {
                loaded.FieldTypeID(responseData.FieldTypeID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.MailingAddressTemplate != null) {
                loaded.MailingAddressTemplate(new smapi.community.MailingAddressTemplateModel().LoadFromResponse(responseData.MailingAddressTemplate));
            }
            if (responseData.FieldType != null) {
                loaded.FieldType(new smapi.community.MailingAddressFieldTypeModel().LoadFromResponse(responseData.FieldType));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.MailingAddressTemplateField', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.LabelResourceKey.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.MailingLabelRowOrdinal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MailingLabelColumnOrdinal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TemplateFormRowOrdinal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MailingAddressTemplateID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CustomCSSClass.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.FieldTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function MailingAddressTemplateFieldSeparatorModel(options) {
        var defaults = {
            Value: '',
            Field1ID: null,
            Field2ID: null,
            SeparatorTypeID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Value = ko.validatedObservable(settings.Value);
        this.Field1ID = ko.validatedObservable(settings.Field1ID);
        this.Field2ID = ko.validatedObservable(settings.Field2ID);
        this.SeparatorTypeID = ko.validatedObservable(settings.SeparatorTypeID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Field1 = ko.observable();
        this.Field2 = ko.observable();
        this.SeparatorType = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Value != undefined) {
                loaded.Value(responseData.Value);
            }
            if (responseData.Field1ID != undefined) {
                loaded.Field1ID(responseData.Field1ID);
            }
            if (responseData.Field2ID != undefined) {
                loaded.Field2ID(responseData.Field2ID);
            }
            if (responseData.SeparatorTypeID != undefined) {
                loaded.SeparatorTypeID(responseData.SeparatorTypeID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Field1 != null) {
                loaded.Field1(new smapi.community.MailingAddressTemplateFieldModel().LoadFromResponse(responseData.Field1));
            }
            if (responseData.Field2 != null) {
                loaded.Field2(new smapi.community.MailingAddressTemplateFieldModel().LoadFromResponse(responseData.Field2));
            }
            if (responseData.SeparatorType != null) {
                loaded.SeparatorType(new smapi.community.MailingAddressTemplateFieldSeparatorTypeModel().LoadFromResponse(responseData.SeparatorType));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.MailingAddressTemplateFieldSeparator', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Value.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 10,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '10')
            }
        });
        this.Field1ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Field2ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SeparatorTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function StreetSuffixModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            CountryID: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.CountryID = ko.validatedObservable(settings.CountryID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Country = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.CountryID != undefined) {
                loaded.CountryID(responseData.CountryID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Country != null) {
                loaded.Country(new smapi.community.CountryModel().LoadFromResponse(responseData.Country));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.StreetSuffix', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.CountryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function MailingAddressFieldTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            BoundFieldName: '',
            SystemProtected: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.BoundFieldName = ko.validatedObservable(settings.BoundFieldName);
        this.SystemProtected = ko.validatedObservable(settings.SystemProtected);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.BoundFieldName != undefined) {
                loaded.BoundFieldName(responseData.BoundFieldName);
            }
            if (responseData.SystemProtected != undefined) {
                loaded.SystemProtected(responseData.SystemProtected);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.MailingAddressFieldType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.BoundFieldName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function MailingAddressTemplateFieldSeparatorTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.MailingAddressTemplateFieldSeparatorType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function HoldCategoryLocationModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Modules = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Modules != null && responseData.Modules.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Modules.length; i++) {
                    items.push(new smapi.entities.ModuleModel().LoadFromResponse(responseData.Modules[i]));
                }
                loaded.Modules(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.HoldCategoryLocation', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function HoldCategoryModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            StopRegistration: false,
            StopOnlineRegistration: false,
            StopTranscript: false,
            StopGradeCard: false,
            StopStatement: false,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.StopRegistration = ko.validatedObservable(settings.StopRegistration);
        this.StopOnlineRegistration = ko.validatedObservable(settings.StopOnlineRegistration);
        this.StopTranscript = ko.validatedObservable(settings.StopTranscript);
        this.StopGradeCard = ko.validatedObservable(settings.StopGradeCard);
        this.StopStatement = ko.validatedObservable(settings.StopStatement);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.HoldLocation = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.StopRegistration != undefined) {
                loaded.StopRegistration(responseData.StopRegistration);
            }
            if (responseData.StopOnlineRegistration != undefined) {
                loaded.StopOnlineRegistration(responseData.StopOnlineRegistration);
            }
            if (responseData.StopTranscript != undefined) {
                loaded.StopTranscript(responseData.StopTranscript);
            }
            if (responseData.StopGradeCard != undefined) {
                loaded.StopGradeCard(responseData.StopGradeCard);
            }
            if (responseData.StopStatement != undefined) {
                loaded.StopStatement(responseData.StopStatement);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.HoldLocation != null && responseData.HoldLocation.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.HoldLocation.length; i++) {
                    items.push(new smapi.community.HoldCategoryLocationModel().LoadFromResponse(responseData.HoldLocation[i]));
                }
                loaded.HoldLocation(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.HoldCategory', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function HoldStatusModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            ISOCode: '',
            ExternalCode: '',
            SortOrder: 0,
            BusinessMeaningName: '',
            SystemProtected: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.ISOCode = ko.validatedObservable(settings.ISOCode);
        this.ExternalCode = ko.validatedObservable(settings.ExternalCode);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.SystemProtected = ko.validatedObservable(settings.SystemProtected);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.ISOCode != undefined) {
                loaded.ISOCode(responseData.ISOCode);
            }
            if (responseData.ExternalCode != undefined) {
                loaded.ExternalCode(responseData.ExternalCode);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.SystemProtected != undefined) {
                loaded.SystemProtected(responseData.SystemProtected);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.HoldStatus', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ISOCode.extend({
            maxLength: {
                params: 10,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '10')
            }
        });
        this.ExternalCode.extend({
            maxLength: {
                params: 10,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '10')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ContactHoldModel(options) {
        var defaults = {
            ContactID: 0,
            HoldCategoryID: 0,
            HoldStatusID: 0,
            StartDate: null,
            EndDate: null,
            StopRegistration: false,
            StopOnlineRegistration: false,
            StopTranscript: false,
            StopGradeCard: false,
            StopStatement: false,
            Description: '',
            VoidReason: '',
            VoidUserID: null,
            VoidDate: null,
            AlertsID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ContactID = ko.validatedObservable(settings.ContactID);
        this.HoldCategoryID = ko.validatedObservable(settings.HoldCategoryID);
        this.HoldStatusID = ko.validatedObservable(settings.HoldStatusID);
        this.StartDate = ko.validatedObservable(settings.StartDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.StopRegistration = ko.validatedObservable(settings.StopRegistration);
        this.StopOnlineRegistration = ko.validatedObservable(settings.StopOnlineRegistration);
        this.StopTranscript = ko.validatedObservable(settings.StopTranscript);
        this.StopGradeCard = ko.validatedObservable(settings.StopGradeCard);
        this.StopStatement = ko.validatedObservable(settings.StopStatement);
        this.Description = ko.validatedObservable(settings.Description);
        this.VoidReason = ko.validatedObservable(settings.VoidReason);
        this.VoidUserID = ko.validatedObservable(settings.VoidUserID);
        this.VoidDate = ko.validatedObservable(settings.VoidDate);
        this.AlertsID = ko.validatedObservable(settings.AlertsID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Contact = ko.observable();
        this.HoldCategory = ko.observable();
        this.HoldStatus = ko.observable();
        this.VoidUser = ko.observable();
        this.Alert = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ContactID != undefined) {
                loaded.ContactID(responseData.ContactID);
            }
            if (responseData.HoldCategoryID != undefined) {
                loaded.HoldCategoryID(responseData.HoldCategoryID);
            }
            if (responseData.HoldStatusID != undefined) {
                loaded.HoldStatusID(responseData.HoldStatusID);
            }
            if (responseData.StartDate != undefined) {
                loaded.StartDate(responseData.StartDate);
            }
            if (responseData.EndDate != undefined) {
                loaded.EndDate(responseData.EndDate);
            }
            if (responseData.StopRegistration != undefined) {
                loaded.StopRegistration(responseData.StopRegistration);
            }
            if (responseData.StopOnlineRegistration != undefined) {
                loaded.StopOnlineRegistration(responseData.StopOnlineRegistration);
            }
            if (responseData.StopTranscript != undefined) {
                loaded.StopTranscript(responseData.StopTranscript);
            }
            if (responseData.StopGradeCard != undefined) {
                loaded.StopGradeCard(responseData.StopGradeCard);
            }
            if (responseData.StopStatement != undefined) {
                loaded.StopStatement(responseData.StopStatement);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.VoidReason != undefined) {
                loaded.VoidReason(responseData.VoidReason);
            }
            if (responseData.VoidUserID != undefined) {
                loaded.VoidUserID(responseData.VoidUserID);
            }
            if (responseData.VoidDate != undefined) {
                loaded.VoidDate(responseData.VoidDate);
            }
            if (responseData.AlertsID != undefined) {
                loaded.AlertsID(responseData.AlertsID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Contact != null) {
                loaded.Contact(new smapi.community.ContactModel().LoadFromResponse(responseData.Contact));
            }
            if (responseData.HoldCategory != null) {
                loaded.HoldCategory(new smapi.community.HoldCategoryModel().LoadFromResponse(responseData.HoldCategory));
            }
            if (responseData.HoldStatus != null) {
                loaded.HoldStatus(new smapi.community.HoldStatusModel().LoadFromResponse(responseData.HoldStatus));
            }
            if (responseData.VoidUser != null) {
                loaded.VoidUser(new smapi.entities.UserModel().LoadFromResponse(responseData.VoidUser));
            }
            if (responseData.Alert != null) {
                loaded.Alert(new smapi.community.ContactAlertModel().LoadFromResponse(responseData.Alert));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.ContactHold', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ContactID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.HoldCategoryID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.HoldStatusID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StartDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.VoidReason.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.VoidUserID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.VoidDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AlertsID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ContactAlertModel(options) {
        var defaults = {
            ContactID: 0,
            StartDate: null,
            EndDate: null,
            Name: '',
            Description: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ContactID = ko.validatedObservable(settings.ContactID);
        this.StartDate = ko.validatedObservable(settings.StartDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Contact = ko.observable();
        this.Holds = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ContactID != undefined) {
                loaded.ContactID(responseData.ContactID);
            }
            if (responseData.StartDate != undefined) {
                loaded.StartDate(responseData.StartDate);
            }
            if (responseData.EndDate != undefined) {
                loaded.EndDate(responseData.EndDate);
            }
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Contact != null) {
                loaded.Contact(new smapi.community.ContactModel().LoadFromResponse(responseData.Contact));
            }
            if (responseData.Holds != null && responseData.Holds.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Holds.length; i++) {
                    items.push(new smapi.community.ContactHoldModel().LoadFromResponse(responseData.Holds[i]));
                }
                loaded.Holds(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.ContactAlert', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ContactID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StartDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function UserContactNoteModel(options) {
        var defaults = {
            ContactID: 0,
            NoteDate: null,
            Note: '',
            Starred: false,
            CopyToContactNote: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ContactID = ko.validatedObservable(settings.ContactID);
        this.NoteDate = ko.validatedObservable(settings.NoteDate);
        this.Note = ko.validatedObservable(settings.Note);
        this.Starred = ko.validatedObservable(settings.Starred);
        this.CopyToContactNote = ko.validatedObservable(settings.CopyToContactNote);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Contact = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ContactID != undefined) {
                loaded.ContactID(responseData.ContactID);
            }
            if (responseData.NoteDate != undefined) {
                loaded.NoteDate(responseData.NoteDate);
            }
            if (responseData.Note != undefined) {
                loaded.Note(responseData.Note);
            }
            if (responseData.Starred != undefined) {
                loaded.Starred(responseData.Starred);
            }
            if (responseData.CopyToContactNote != undefined) {
                loaded.CopyToContactNote(responseData.CopyToContactNote);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Contact != null) {
                loaded.Contact(new smapi.community.ContactModel().LoadFromResponse(responseData.Contact));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.UserContactNote', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ContactID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.NoteDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.Note.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CRMRankModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.CRMRank', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ContactModel(options) {
        var defaults = {
            ContactType: null,
            DisplayName: '',
            ShowOnDirectory: false,
            DoNotContact: false,
            ContactPronounSetID: null,
            DefaultLocaleID: null,
            CRMRankID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ContactType = ko.validatedObservable(settings.ContactType);
        this.DisplayName = ko.validatedObservable(settings.DisplayName);
        this.ShowOnDirectory = ko.validatedObservable(settings.ShowOnDirectory);
        this.DoNotContact = ko.validatedObservable(settings.DoNotContact);
        this.ContactPronounSetID = ko.validatedObservable(settings.ContactPronounSetID);
        this.DefaultLocaleID = ko.validatedObservable(settings.DefaultLocaleID);
        this.CRMRankID = ko.validatedObservable(settings.CRMRankID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.CRMRank = ko.observable();
        this.DefaultLocale = ko.observable();
        this.Addresses = ko.observableArray([]);
        this.PhoneNumbers = ko.observableArray([]);
        this.ElectronicAddresses = ko.observableArray([]);
        this.Pictures = ko.observableArray([]);
        this.Notes = ko.observableArray([]);
        this.Interests = ko.observableArray([]);
        this.Greetings = ko.observableArray([]);
        this.MyARelations = ko.observableArray([]);
        this.MyZRelations = ko.observableArray([]);
        this.Holds = ko.observableArray([]);
        this.Alerts = ko.observableArray([]);
        this.UserNotes = ko.observableArray([]);
        this.DocumentRepository = ko.observableArray([]);
        this.ContactPronounSet = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ContactType != undefined) {
                loaded.ContactType(responseData.ContactType);
            }
            if (responseData.DisplayName != undefined) {
                loaded.DisplayName(responseData.DisplayName);
            }
            if (responseData.ShowOnDirectory != undefined) {
                loaded.ShowOnDirectory(responseData.ShowOnDirectory);
            }
            if (responseData.DoNotContact != undefined) {
                loaded.DoNotContact(responseData.DoNotContact);
            }
            if (responseData.ContactPronounSetID != undefined) {
                loaded.ContactPronounSetID(responseData.ContactPronounSetID);
            }
            if (responseData.DefaultLocaleID != undefined) {
                loaded.DefaultLocaleID(responseData.DefaultLocaleID);
            }
            if (responseData.CRMRankID != undefined) {
                loaded.CRMRankID(responseData.CRMRankID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.CRMRank != null) {
                loaded.CRMRank(new smapi.community.CRMRankModel().LoadFromResponse(responseData.CRMRank));
            }
            if (responseData.DefaultLocale != null) {
                loaded.DefaultLocale(new smapi.entities.LocaleModel().LoadFromResponse(responseData.DefaultLocale));
            }
            if (responseData.Addresses != null && responseData.Addresses.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Addresses.length; i++) {
                    items.push(new smapi.community.MailingAddressModel().LoadFromResponse(responseData.Addresses[i]));
                }
                loaded.Addresses(items);
            }
            if (responseData.PhoneNumbers != null && responseData.PhoneNumbers.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.PhoneNumbers.length; i++) {
                    items.push(new smapi.community.PhoneNumberModel().LoadFromResponse(responseData.PhoneNumbers[i]));
                }
                loaded.PhoneNumbers(items);
            }
            if (responseData.ElectronicAddresses != null && responseData.ElectronicAddresses.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ElectronicAddresses.length; i++) {
                    items.push(new smapi.community.ElectronicAddressModel().LoadFromResponse(responseData.ElectronicAddresses[i]));
                }
                loaded.ElectronicAddresses(items);
            }
            if (responseData.Pictures != null && responseData.Pictures.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Pictures.length; i++) {
                    items.push(new smapi.community.ContactPictureModel().LoadFromResponse(responseData.Pictures[i]));
                }
                loaded.Pictures(items);
            }
            if (responseData.Notes != null && responseData.Notes.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Notes.length; i++) {
                    items.push(new smapi.community.ContactNoteModel().LoadFromResponse(responseData.Notes[i]));
                }
                loaded.Notes(items);
            }
            if (responseData.Interests != null && responseData.Interests.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Interests.length; i++) {
                    items.push(new smapi.community.ContactInterestModel().LoadFromResponse(responseData.Interests[i]));
                }
                loaded.Interests(items);
            }
            if (responseData.Greetings != null && responseData.Greetings.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Greetings.length; i++) {
                    items.push(new smapi.community.ContactGreetingModel().LoadFromResponse(responseData.Greetings[i]));
                }
                loaded.Greetings(items);
            }
            if (responseData.MyARelations != null && responseData.MyARelations.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.MyARelations.length; i++) {
                    items.push(new smapi.community.ContactRelationshipModel().LoadFromResponse(responseData.MyARelations[i]));
                }
                loaded.MyARelations(items);
            }
            if (responseData.MyZRelations != null && responseData.MyZRelations.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.MyZRelations.length; i++) {
                    items.push(new smapi.community.ContactRelationshipModel().LoadFromResponse(responseData.MyZRelations[i]));
                }
                loaded.MyZRelations(items);
            }
            if (responseData.Holds != null && responseData.Holds.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Holds.length; i++) {
                    items.push(new smapi.community.ContactHoldModel().LoadFromResponse(responseData.Holds[i]));
                }
                loaded.Holds(items);
            }
            if (responseData.Alerts != null && responseData.Alerts.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Alerts.length; i++) {
                    items.push(new smapi.community.ContactAlertModel().LoadFromResponse(responseData.Alerts[i]));
                }
                loaded.Alerts(items);
            }
            if (responseData.UserNotes != null && responseData.UserNotes.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.UserNotes.length; i++) {
                    items.push(new smapi.community.UserContactNoteModel().LoadFromResponse(responseData.UserNotes[i]));
                }
                loaded.UserNotes(items);
            }
            if (responseData.DocumentRepository != null && responseData.DocumentRepository.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.DocumentRepository.length; i++) {
                    items.push(new smapi.community.DocumentRepositoryModel().LoadFromResponse(responseData.DocumentRepository[i]));
                }
                loaded.DocumentRepository(items);
            }
            if (responseData.ContactPronounSet != null) {
                loaded.ContactPronounSet(new smapi.community.ContactPronounSetModel().LoadFromResponse(responseData.ContactPronounSet));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.Contact', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ContactType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.DisplayName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.ContactPronounSetID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DefaultLocaleID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CRMRankID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PersonPreviousModel(options) {
        var defaults = {
            PersonID: null,
            CategoryID: null,
            SalutationID: null,
            GivenName: '',
            MiddleName: '',
            Surname: '',
            SuffixID: null,
            GenderID: null,
            DateOfChange: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.CategoryID = ko.validatedObservable(settings.CategoryID);
        this.SalutationID = ko.validatedObservable(settings.SalutationID);
        this.GivenName = ko.validatedObservable(settings.GivenName);
        this.MiddleName = ko.validatedObservable(settings.MiddleName);
        this.Surname = ko.validatedObservable(settings.Surname);
        this.SuffixID = ko.validatedObservable(settings.SuffixID);
        this.GenderID = ko.validatedObservable(settings.GenderID);
        this.DateOfChange = ko.validatedObservable(settings.DateOfChange);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        this.Category = ko.observable();
        this.Salutation = ko.observable();
        this.Suffix = ko.observable();
        this.Gender = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.CategoryID != undefined) {
                loaded.CategoryID(responseData.CategoryID);
            }
            if (responseData.SalutationID != undefined) {
                loaded.SalutationID(responseData.SalutationID);
            }
            if (responseData.GivenName != undefined) {
                loaded.GivenName(responseData.GivenName);
            }
            if (responseData.MiddleName != undefined) {
                loaded.MiddleName(responseData.MiddleName);
            }
            if (responseData.Surname != undefined) {
                loaded.Surname(responseData.Surname);
            }
            if (responseData.SuffixID != undefined) {
                loaded.SuffixID(responseData.SuffixID);
            }
            if (responseData.GenderID != undefined) {
                loaded.GenderID(responseData.GenderID);
            }
            if (responseData.DateOfChange != undefined) {
                loaded.DateOfChange(responseData.DateOfChange);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.Category != null) {
                loaded.Category(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.Category));
            }
            if (responseData.Salutation != null) {
                loaded.Salutation(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.Salutation));
            }
            if (responseData.Suffix != null) {
                loaded.Suffix(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.Suffix));
            }
            if (responseData.Gender != null) {
                loaded.Gender(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.Gender));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.PersonPrevious', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CategoryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SalutationID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GivenName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.MiddleName.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Surname.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.SuffixID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GenderID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DateOfChange.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ContactPictureModel(options) {
        var defaults = {
            ContactID: 0,
            PictureTypeID: null,
            MIMEType: '',
            FileName: '',
            FileData: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ContactID = ko.validatedObservable(settings.ContactID);
        this.PictureTypeID = ko.validatedObservable(settings.PictureTypeID);
        this.MIMEType = ko.validatedObservable(settings.MIMEType);
        this.FileName = ko.validatedObservable(settings.FileName);
        this.FileData = ko.validatedObservable(settings.FileData);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Contact = ko.observable();
        this.PictureType = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ContactID != undefined) {
                loaded.ContactID(responseData.ContactID);
            }
            if (responseData.PictureTypeID != undefined) {
                loaded.PictureTypeID(responseData.PictureTypeID);
            }
            if (responseData.MIMEType != undefined) {
                loaded.MIMEType(responseData.MIMEType);
            }
            if (responseData.FileName != undefined) {
                loaded.FileName(responseData.FileName);
            }
            if (responseData.FileData != undefined) {
                loaded.FileData(responseData.FileData);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Contact != null) {
                loaded.Contact(new smapi.community.ContactModel().LoadFromResponse(responseData.Contact));
            }
            if (responseData.PictureType != null) {
                loaded.PictureType(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.PictureType));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.ContactPicture', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ContactID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PictureTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MIMEType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 250,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '250')
            }
        });
        this.FileName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function EmergencyContactModel(options) {
        var defaults = {
            PersonID: 0,
            EmergencyContactTypeID: null,
            EmergencyContactName: '',
            Number: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.EmergencyContactTypeID = ko.validatedObservable(settings.EmergencyContactTypeID);
        this.EmergencyContactName = ko.validatedObservable(settings.EmergencyContactName);
        this.Number = ko.validatedObservable(settings.Number);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        this.EmergencyContactType = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.EmergencyContactTypeID != undefined) {
                loaded.EmergencyContactTypeID(responseData.EmergencyContactTypeID);
            }
            if (responseData.EmergencyContactName != undefined) {
                loaded.EmergencyContactName(responseData.EmergencyContactName);
            }
            if (responseData.Number != undefined) {
                loaded.Number(responseData.Number);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.EmergencyContactType != null) {
                loaded.EmergencyContactType(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.EmergencyContactType));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.EmergencyContact', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EmergencyContactTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EmergencyContactName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Number.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function FavoriteGroupModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.FavoriteGroup', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 250,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '250')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ContactFavoriteModel(options) {
        var defaults = {
            PersonID: 0,
            ContactID: 0,
            FavoriteGroupID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.ContactID = ko.validatedObservable(settings.ContactID);
        this.FavoriteGroupID = ko.validatedObservable(settings.FavoriteGroupID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.FavoriteGroup = ko.observable();
        this.Person = ko.observable();
        this.Contact = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.ContactID != undefined) {
                loaded.ContactID(responseData.ContactID);
            }
            if (responseData.FavoriteGroupID != undefined) {
                loaded.FavoriteGroupID(responseData.FavoriteGroupID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.FavoriteGroup != null) {
                loaded.FavoriteGroup(new smapi.community.FavoriteGroupModel().LoadFromResponse(responseData.FavoriteGroup));
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.Contact != null) {
                loaded.Contact(new smapi.community.ContactModel().LoadFromResponse(responseData.Contact));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.ContactFavorite', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ContactID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.FavoriteGroupID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PersonIdentifierTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            BusinessMeaningName: '',
            IsEditDenied: false,
            IsDeleteDenied: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.IsEditDenied = ko.validatedObservable(settings.IsEditDenied);
        this.IsDeleteDenied = ko.validatedObservable(settings.IsDeleteDenied);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.IsEditDenied != undefined) {
                loaded.IsEditDenied(responseData.IsEditDenied);
            }
            if (responseData.IsDeleteDenied != undefined) {
                loaded.IsDeleteDenied(responseData.IsDeleteDenied);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.PersonIdentifierType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function OrganizationIdentifierTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.OrganizationTypes = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.OrganizationTypes != null && responseData.OrganizationTypes.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.OrganizationTypes.length; i++) {
                    items.push(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.OrganizationTypes[i]));
                }
                loaded.OrganizationTypes(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.OrganizationIdentifierType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PersonIdentifierModel(options) {
        var defaults = {
            PersonID: 0,
            Identifier: '',
            IdentifierTypeID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.Identifier = ko.validatedObservable(settings.Identifier);
        this.IdentifierTypeID = ko.validatedObservable(settings.IdentifierTypeID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        this.IdentifierType = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.Identifier != undefined) {
                loaded.Identifier(responseData.Identifier);
            }
            if (responseData.IdentifierTypeID != undefined) {
                loaded.IdentifierTypeID(responseData.IdentifierTypeID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.IdentifierType != null) {
                loaded.IdentifierType(new smapi.community.PersonIdentifierTypeModel().LoadFromResponse(responseData.IdentifierType));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.PersonIdentifier', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Identifier.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.IdentifierTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PersonModel(options) {
        var defaults = {
            Surname: '',
            GivenName: '',
            MiddleName: '',
            PreferredGivenName: '',
            TaxID: '',
            GenderID: null,
            SalutationID: null,
            SuffixID: null,
            BirthDay: 0,
            BirthMonth: 0,
            BirthYear: 0,
            DateOfBirth: null,
            SavedAge: 0,
            DateOfDeath: null,
            Deceased: false,
            AgeCalculatedOn: null,
            LeadTypeID: null,
            ContactType: null,
            DisplayName: '',
            ShowOnDirectory: false,
            DoNotContact: false,
            ContactPronounSetID: null,
            DefaultLocaleID: null,
            CRMRankID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
            SIN: ''
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Surname = ko.validatedObservable(settings.Surname);
        this.GivenName = ko.validatedObservable(settings.GivenName);
        this.MiddleName = ko.validatedObservable(settings.MiddleName);
        this.PreferredGivenName = ko.validatedObservable(settings.PreferredGivenName);
        this.TaxID = ko.validatedObservable(settings.TaxID);
        this.GenderID = ko.validatedObservable(settings.GenderID);
        this.SalutationID = ko.validatedObservable(settings.SalutationID);
        this.SuffixID = ko.validatedObservable(settings.SuffixID);
        this.BirthDay = ko.validatedObservable(settings.BirthDay);
        this.BirthMonth = ko.validatedObservable(settings.BirthMonth);
        this.BirthYear = ko.validatedObservable(settings.BirthYear);
        this.DateOfBirth = ko.validatedObservable(settings.DateOfBirth);
        this.SavedAge = ko.validatedObservable(settings.SavedAge);
        this.DateOfDeath = ko.validatedObservable(settings.DateOfDeath);
        this.Deceased = ko.validatedObservable(settings.Deceased);
        this.AgeCalculatedOn = ko.validatedObservable(settings.AgeCalculatedOn);
        this.LeadTypeID = ko.validatedObservable(settings.LeadTypeID);
        this.ContactType = ko.validatedObservable(settings.ContactType);
        this.DisplayName = ko.validatedObservable(settings.DisplayName);
        this.ShowOnDirectory = ko.validatedObservable(settings.ShowOnDirectory);
        this.DoNotContact = ko.validatedObservable(settings.DoNotContact);
        this.ContactPronounSetID = ko.validatedObservable(settings.ContactPronounSetID);
        this.DefaultLocaleID = ko.validatedObservable(settings.DefaultLocaleID);
        this.CRMRankID = ko.validatedObservable(settings.CRMRankID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        this.SIN = ko.validatedObservable(settings.SIN);

        // Relationships as Observables and ObservableArrays
        this.LeadType = ko.observable();
        this.Previous = ko.observableArray([]);
        this.EmergencyContacts = ko.observableArray([]);
        this.DemographicData = ko.observableArray([]);
        this.Employment = ko.observableArray([]);
        this.AccessibilityNeed = ko.observableArray([]);
        this.ContactFavorites = ko.observableArray([]);
        this.IDs = ko.observableArray(settings.IDs);
        this.EventTypes = ko.observableArray([]);
        this.DepartmentalContacts = ko.observableArray([]);
        this.Gender = ko.observable();
        this.Salutation = ko.observable();
        this.Suffix = ko.observable();
        this.CRMRank = ko.observable();
        this.DefaultLocale = ko.observable();
        this.Addresses = ko.observableArray([]);
        this.PhoneNumbers = ko.observableArray([]);
        this.ElectronicAddresses = ko.observableArray([]);
        this.Pictures = ko.observableArray([]);
        this.Notes = ko.observableArray([]);
        this.Interests = ko.observableArray([]);
        this.Greetings = ko.observableArray([]);
        this.MyARelations = ko.observableArray([]);
        this.MyZRelations = ko.observableArray([]);
        this.Holds = ko.observableArray([]);
        this.Alerts = ko.observableArray([]);
        this.UserNotes = ko.observableArray([]);
        this.DocumentRepository = ko.observableArray([]);
        this.ContactPronounSet = ko.observable();

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Surname != undefined) {
                loaded.Surname(responseData.Surname);
            }
            if (responseData.GivenName != undefined) {
                loaded.GivenName(responseData.GivenName);
            }
            if (responseData.MiddleName != undefined) {
                loaded.MiddleName(responseData.MiddleName);
            }
            if (responseData.PreferredGivenName != undefined) {
                loaded.PreferredGivenName(responseData.PreferredGivenName);
            }
            if (responseData.TaxID != undefined) {
                loaded.TaxID(responseData.TaxID);
            }
            if (responseData.GenderID != undefined) {
                loaded.GenderID(responseData.GenderID);
            }
            if (responseData.SalutationID != undefined) {
                loaded.SalutationID(responseData.SalutationID);
            }
            if (responseData.SuffixID != undefined) {
                loaded.SuffixID(responseData.SuffixID);
            }
            if (responseData.BirthDay != undefined) {
                loaded.BirthDay(responseData.BirthDay);
            }
            if (responseData.BirthMonth != undefined) {
                loaded.BirthMonth(responseData.BirthMonth);
            }
            if (responseData.BirthYear != undefined) {
                loaded.BirthYear(responseData.BirthYear);
            }
            if (responseData.DateOfBirth != undefined) {
                loaded.DateOfBirth(responseData.DateOfBirth);
            }
            if (responseData.SavedAge != undefined) {
                loaded.SavedAge(responseData.SavedAge);
            }
            if (responseData.DateOfDeath != undefined) {
                loaded.DateOfDeath(responseData.DateOfDeath);
            }
            if (responseData.Deceased != undefined) {
                loaded.Deceased(responseData.Deceased);
            }
            if (responseData.AgeCalculatedOn != undefined) {
                loaded.AgeCalculatedOn(responseData.AgeCalculatedOn);
            }
            if (responseData.LeadTypeID != undefined) {
                loaded.LeadTypeID(responseData.LeadTypeID);
            }
            if (responseData.ContactType != undefined) {
                loaded.ContactType(responseData.ContactType);
            }
            if (responseData.DisplayName != undefined) {
                loaded.DisplayName(responseData.DisplayName);
            }
            if (responseData.ShowOnDirectory != undefined) {
                loaded.ShowOnDirectory(responseData.ShowOnDirectory);
            }
            if (responseData.DoNotContact != undefined) {
                loaded.DoNotContact(responseData.DoNotContact);
            }
            if (responseData.ContactPronounSetID != undefined) {
                loaded.ContactPronounSetID(responseData.ContactPronounSetID);
            }
            if (responseData.DefaultLocaleID != undefined) {
                loaded.DefaultLocaleID(responseData.DefaultLocaleID);
            }
            if (responseData.CRMRankID != undefined) {
                loaded.CRMRankID(responseData.CRMRankID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.SIN != undefined) {
                loaded.SIN(responseData.SIN);
            }
            if (responseData.LeadType != null) {
                loaded.LeadType(new smapi.community.LeadTypeModel().LoadFromResponse(responseData.LeadType));
            }
            if (responseData.Previous != null && responseData.Previous.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Previous.length; i++) {
                    items.push(new smapi.community.PersonPreviousModel().LoadFromResponse(responseData.Previous[i]));
                }
                loaded.Previous(items);
            }
            if (responseData.EmergencyContacts != null && responseData.EmergencyContacts.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.EmergencyContacts.length; i++) {
                    items.push(new smapi.community.EmergencyContactModel().LoadFromResponse(responseData.EmergencyContacts[i]));
                }
                loaded.EmergencyContacts(items);
            }
            if (responseData.DemographicData != null && responseData.DemographicData.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.DemographicData.length; i++) {
                    items.push(new smapi.community.DemographicDataModel().LoadFromResponse(responseData.DemographicData[i]));
                }
                loaded.DemographicData(items);
            }
            if (responseData.Employment != null && responseData.Employment.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Employment.length; i++) {
                    items.push(new smapi.community.EmploymentModel().LoadFromResponse(responseData.Employment[i]));
                }
                loaded.Employment(items);
            }
            if (responseData.AccessibilityNeed != null && responseData.AccessibilityNeed.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.AccessibilityNeed.length; i++) {
                    items.push(new smapi.community.AccessibilityNeedModel().LoadFromResponse(responseData.AccessibilityNeed[i]));
                }
                loaded.AccessibilityNeed(items);
            }
            if (responseData.ContactFavorites != null && responseData.ContactFavorites.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ContactFavorites.length; i++) {
                    items.push(new smapi.community.ContactFavoriteModel().LoadFromResponse(responseData.ContactFavorites[i]));
                }
                loaded.ContactFavorites(items);
            }
            if (responseData.IDs != null && responseData.IDs.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.IDs.length; i++) {
                    items.push(new smapi.community.PersonIdentifierModel().LoadFromResponse(responseData.IDs[i]));
                }
                loaded.IDs(items);
            }
            if (responseData.EventTypes != null && responseData.EventTypes.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.EventTypes.length; i++) {
                    items.push(new smapi.community.EventTypeModel().LoadFromResponse(responseData.EventTypes[i]));
                }
                loaded.EventTypes(items);
            }
            if (responseData.DepartmentalContacts != null && responseData.DepartmentalContacts.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.DepartmentalContacts.length; i++) {
                    items.push(new smapi.community.DepartmentalContactModel().LoadFromResponse(responseData.DepartmentalContacts[i]));
                }
                loaded.DepartmentalContacts(items);
            }
            if (responseData.Gender != null) {
                loaded.Gender(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.Gender));
            }
            if (responseData.Salutation != null) {
                loaded.Salutation(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.Salutation));
            }
            if (responseData.Suffix != null) {
                loaded.Suffix(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.Suffix));
            }
            if (responseData.CRMRank != null) {
                loaded.CRMRank(new smapi.community.CRMRankModel().LoadFromResponse(responseData.CRMRank));
            }
            if (responseData.DefaultLocale != null) {
                loaded.DefaultLocale(new smapi.entities.LocaleModel().LoadFromResponse(responseData.DefaultLocale));
            }
            if (responseData.Addresses != null && responseData.Addresses.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Addresses.length; i++) {
                    items.push(new smapi.community.MailingAddressModel().LoadFromResponse(responseData.Addresses[i]));
                }
                loaded.Addresses(items);
            }
            if (responseData.PhoneNumbers != null && responseData.PhoneNumbers.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.PhoneNumbers.length; i++) {
                    items.push(new smapi.community.PhoneNumberModel().LoadFromResponse(responseData.PhoneNumbers[i]));
                }
                loaded.PhoneNumbers(items);
            }
            if (responseData.ElectronicAddresses != null && responseData.ElectronicAddresses.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ElectronicAddresses.length; i++) {
                    items.push(new smapi.community.ElectronicAddressModel().LoadFromResponse(responseData.ElectronicAddresses[i]));
                }
                loaded.ElectronicAddresses(items);
            }
            if (responseData.Pictures != null && responseData.Pictures.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Pictures.length; i++) {
                    items.push(new smapi.community.ContactPictureModel().LoadFromResponse(responseData.Pictures[i]));
                }
                loaded.Pictures(items);
            }
            if (responseData.Notes != null && responseData.Notes.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Notes.length; i++) {
                    items.push(new smapi.community.ContactNoteModel().LoadFromResponse(responseData.Notes[i]));
                }
                loaded.Notes(items);
            }
            if (responseData.Interests != null && responseData.Interests.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Interests.length; i++) {
                    items.push(new smapi.community.ContactInterestModel().LoadFromResponse(responseData.Interests[i]));
                }
                loaded.Interests(items);
            }
            if (responseData.Greetings != null && responseData.Greetings.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Greetings.length; i++) {
                    items.push(new smapi.community.ContactGreetingModel().LoadFromResponse(responseData.Greetings[i]));
                }
                loaded.Greetings(items);
            }
            if (responseData.MyARelations != null && responseData.MyARelations.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.MyARelations.length; i++) {
                    items.push(new smapi.community.ContactRelationshipModel().LoadFromResponse(responseData.MyARelations[i]));
                }
                loaded.MyARelations(items);
            }
            if (responseData.MyZRelations != null && responseData.MyZRelations.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.MyZRelations.length; i++) {
                    items.push(new smapi.community.ContactRelationshipModel().LoadFromResponse(responseData.MyZRelations[i]));
                }
                loaded.MyZRelations(items);
            }
            if (responseData.Holds != null && responseData.Holds.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Holds.length; i++) {
                    items.push(new smapi.community.ContactHoldModel().LoadFromResponse(responseData.Holds[i]));
                }
                loaded.Holds(items);
            }
            if (responseData.Alerts != null && responseData.Alerts.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Alerts.length; i++) {
                    items.push(new smapi.community.ContactAlertModel().LoadFromResponse(responseData.Alerts[i]));
                }
                loaded.Alerts(items);
            }
            if (responseData.UserNotes != null && responseData.UserNotes.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.UserNotes.length; i++) {
                    items.push(new smapi.community.UserContactNoteModel().LoadFromResponse(responseData.UserNotes[i]));
                }
                loaded.UserNotes(items);
            }
            if (responseData.DocumentRepository != null && responseData.DocumentRepository.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.DocumentRepository.length; i++) {
                    items.push(new smapi.community.DocumentRepositoryModel().LoadFromResponse(responseData.DocumentRepository[i]));
                }
                loaded.DocumentRepository(items);
            }
            if (responseData.ContactPronounSet != null) {
                loaded.ContactPronounSet(new smapi.community.ContactPronounSetModel().LoadFromResponse(responseData.ContactPronounSet));
            }
            var matchedPeopleData = {
                defaults : defaults,
                self : self,
                responseData : responseData,
                loaded : loaded
            }
            sm.portal.vm.custom.callCustomization('ResponseHandlingForMatchedPeople', matchedPeopleData);
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.Person', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }

        this.Surname.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.GivenName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.MiddleName.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.PreferredGivenName.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.TaxID.extend({
            pattern: {
                params: /^(\d{3}-|\*\*\*-)(\d{2}-|\*\*-)(\d{4})$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), '###-##-####')
            }, 
            maxLength: {
                params: 15,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '15')
            }
        });
        this.GenderID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SalutationID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SuffixID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BirthDay.extend({
            min: {
                params: -32768,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 32767,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BirthMonth.extend({
            min: {
                params: -32768,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 32767,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BirthYear.extend({
            min: {
                params: -32768,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 32767,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DateOfBirth.extend({
            smLocalDate: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            },
            smDateOfBirth: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.Validate_MustBeProperDateOfBirth_Key)
            }
        });
        this.SavedAge.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DateOfDeath.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AgeCalculatedOn.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.SIN.extend({
            pattern: {
                params: /^(\d{3}|\*\*\*-)(\d{3}|\*\*\*-)(\d{3})$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), '#########')
            },
            maxLength: {
                params: 15,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '15')
            }
        });
        this.LeadTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ContactType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.DisplayName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.ContactPronounSetID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DefaultLocaleID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CRMRankID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function OrganizationIdentifierModel(options) {
        var defaults = {
            OrganizationID: 0,
            Identifier: '',
            IdentifierTypeID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.OrganizationID = ko.validatedObservable(settings.OrganizationID);
        this.Identifier = ko.validatedObservable(settings.Identifier);
        this.IdentifierTypeID = ko.validatedObservable(settings.IdentifierTypeID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Organization = ko.observable();
        this.IdentifierType = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.OrganizationID != undefined) {
                loaded.OrganizationID(responseData.OrganizationID);
            }
            if (responseData.Identifier != undefined) {
                loaded.Identifier(responseData.Identifier);
            }
            if (responseData.IdentifierTypeID != undefined) {
                loaded.IdentifierTypeID(responseData.IdentifierTypeID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Organization != null) {
                loaded.Organization(new smapi.community.OrganizationModel().LoadFromResponse(responseData.Organization));
            }
            if (responseData.IdentifierType != null) {
                loaded.IdentifierType(new smapi.community.OrganizationIdentifierTypeModel().LoadFromResponse(responseData.IdentifierType));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.OrganizationIdentifier', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.OrganizationID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Identifier.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.IdentifierTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function OrganizationModel(options) {
        var defaults = {
            Description: '',
            LeadTypeID: null,
            ContactType: null,
            DisplayName: '',
            ShowOnDirectory: false,
            DoNotContact: false,
            ContactPronounSetID: null,
            DefaultLocaleID: null,
            CRMRankID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Description = ko.validatedObservable(settings.Description);
        this.LeadTypeID = ko.validatedObservable(settings.LeadTypeID);
        this.ContactType = ko.validatedObservable(settings.ContactType);
        this.DisplayName = ko.validatedObservable(settings.DisplayName);
        this.ShowOnDirectory = ko.validatedObservable(settings.ShowOnDirectory);
        this.DoNotContact = ko.validatedObservable(settings.DoNotContact);
        this.ContactPronounSetID = ko.validatedObservable(settings.ContactPronounSetID);
        this.DefaultLocaleID = ko.validatedObservable(settings.DefaultLocaleID);
        this.CRMRankID = ko.validatedObservable(settings.CRMRankID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.IDs = ko.observableArray([]);
        this.LeadType = ko.observable();
        this.DepartmentalContacts = ko.observableArray([]);
        this.OrganizationContracts = ko.observableArray([]);
        this.OrganizationTypes = ko.observableArray([]);
        this.CRMRank = ko.observable();
        this.DefaultLocale = ko.observable();
        this.Addresses = ko.observableArray([]);
        this.PhoneNumbers = ko.observableArray([]);
        this.ElectronicAddresses = ko.observableArray([]);
        this.Pictures = ko.observableArray([]);
        this.Notes = ko.observableArray([]);
        this.Interests = ko.observableArray([]);
        this.Greetings = ko.observableArray([]);
        this.MyARelations = ko.observableArray([]);
        this.MyZRelations = ko.observableArray([]);
        this.Holds = ko.observableArray([]);
        this.Alerts = ko.observableArray([]);
        this.UserNotes = ko.observableArray([]);
        this.DocumentRepository = ko.observableArray([]);
        this.ContactPronounSet = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.LeadTypeID != undefined) {
                loaded.LeadTypeID(responseData.LeadTypeID);
            }
            if (responseData.ContactType != undefined) {
                loaded.ContactType(responseData.ContactType);
            }
            if (responseData.DisplayName != undefined) {
                loaded.DisplayName(responseData.DisplayName);
            }
            if (responseData.ShowOnDirectory != undefined) {
                loaded.ShowOnDirectory(responseData.ShowOnDirectory);
            }
            if (responseData.DoNotContact != undefined) {
                loaded.DoNotContact(responseData.DoNotContact);
            }
            if (responseData.ContactPronounSetID != undefined) {
                loaded.ContactPronounSetID(responseData.ContactPronounSetID);
            }
            if (responseData.DefaultLocaleID != undefined) {
                loaded.DefaultLocaleID(responseData.DefaultLocaleID);
            }
            if (responseData.CRMRankID != undefined) {
                loaded.CRMRankID(responseData.CRMRankID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.IDs != null && responseData.IDs.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.IDs.length; i++) {
                    items.push(new smapi.community.OrganizationIdentifierModel().LoadFromResponse(responseData.IDs[i]));
                }
                loaded.IDs(items);
            }
            if (responseData.LeadType != null) {
                loaded.LeadType(new smapi.community.LeadTypeModel().LoadFromResponse(responseData.LeadType));
            }
            if (responseData.DepartmentalContacts != null && responseData.DepartmentalContacts.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.DepartmentalContacts.length; i++) {
                    items.push(new smapi.community.DepartmentalContactModel().LoadFromResponse(responseData.DepartmentalContacts[i]));
                }
                loaded.DepartmentalContacts(items);
            }
            if (responseData.OrganizationContracts != null && responseData.OrganizationContracts.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.OrganizationContracts.length; i++) {
                    items.push(new smapi.community.ContractDocumentModel().LoadFromResponse(responseData.OrganizationContracts[i]));
                }
                loaded.OrganizationContracts(items);
            }
            if (responseData.OrganizationTypes != null && responseData.OrganizationTypes.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.OrganizationTypes.length; i++) {
                    items.push(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.OrganizationTypes[i]));
                }
                loaded.OrganizationTypes(items);
            }
            if (responseData.CRMRank != null) {
                loaded.CRMRank(new smapi.community.CRMRankModel().LoadFromResponse(responseData.CRMRank));
            }
            if (responseData.DefaultLocale != null) {
                loaded.DefaultLocale(new smapi.entities.LocaleModel().LoadFromResponse(responseData.DefaultLocale));
            }
            if (responseData.Addresses != null && responseData.Addresses.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Addresses.length; i++) {
                    items.push(new smapi.community.MailingAddressModel().LoadFromResponse(responseData.Addresses[i]));
                }
                loaded.Addresses(items);
            }
            if (responseData.PhoneNumbers != null && responseData.PhoneNumbers.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.PhoneNumbers.length; i++) {
                    items.push(new smapi.community.PhoneNumberModel().LoadFromResponse(responseData.PhoneNumbers[i]));
                }
                loaded.PhoneNumbers(items);
            }
            if (responseData.ElectronicAddresses != null && responseData.ElectronicAddresses.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ElectronicAddresses.length; i++) {
                    items.push(new smapi.community.ElectronicAddressModel().LoadFromResponse(responseData.ElectronicAddresses[i]));
                }
                loaded.ElectronicAddresses(items);
            }
            if (responseData.Pictures != null && responseData.Pictures.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Pictures.length; i++) {
                    items.push(new smapi.community.ContactPictureModel().LoadFromResponse(responseData.Pictures[i]));
                }
                loaded.Pictures(items);
            }
            if (responseData.Notes != null && responseData.Notes.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Notes.length; i++) {
                    items.push(new smapi.community.ContactNoteModel().LoadFromResponse(responseData.Notes[i]));
                }
                loaded.Notes(items);
            }
            if (responseData.Interests != null && responseData.Interests.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Interests.length; i++) {
                    items.push(new smapi.community.ContactInterestModel().LoadFromResponse(responseData.Interests[i]));
                }
                loaded.Interests(items);
            }
            if (responseData.Greetings != null && responseData.Greetings.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Greetings.length; i++) {
                    items.push(new smapi.community.ContactGreetingModel().LoadFromResponse(responseData.Greetings[i]));
                }
                loaded.Greetings(items);
            }
            if (responseData.MyARelations != null && responseData.MyARelations.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.MyARelations.length; i++) {
                    items.push(new smapi.community.ContactRelationshipModel().LoadFromResponse(responseData.MyARelations[i]));
                }
                loaded.MyARelations(items);
            }
            if (responseData.MyZRelations != null && responseData.MyZRelations.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.MyZRelations.length; i++) {
                    items.push(new smapi.community.ContactRelationshipModel().LoadFromResponse(responseData.MyZRelations[i]));
                }
                loaded.MyZRelations(items);
            }
            if (responseData.Holds != null && responseData.Holds.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Holds.length; i++) {
                    items.push(new smapi.community.ContactHoldModel().LoadFromResponse(responseData.Holds[i]));
                }
                loaded.Holds(items);
            }
            if (responseData.Alerts != null && responseData.Alerts.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Alerts.length; i++) {
                    items.push(new smapi.community.ContactAlertModel().LoadFromResponse(responseData.Alerts[i]));
                }
                loaded.Alerts(items);
            }
            if (responseData.UserNotes != null && responseData.UserNotes.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.UserNotes.length; i++) {
                    items.push(new smapi.community.UserContactNoteModel().LoadFromResponse(responseData.UserNotes[i]));
                }
                loaded.UserNotes(items);
            }
            if (responseData.DocumentRepository != null && responseData.DocumentRepository.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.DocumentRepository.length; i++) {
                    items.push(new smapi.community.DocumentRepositoryModel().LoadFromResponse(responseData.DocumentRepository[i]));
                }
                loaded.DocumentRepository(items);
            }
            if (responseData.ContactPronounSet != null) {
                loaded.ContactPronounSet(new smapi.community.ContactPronounSetModel().LoadFromResponse(responseData.ContactPronounSet));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.Organization', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Description.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.LeadTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ContactType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.DisplayName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.ContactPronounSetID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DefaultLocaleID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CRMRankID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ReligiousDenominationModel(options) {
        var defaults = {
            ReligionID: null,
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ReligionID = ko.validatedObservable(settings.ReligionID);
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Religion = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ReligionID != undefined) {
                loaded.ReligionID(responseData.ReligionID);
            }
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Religion != null) {
                loaded.Religion(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.Religion));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.ReligiousDenomination', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ReligionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PlaceOfWorshipModel(options) {
        var defaults = {
            OrganizationID: 0,
            ReligionID: null,
            DenominationID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.OrganizationID = ko.validatedObservable(settings.OrganizationID);
        this.ReligionID = ko.validatedObservable(settings.ReligionID);
        this.DenominationID = ko.validatedObservable(settings.DenominationID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Organization = ko.observable();
        this.Denomination = ko.observable();
        this.Religion = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.OrganizationID != undefined) {
                loaded.OrganizationID(responseData.OrganizationID);
            }
            if (responseData.ReligionID != undefined) {
                loaded.ReligionID(responseData.ReligionID);
            }
            if (responseData.DenominationID != undefined) {
                loaded.DenominationID(responseData.DenominationID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Organization != null) {
                loaded.Organization(new smapi.community.OrganizationModel().LoadFromResponse(responseData.Organization));
            }
            if (responseData.Denomination != null) {
                loaded.Denomination(new smapi.community.ReligiousDenominationModel().LoadFromResponse(responseData.Denomination));
            }
            if (responseData.Religion != null) {
                loaded.Religion(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.Religion));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.PlaceOfWorship', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.OrganizationID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ReligionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DenominationID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function RelationshipTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            RulesetRelationshipTypeID: null,
            ContactFormatRuleSetGID: null,
            NavigatorScreenGID: null,
            ReciprocialTypeID: null,
            RelationshipCategoryID: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.RulesetRelationshipTypeID = ko.validatedObservable(settings.RulesetRelationshipTypeID);
        this.ContactFormatRuleSetGID = ko.validatedObservable(settings.ContactFormatRuleSetGID);
        this.NavigatorScreenGID = ko.validatedObservable(settings.NavigatorScreenGID);
        this.ReciprocialTypeID = ko.validatedObservable(settings.ReciprocialTypeID);
        this.RelationshipCategoryID = ko.validatedObservable(settings.RelationshipCategoryID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.ReciprocialType = ko.observable();
        this.RelationshipCategory = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.RulesetRelationshipTypeID != undefined) {
                loaded.RulesetRelationshipTypeID(responseData.RulesetRelationshipTypeID);
            }
            if (responseData.ContactFormatRuleSetGID != undefined) {
                loaded.ContactFormatRuleSetGID(responseData.ContactFormatRuleSetGID);
            }
            if (responseData.NavigatorScreenGID != undefined) {
                loaded.NavigatorScreenGID(responseData.NavigatorScreenGID);
            }
            if (responseData.ReciprocialTypeID != undefined) {
                loaded.ReciprocialTypeID(responseData.ReciprocialTypeID);
            }
            if (responseData.RelationshipCategoryID != undefined) {
                loaded.RelationshipCategoryID(responseData.RelationshipCategoryID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.ReciprocialType != null) {
                loaded.ReciprocialType(new smapi.community.RelationshipTypeModel().LoadFromResponse(responseData.ReciprocialType));
            }
            if (responseData.RelationshipCategory != null) {
                loaded.RelationshipCategory(new smapi.community.RelationshipCategoryModel().LoadFromResponse(responseData.RelationshipCategory));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.RelationshipType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.RulesetRelationshipTypeID.extend({
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.ContactFormatRuleSetGID.extend({
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.NavigatorScreenGID.extend({
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.ReciprocialTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RelationshipCategoryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function RelationshipCategoryModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.RelationshipTypes = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.RelationshipTypes != null && responseData.RelationshipTypes.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.RelationshipTypes.length; i++) {
                    items.push(new smapi.community.RelationshipTypeModel().LoadFromResponse(responseData.RelationshipTypes[i]));
                }
                loaded.RelationshipTypes(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.RelationshipCategory', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ContactRelationshipModel(options) {
        var defaults = {
            RelationshipTypeID: null,
            NodeAID: null,
            NodeZID: null,
            BeginDate: null,
            EndDate: null,
            NavigatorScreenGID: null,
            ContactType: null,
            DisplayName: '',
            ShowOnDirectory: false,
            DoNotContact: false,
            ContactPronounSetID: null,
            DefaultLocaleID: null,
            CRMRankID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.RelationshipTypeID = ko.validatedObservable(settings.RelationshipTypeID);
        this.NodeAID = ko.validatedObservable(settings.NodeAID);
        this.NodeZID = ko.validatedObservable(settings.NodeZID);
        this.BeginDate = ko.validatedObservable(settings.BeginDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.NavigatorScreenGID = ko.validatedObservable(settings.NavigatorScreenGID);
        this.ContactType = ko.validatedObservable(settings.ContactType);
        this.DisplayName = ko.validatedObservable(settings.DisplayName);
        this.ShowOnDirectory = ko.validatedObservable(settings.ShowOnDirectory);
        this.DoNotContact = ko.validatedObservable(settings.DoNotContact);
        this.ContactPronounSetID = ko.validatedObservable(settings.ContactPronounSetID);
        this.DefaultLocaleID = ko.validatedObservable(settings.DefaultLocaleID);
        this.CRMRankID = ko.validatedObservable(settings.CRMRankID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.NodeA = ko.observable();
        this.NodeZ = ko.observable();
        this.RelationshipType = ko.observable();
        this.CRMRank = ko.observable();
        this.DefaultLocale = ko.observable();
        this.Addresses = ko.observableArray([]);
        this.PhoneNumbers = ko.observableArray([]);
        this.ElectronicAddresses = ko.observableArray([]);
        this.Pictures = ko.observableArray([]);
        this.Notes = ko.observableArray([]);
        this.Interests = ko.observableArray([]);
        this.Greetings = ko.observableArray([]);
        this.MyARelations = ko.observableArray([]);
        this.MyZRelations = ko.observableArray([]);
        this.Holds = ko.observableArray([]);
        this.Alerts = ko.observableArray([]);
        this.UserNotes = ko.observableArray([]);
        this.DocumentRepository = ko.observableArray([]);
        this.ContactPronounSet = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.RelationshipTypeID != undefined) {
                loaded.RelationshipTypeID(responseData.RelationshipTypeID);
            }
            if (responseData.NodeAID != undefined) {
                loaded.NodeAID(responseData.NodeAID);
            }
            if (responseData.NodeZID != undefined) {
                loaded.NodeZID(responseData.NodeZID);
            }
            if (responseData.BeginDate != undefined) {
                loaded.BeginDate(responseData.BeginDate);
            }
            if (responseData.EndDate != undefined) {
                loaded.EndDate(responseData.EndDate);
            }
            if (responseData.NavigatorScreenGID != undefined) {
                loaded.NavigatorScreenGID(responseData.NavigatorScreenGID);
            }
            if (responseData.ContactType != undefined) {
                loaded.ContactType(responseData.ContactType);
            }
            if (responseData.DisplayName != undefined) {
                loaded.DisplayName(responseData.DisplayName);
            }
            if (responseData.ShowOnDirectory != undefined) {
                loaded.ShowOnDirectory(responseData.ShowOnDirectory);
            }
            if (responseData.DoNotContact != undefined) {
                loaded.DoNotContact(responseData.DoNotContact);
            }
            if (responseData.ContactPronounSetID != undefined) {
                loaded.ContactPronounSetID(responseData.ContactPronounSetID);
            }
            if (responseData.DefaultLocaleID != undefined) {
                loaded.DefaultLocaleID(responseData.DefaultLocaleID);
            }
            if (responseData.CRMRankID != undefined) {
                loaded.CRMRankID(responseData.CRMRankID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.NodeA != null) {
                loaded.NodeA(new smapi.community.ContactModel().LoadFromResponse(responseData.NodeA));
            }
            if (responseData.NodeZ != null) {
                loaded.NodeZ(new smapi.community.ContactModel().LoadFromResponse(responseData.NodeZ));
            }
            if (responseData.RelationshipType != null) {
                loaded.RelationshipType(new smapi.community.RelationshipTypeModel().LoadFromResponse(responseData.RelationshipType));
            }
            if (responseData.CRMRank != null) {
                loaded.CRMRank(new smapi.community.CRMRankModel().LoadFromResponse(responseData.CRMRank));
            }
            if (responseData.DefaultLocale != null) {
                loaded.DefaultLocale(new smapi.entities.LocaleModel().LoadFromResponse(responseData.DefaultLocale));
            }
            if (responseData.Addresses != null && responseData.Addresses.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Addresses.length; i++) {
                    items.push(new smapi.community.MailingAddressModel().LoadFromResponse(responseData.Addresses[i]));
                }
                loaded.Addresses(items);
            }
            if (responseData.PhoneNumbers != null && responseData.PhoneNumbers.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.PhoneNumbers.length; i++) {
                    items.push(new smapi.community.PhoneNumberModel().LoadFromResponse(responseData.PhoneNumbers[i]));
                }
                loaded.PhoneNumbers(items);
            }
            if (responseData.ElectronicAddresses != null && responseData.ElectronicAddresses.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ElectronicAddresses.length; i++) {
                    items.push(new smapi.community.ElectronicAddressModel().LoadFromResponse(responseData.ElectronicAddresses[i]));
                }
                loaded.ElectronicAddresses(items);
            }
            if (responseData.Pictures != null && responseData.Pictures.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Pictures.length; i++) {
                    items.push(new smapi.community.ContactPictureModel().LoadFromResponse(responseData.Pictures[i]));
                }
                loaded.Pictures(items);
            }
            if (responseData.Notes != null && responseData.Notes.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Notes.length; i++) {
                    items.push(new smapi.community.ContactNoteModel().LoadFromResponse(responseData.Notes[i]));
                }
                loaded.Notes(items);
            }
            if (responseData.Interests != null && responseData.Interests.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Interests.length; i++) {
                    items.push(new smapi.community.ContactInterestModel().LoadFromResponse(responseData.Interests[i]));
                }
                loaded.Interests(items);
            }
            if (responseData.Greetings != null && responseData.Greetings.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Greetings.length; i++) {
                    items.push(new smapi.community.ContactGreetingModel().LoadFromResponse(responseData.Greetings[i]));
                }
                loaded.Greetings(items);
            }
            if (responseData.MyARelations != null && responseData.MyARelations.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.MyARelations.length; i++) {
                    items.push(new smapi.community.ContactRelationshipModel().LoadFromResponse(responseData.MyARelations[i]));
                }
                loaded.MyARelations(items);
            }
            if (responseData.MyZRelations != null && responseData.MyZRelations.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.MyZRelations.length; i++) {
                    items.push(new smapi.community.ContactRelationshipModel().LoadFromResponse(responseData.MyZRelations[i]));
                }
                loaded.MyZRelations(items);
            }
            if (responseData.Holds != null && responseData.Holds.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Holds.length; i++) {
                    items.push(new smapi.community.ContactHoldModel().LoadFromResponse(responseData.Holds[i]));
                }
                loaded.Holds(items);
            }
            if (responseData.Alerts != null && responseData.Alerts.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Alerts.length; i++) {
                    items.push(new smapi.community.ContactAlertModel().LoadFromResponse(responseData.Alerts[i]));
                }
                loaded.Alerts(items);
            }
            if (responseData.UserNotes != null && responseData.UserNotes.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.UserNotes.length; i++) {
                    items.push(new smapi.community.UserContactNoteModel().LoadFromResponse(responseData.UserNotes[i]));
                }
                loaded.UserNotes(items);
            }
            if (responseData.DocumentRepository != null && responseData.DocumentRepository.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.DocumentRepository.length; i++) {
                    items.push(new smapi.community.DocumentRepositoryModel().LoadFromResponse(responseData.DocumentRepository[i]));
                }
                loaded.DocumentRepository(items);
            }
            if (responseData.ContactPronounSet != null) {
                loaded.ContactPronounSet(new smapi.community.ContactPronounSetModel().LoadFromResponse(responseData.ContactPronounSet));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.ContactRelationship', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.RelationshipTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.NodeAID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.NodeZID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BeginDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.NavigatorScreenGID.extend({
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.ContactType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.DisplayName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.ContactPronounSetID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DefaultLocaleID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CRMRankID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ComputerModel(options) {
        var defaults = {
            Name: '',
            Manufacturer: '',
            RAMSize: 0,
            HarddriveSize: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Manufacturer = ko.validatedObservable(settings.Manufacturer);
        this.RAMSize = ko.validatedObservable(settings.RAMSize);
        this.HarddriveSize = ko.validatedObservable(settings.HarddriveSize);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Manufacturer != undefined) {
                loaded.Manufacturer(responseData.Manufacturer);
            }
            if (responseData.RAMSize != undefined) {
                loaded.RAMSize(responseData.RAMSize);
            }
            if (responseData.HarddriveSize != undefined) {
                loaded.HarddriveSize(responseData.HarddriveSize);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.Computer', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Manufacturer.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.RAMSize.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.HarddriveSize.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function DemographicDataModel(options) {
        var defaults = {
            PersonID: 0,
            ParentMaritalStatusID: null,
            IsHispanic: false,
            ReligionID: null,
            MaritalStatusID: null,
            BirthCountryID: null,
            BirthStateID: null,
            BirthCountyID: null,
            BirthCity: '',
            ResidentCountryID: null,
            ResidentStateID: null,
            ResidentCountyID: null,
            OriginStateID: null,
            OriginCountyID: null,
            Veteran: false,
            IndigenousPersonDeclarationID:null,
            IsGuardiansAttendedcollege: false,
            NumOfDependents: 0,
            NumOfDependentsInHousehold: 0,
            DriversLicenseStateID: null,
            DriversLicense: '',
            PlaceOfWorshipID: null,
            LiveWithID: null,
            ConvictedFelon: false,
            CriminalConviction: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.ParentMaritalStatusID = ko.validatedObservable(settings.ParentMaritalStatusID);
        this.IsHispanic = ko.validatedObservable(settings.IsHispanic);
        this.ReligionID = ko.validatedObservable(settings.ReligionID);
        this.MaritalStatusID = ko.validatedObservable(settings.MaritalStatusID);
        this.BirthCountryID = ko.validatedObservable(settings.BirthCountryID);
        this.BirthStateID = ko.validatedObservable(settings.BirthStateID);
        this.BirthCountyID = ko.validatedObservable(settings.BirthCountyID);
        this.BirthCity = ko.validatedObservable(settings.BirthCity);
        this.IndigenousPersonDeclarationID = ko.validatedObservable(settings.IndigenousPersonDeclarationID);
        this.IsGuardiansAttendedcollege = ko.validatedObservable(settings.IsGuardiansAttendedcollege);
        this.ResidentCountryID = ko.validatedObservable(settings.ResidentCountryID);
        this.ResidentStateID = ko.validatedObservable(settings.ResidentStateID);
        this.ResidentCountyID = ko.validatedObservable(settings.ResidentCountyID);
        this.OriginStateID = ko.validatedObservable(settings.OriginStateID);
        this.OriginCountyID = ko.validatedObservable(settings.OriginCountyID);
        this.Veteran = ko.validatedObservable(settings.Veteran);
        this.NumOfDependents = ko.validatedObservable(settings.NumOfDependents);
        this.NumOfDependentsInHousehold = ko.validatedObservable(settings.NumOfDependentsInHousehold);
        this.DriversLicenseStateID = ko.validatedObservable(settings.DriversLicenseStateID);
        this.DriversLicense = ko.validatedObservable(settings.DriversLicense);
        this.PlaceOfWorshipID = ko.validatedObservable(settings.PlaceOfWorshipID);
        this.LiveWithID = ko.validatedObservable(settings.LiveWithID);
        this.ConvictedFelon = ko.validatedObservable(settings.ConvictedFelon);
        this.CriminalConviction = ko.validatedObservable(settings.CriminalConviction);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        this.BirthCountry = ko.observable();
        this.BirthGoverningDistrict = ko.observable();
        this.ResidentCountry = ko.observable();
        this.ResidentGoverningDistrict = ko.observable();
        this.OriginGoverningDistrict = ko.observable();
        this.DriversLicenseGoverningDistrict = ko.observable();
        this.PlaceOfWorship = ko.observable();
        this.Citizenships = ko.observableArray([]);
        this.MilitaryService = ko.observableArray([]);
        this.Languages = ko.observableArray([]);
        this.ParentMaritalStatus = ko.observable();
        this.EthnicOrigins = ko.observableArray([]);
        this.Religion = ko.observable();
        this.MaritalStatus = ko.observable();
        this.BirthCounty = ko.observable();
        this.ResidentCounty = ko.observable();
        this.OriginCounty = ko.observable();
        this.LiveWith = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.ParentMaritalStatusID != undefined) {
                loaded.ParentMaritalStatusID(responseData.ParentMaritalStatusID);
            }
            if (responseData.IsHispanic != undefined) {
                loaded.IsHispanic(responseData.IsHispanic);
            }
            if (responseData.ReligionID != undefined) {
                loaded.ReligionID(responseData.ReligionID);
            }
            if (responseData.MaritalStatusID != undefined) {
                loaded.MaritalStatusID(responseData.MaritalStatusID);
            }
            if (responseData.BirthCountryID != undefined) {
                loaded.BirthCountryID(responseData.BirthCountryID);
            }
            if (responseData.BirthStateID != undefined) {
                loaded.BirthStateID(responseData.BirthStateID);
            }
            if (responseData.BirthCountyID != undefined) {
                loaded.BirthCountyID(responseData.BirthCountyID);
            }
            if (responseData.BirthCity != undefined) {
                loaded.BirthCity(responseData.BirthCity);
            }
            if (responseData.IndigenousPersonDeclarationID != undefined) {
                loaded.IndigenousPersonDeclarationID(responseData.IndigenousPersonDeclarationID);
            }
            if (responseData.IsGuardiansAttendedcollege != undefined) {
                loaded.IsGuardiansAttendedcollege(responseData.IsGuardiansAttendedcollege);
            }
            if (responseData.ResidentCountryID != undefined) {
                loaded.ResidentCountryID(responseData.ResidentCountryID);
            }
            if (responseData.ResidentStateID != undefined) {
                loaded.ResidentStateID(responseData.ResidentStateID);
            }
            if (responseData.ResidentCountyID != undefined) {
                loaded.ResidentCountyID(responseData.ResidentCountyID);
            }
            if (responseData.OriginStateID != undefined) {
                loaded.OriginStateID(responseData.OriginStateID);
            }
            if (responseData.OriginCountyID != undefined) {
                loaded.OriginCountyID(responseData.OriginCountyID);
            }
            if (responseData.Veteran != undefined) {
                loaded.Veteran(responseData.Veteran);
            }
            if (responseData.NumOfDependents != undefined) {
                loaded.NumOfDependents(responseData.NumOfDependents);
            }
            if (responseData.NumOfDependentsInHousehold != undefined) {
                loaded.NumOfDependentsInHousehold(responseData.NumOfDependentsInHousehold);
            }
            if (responseData.DriversLicenseStateID != undefined) {
                loaded.DriversLicenseStateID(responseData.DriversLicenseStateID);
            }
            if (responseData.DriversLicense != undefined) {
                loaded.DriversLicense(responseData.DriversLicense);
            }
            if (responseData.PlaceOfWorshipID != undefined) {
                loaded.PlaceOfWorshipID(responseData.PlaceOfWorshipID);
            }
            if (responseData.LiveWithID != undefined) {
                loaded.LiveWithID(responseData.LiveWithID);
            }
            if (responseData.ConvictedFelon != undefined) {
                loaded.ConvictedFelon(responseData.ConvictedFelon);
            }
            if (responseData.CriminalConviction != undefined) {
                loaded.CriminalConviction(responseData.CriminalConviction);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.BirthCountry != null) {
                loaded.BirthCountry(new smapi.community.CountryModel().LoadFromResponse(responseData.BirthCountry));
            }
            if (responseData.BirthGoverningDistrict != null) {
                loaded.BirthGoverningDistrict(new smapi.community.GoverningDistrictModel().LoadFromResponse(responseData.BirthGoverningDistrict));
            }
            if (responseData.ResidentCountry != null) {
                loaded.ResidentCountry(new smapi.community.CountryModel().LoadFromResponse(responseData.ResidentCountry));
            }
            if (responseData.ResidentGoverningDistrict != null) {
                loaded.ResidentGoverningDistrict(new smapi.community.GoverningDistrictModel().LoadFromResponse(responseData.ResidentGoverningDistrict));
            }
            if (responseData.OriginGoverningDistrict != null) {
                loaded.OriginGoverningDistrict(new smapi.community.GoverningDistrictModel().LoadFromResponse(responseData.OriginGoverningDistrict));
            }
            if (responseData.DriversLicenseGoverningDistrict != null) {
                loaded.DriversLicenseGoverningDistrict(new smapi.community.GoverningDistrictModel().LoadFromResponse(responseData.DriversLicenseGoverningDistrict));
            }
            if (responseData.PlaceOfWorship != null) {
                loaded.PlaceOfWorship(new smapi.community.PlaceOfWorshipModel().LoadFromResponse(responseData.PlaceOfWorship));
            }
            if (responseData.Citizenships != null && responseData.Citizenships.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Citizenships.length; i++) {
                    items.push(new smapi.community.CitizenshipModel().LoadFromResponse(responseData.Citizenships[i]));
                }
                loaded.Citizenships(items);
            }
            if (responseData.MilitaryService != null && responseData.MilitaryService.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.MilitaryService.length; i++) {
                    items.push(new smapi.community.MilitaryServiceModel().LoadFromResponse(responseData.MilitaryService[i]));
                }
                loaded.MilitaryService(items);
            }
            if (responseData.Languages != null && responseData.Languages.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Languages.length; i++) {
                    items.push(new smapi.community.LanguagesModel().LoadFromResponse(responseData.Languages[i]));
                }
                loaded.Languages(items);
            }
            if (responseData.ParentMaritalStatus != null) {
                loaded.ParentMaritalStatus(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.ParentMaritalStatus));
            }
            if (responseData.EthnicOrigins != null && responseData.EthnicOrigins.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.EthnicOrigins.length; i++) {
                    items.push(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.EthnicOrigins[i]));
                }
                loaded.EthnicOrigins(items);
            }
            if (responseData.Religion != null) {
                loaded.Religion(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.Religion));
            }
            if (responseData.MaritalStatus != null) {
                loaded.MaritalStatus(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.MaritalStatus));
            }
            if (responseData.BirthCounty != null) {
                loaded.BirthCounty(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.BirthCounty));
            }
            if (responseData.ResidentCounty != null) {
                loaded.ResidentCounty(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.ResidentCounty));
            }
            if (responseData.OriginCounty != null) {
                loaded.OriginCounty(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.OriginCounty));
            }
            if (responseData.LiveWith != null) {
                loaded.LiveWith(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.LiveWith));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.DemographicData', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentMaritalStatusID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ReligionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MaritalStatusID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BirthCountryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BirthStateID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BirthCountyID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BirthCity.extend({
            maxLength: {
                params: 60,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '60')
            }
        });
        this.ResidentCountryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ResidentStateID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ResidentCountyID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.OriginStateID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.OriginCountyID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.NumOfDependents.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.NumOfDependentsInHousehold.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DriversLicenseStateID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DriversLicense.extend({
            maxLength: {
                params: 15,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '15')
            }
        });
        this.PlaceOfWorshipID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.LiveWithID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CitizenshipModel(options) {
        var defaults = {
            DemographicDataID: 0,
            CountryID: 0,
            NationalID: '',
            PassportNumber: '',
            PassportExpiration: null,
            PermanentResidentStatusID: null,
            VisaTypeID: null,
            RequireVisa: false,
            VisaExpirationDate: null,
            AlienIDNumber: '',
            PermanentResident: false,
            VisaExpirationDateNotSupplied: false,
            IsPrimary: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
            DateOfEntryToUK: null,
            PassportIssuePlace: '',
            VisaNumber: '',
            EntryDateIntoCanada: '',
            WorkPermitNumber: '',
            WorkPermitExpirationDate: '',
            StudyPermitNumber: '',
            StudyPermitExpirationDate: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.DemographicDataID = ko.validatedObservable(settings.DemographicDataID);
        this.CountryID = ko.validatedObservable(settings.CountryID);
        this.NationalID = ko.validatedObservable(settings.NationalID);
        this.PassportNumber = ko.validatedObservable(settings.PassportNumber);
        this.PassportExpiration = ko.validatedObservable(settings.PassportExpiration);
        this.PermanentResidentStatusID = ko.validatedObservable(settings.PermanentResidentStatusID);
        this.VisaTypeID = ko.validatedObservable(settings.VisaTypeID);
        this.RequireVisa = ko.validatedObservable(settings.RequireVisa);
        this.VisaExpirationDate = ko.validatedObservable(settings.VisaExpirationDate);
        this.AlienIDNumber = ko.validatedObservable(settings.AlienIDNumber);
        this.PermanentResident = ko.validatedObservable(settings.PermanentResident);
        this.VisaExpirationDateNotSupplied = ko.validatedObservable(settings.VisaExpirationDateNotSupplied);
        this.IsPrimary = ko.validatedObservable(settings.IsPrimary);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        this.DateOfEntryToUK = ko.validatedObservable(settings.DateOfEntryToUK);
        this.PassportIssuePlace = ko.validatedObservable(settings.PassportIssuePlace);
        this.VisaNumber = ko.validatedObservable(settings.VisaNumber);
        this.EntryDateIntoCanada = ko.validatedObservable(settings.EntryDateIntoCanada);
        this.WorkPermitNumber = ko.validatedObservable(settings.WorkPermitNumber);
        this.WorkPermitExpirationDate = ko.validatedObservable(settings.WorkPermitExpirationDate);
        this.StudyPermitNumber = ko.validatedObservable(settings.StudyPermitNumber);
        this.StudyPermitExpirationDate = ko.validatedObservable(settings.StudyPermitExpirationDate);
        
        // Relationships as Observables and ObservableArrays
        this.DemographicData = ko.observable();
        this.Country = ko.observable();
        this.PermanentResidentStatus = ko.observable();
        this.VisaType = ko.observable();

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.DemographicDataID != undefined) {
                loaded.DemographicDataID(responseData.DemographicDataID);
            }
            if (responseData.CountryID != undefined) {
                loaded.CountryID(responseData.CountryID);
            }
            if (responseData.NationalID != undefined) {
                loaded.NationalID(responseData.NationalID);
            }
            if (responseData.PassportNumber != undefined) {
                loaded.PassportNumber(responseData.PassportNumber);
            }
            if (responseData.PassportExpiration != undefined) {
                loaded.PassportExpiration(responseData.PassportExpiration);
            }
            if (responseData.PermanentResidentStatusID != undefined) {
                loaded.PermanentResidentStatusID(responseData.PermanentResidentStatusID);
            }
            if (responseData.VisaTypeID != undefined) {
                loaded.VisaTypeID(responseData.VisaTypeID);
            }
            if (responseData.RequireVisa != undefined) {
                loaded.RequireVisa(responseData.RequireVisa);
            }
            if (responseData.VisaExpirationDate != undefined) {
                loaded.VisaExpirationDate(responseData.VisaExpirationDate);
            }
            if (responseData.EntryDateIntoCanada != undefined) {
                loaded.EntryDateIntoCanada(responseData.EntryDateIntoCanada);
            }
            if (responseData.WorkPermitNumber != undefined) {
                loaded.WorkPermitNumber(responseData.WorkPermitNumber);
            }
            if (responseData.WorkPermitExpirationDate != undefined) {
                loaded.WorkPermitExpirationDate(responseData.WorkPermitExpirationDate);
            }
            if (responseData.StudyPermitNumber != undefined) {
                loaded.StudyPermitNumber(responseData.StudyPermitNumber);
            }
            if (responseData.StudyPermitExpirationDate != undefined) {
                loaded.StudyPermitExpirationDate(responseData.StudyPermitExpirationDate);
            }
            if (responseData.AlienIDNumber != undefined) {
                loaded.AlienIDNumber(responseData.AlienIDNumber);
            }
            if (responseData.PermanentResident != undefined) {
                loaded.PermanentResident(responseData.PermanentResident);
            }
            if (responseData.VisaExpirationDateNotSupplied != undefined) {
                loaded.VisaExpirationDateNotSupplied(responseData.VisaExpirationDateNotSupplied);
            }
            if (responseData.IsPrimary != undefined) {
                loaded.IsPrimary(responseData.IsPrimary);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.DemographicData != null) {
                loaded.DemographicData(new smapi.community.DemographicDataModel().LoadFromResponse(responseData.DemographicData));
            }
            if (responseData.Country != null) {
                loaded.Country(new smapi.community.CountryModel().LoadFromResponse(responseData.Country));
            }
            if (responseData.PermanentResidentStatus != null) {
                loaded.PermanentResidentStatus(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.PermanentResidentStatus));
            }
            if (responseData.VisaType != null) {
                loaded.VisaType(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.VisaType));
            }
            if (responseData.DateOfEntryToUK != undefined) {
                loaded.DateOfEntryToUK(responseData.DateOfEntryToUK);
            }
            if (responseData.PassportIssuePlace != undefined) {
                loaded.PassportIssuePlace(responseData.PassportIssuePlace);
            }
            if (responseData.VisaNumber != undefined) {
                loaded.VisaNumber(responseData.VisaNumber);
            }
            var custDta = {
                defaults: defaults,
                settings : settings,
                self : self,
                responseData : responseData,
                loaded : loaded
            }
            sm.portal.vm.custom.callCustomization('ResponseHandlingForCitizenModel', custDta);
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.Citizenship', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }

        this.DemographicDataID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CountryID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.NationalID.extend({
            maxLength: {
                params: 60,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '60')
            }
        });
        this.PassportNumber.extend({
            maxLength: {
                params: 30,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '30')
            }
        });
        this.PassportExpiration.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.PermanentResidentStatusID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.VisaTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.VisaExpirationDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AlienIDNumber.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.DateOfEntryToUK.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.PassportIssuePlace.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.VisaNumber.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function MilitaryClassificationModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            SortOrder: 0,
            BranchID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BranchID = ko.validatedObservable(settings.BranchID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Branch = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BranchID != undefined) {
                loaded.BranchID(responseData.BranchID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Branch != null) {
                loaded.Branch(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.Branch));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.MilitaryClassification', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BranchID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function MilitaryPayGradeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            SortOrder: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.MilitaryPayGrade', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function MilitaryRankModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            SortOrder: 0,
            BranchID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BranchID = ko.validatedObservable(settings.BranchID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Branch = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BranchID != undefined) {
                loaded.BranchID(responseData.BranchID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Branch != null) {
                loaded.Branch(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.Branch));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.MilitaryRank', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BranchID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function MilitaryServiceModel(options) {
        var defaults = {
            DemographicDataID: 0,
            BranchID: 0,
            MilitaryStatusID: null,
            DateOfServiceFrom: null,
            DateOfServiceTo: null,
            MilitaryRankID: null,
            MilitaryPayGradeID: null,
            MilitaryClassificationID: null,
            PrimaryAFSC: '',
            SecondaryAFSC: '',
            TertiaryAFSC: '',
            QuaternaryAFSC: '',
            Unit: '',
            DateOfRank: null,
            PromotionLineNumber: 0,
            EligibleForReinstatement: false,
            EnlistmentDateTo: null,
            EnlistmentDateFrom: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.DemographicDataID = ko.validatedObservable(settings.DemographicDataID);
        this.BranchID = ko.validatedObservable(settings.BranchID);
        this.MilitaryStatusID = ko.validatedObservable(settings.MilitaryStatusID);
        this.DateOfServiceFrom = ko.validatedObservable(settings.DateOfServiceFrom);
        this.DateOfServiceTo = ko.validatedObservable(settings.DateOfServiceTo);
        this.MilitaryRankID = ko.validatedObservable(settings.MilitaryRankID);
        this.MilitaryPayGradeID = ko.validatedObservable(settings.MilitaryPayGradeID);
        this.MilitaryClassificationID = ko.validatedObservable(settings.MilitaryClassificationID);
        this.PrimaryAFSC = ko.validatedObservable(settings.PrimaryAFSC);
        this.SecondaryAFSC = ko.validatedObservable(settings.SecondaryAFSC);
        this.TertiaryAFSC = ko.validatedObservable(settings.TertiaryAFSC);
        this.QuaternaryAFSC = ko.validatedObservable(settings.QuaternaryAFSC);
        this.Unit = ko.validatedObservable(settings.Unit);
        this.DateOfRank = ko.validatedObservable(settings.DateOfRank);
        this.PromotionLineNumber = ko.validatedObservable(settings.PromotionLineNumber);
        this.EligibleForReinstatement = ko.validatedObservable(settings.EligibleForReinstatement);
        this.EnlistmentDateTo = ko.validatedObservable(settings.EnlistmentDateTo);
        this.EnlistmentDateFrom = ko.validatedObservable(settings.EnlistmentDateFrom);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.DemographicData = ko.observable();
        this.MilitaryRank = ko.observable();
        this.MilitaryPayGrade = ko.observable();
        this.MilitaryClassification = ko.observable();
        this.Branch = ko.observable();
        this.MilitaryStatus = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.DemographicDataID != undefined) {
                loaded.DemographicDataID(responseData.DemographicDataID);
            }
            if (responseData.BranchID != undefined) {
                loaded.BranchID(responseData.BranchID);
            }
            if (responseData.MilitaryStatusID != undefined) {
                loaded.MilitaryStatusID(responseData.MilitaryStatusID);
            }
            if (responseData.DateOfServiceFrom != undefined) {
                loaded.DateOfServiceFrom(responseData.DateOfServiceFrom);
            }
            if (responseData.DateOfServiceTo != undefined) {
                loaded.DateOfServiceTo(responseData.DateOfServiceTo);
            }
            if (responseData.MilitaryRankID != undefined) {
                loaded.MilitaryRankID(responseData.MilitaryRankID);
            }
            if (responseData.MilitaryPayGradeID != undefined) {
                loaded.MilitaryPayGradeID(responseData.MilitaryPayGradeID);
            }
            if (responseData.MilitaryClassificationID != undefined) {
                loaded.MilitaryClassificationID(responseData.MilitaryClassificationID);
            }
            if (responseData.PrimaryAFSC != undefined) {
                loaded.PrimaryAFSC(responseData.PrimaryAFSC);
            }
            if (responseData.SecondaryAFSC != undefined) {
                loaded.SecondaryAFSC(responseData.SecondaryAFSC);
            }
            if (responseData.TertiaryAFSC != undefined) {
                loaded.TertiaryAFSC(responseData.TertiaryAFSC);
            }
            if (responseData.QuaternaryAFSC != undefined) {
                loaded.QuaternaryAFSC(responseData.QuaternaryAFSC);
            }
            if (responseData.Unit != undefined) {
                loaded.Unit(responseData.Unit);
            }
            if (responseData.DateOfRank != undefined) {
                loaded.DateOfRank(responseData.DateOfRank);
            }
            if (responseData.PromotionLineNumber != undefined) {
                loaded.PromotionLineNumber(responseData.PromotionLineNumber);
            }
            if (responseData.EligibleForReinstatement != undefined) {
                loaded.EligibleForReinstatement(responseData.EligibleForReinstatement);
            }
            if (responseData.EnlistmentDateTo != undefined) {
                loaded.EnlistmentDateTo(responseData.EnlistmentDateTo);
            }
            if (responseData.EnlistmentDateFrom != undefined) {
                loaded.EnlistmentDateFrom(responseData.EnlistmentDateFrom);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.DemographicData != null) {
                loaded.DemographicData(new smapi.community.DemographicDataModel().LoadFromResponse(responseData.DemographicData));
            }
            if (responseData.MilitaryRank != null) {
                loaded.MilitaryRank(new smapi.community.MilitaryRankModel().LoadFromResponse(responseData.MilitaryRank));
            }
            if (responseData.MilitaryPayGrade != null) {
                loaded.MilitaryPayGrade(new smapi.community.MilitaryPayGradeModel().LoadFromResponse(responseData.MilitaryPayGrade));
            }
            if (responseData.MilitaryClassification != null) {
                loaded.MilitaryClassification(new smapi.community.MilitaryClassificationModel().LoadFromResponse(responseData.MilitaryClassification));
            }
            if (responseData.Branch != null) {
                loaded.Branch(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.Branch));
            }
            if (responseData.MilitaryStatus != null) {
                loaded.MilitaryStatus(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.MilitaryStatus));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.MilitaryService', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.DemographicDataID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BranchID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MilitaryStatusID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DateOfServiceFrom.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.DateOfServiceTo.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.MilitaryRankID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MilitaryPayGradeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MilitaryClassificationID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PrimaryAFSC.extend({
            maxLength: {
                params: 30,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '30')
            }
        });
        this.SecondaryAFSC.extend({
            maxLength: {
                params: 30,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '30')
            }
        });
        this.TertiaryAFSC.extend({
            maxLength: {
                params: 30,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '30')
            }
        });
        this.QuaternaryAFSC.extend({
            maxLength: {
                params: 30,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '30')
            }
        });
        this.Unit.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.DateOfRank.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.PromotionLineNumber.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EnlistmentDateTo.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EnlistmentDateFrom.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function LanguagesModel(options) {
        var defaults = {
            DemographicDataID: 0,
            LanguageID: 0,
            Proficiency: '',
            IsPrimary: false,
            EducationReceived: '',
            QualificationsObtained: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.DemographicDataID = ko.validatedObservable(settings.DemographicDataID);
        this.LanguageID = ko.validatedObservable(settings.LanguageID);
        this.Proficiency = ko.validatedObservable(settings.Proficiency);
        this.IsPrimary = ko.validatedObservable(settings.IsPrimary);
        this.EducationReceived = ko.validatedObservable(settings.EducationReceived);
        this.QualificationsObtained = ko.validatedObservable(settings.QualificationsObtained);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.DemographicData = ko.observable();
        this.Language = ko.observable();
                
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.DemographicDataID != undefined) {
                loaded.DemographicDataID(responseData.DemographicDataID);
            }
            if (responseData.LanguageID != undefined) {
                loaded.LanguageID(responseData.LanguageID);
            }
            if (responseData.Proficiency != undefined) {
                loaded.Proficiency(responseData.Proficiency);
            }
            if (responseData.IsPrimary != undefined) {
                loaded.IsPrimary(responseData.IsPrimary);
            }
            if (responseData.EducationReceived != undefined) {
                loaded.EducationReceived(responseData.EducationReceived);
            }
            if (responseData.QualificationsObtained != undefined) {
                loaded.QualificationsObtained(responseData.QualificationsObtained);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.DemographicData != null) {
                loaded.DemographicData(new smapi.community.DemographicDataModel().LoadFromResponse(responseData.DemographicData));
            }
            if (responseData.Language != null) {
                loaded.Language(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.Language));
            }
            var custData = {
                defaults : defaults,
                self : self,
                settings : settings,
                responseData : responseData,
                loaded : loaded
            }
            sm.portal.vm.custom.callCustomization('ResponseHandlingForLanguageModel', custData); 
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.Languages', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.DemographicDataID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.LanguageID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Proficiency.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 30,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '30')
            }
        });
        this.EducationReceived.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 250,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '250')
            }
        });
        this.QualificationsObtained.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 250,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '250')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function SocietyModuleSettingsModel(options) {
        var defaults = {
            ApplicationName: '',
            SiteName: '',
            UnknownEmailAddress: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ApplicationName = ko.validatedObservable(settings.ApplicationName);
        this.SiteName = ko.validatedObservable(settings.SiteName);
        this.UnknownEmailAddress = ko.validatedObservable(settings.UnknownEmailAddress);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ApplicationName != undefined) {
                loaded.ApplicationName(responseData.ApplicationName);
            }
            if (responseData.SiteName != undefined) {
                loaded.SiteName(responseData.SiteName);
            }
            if (responseData.UnknownEmailAddress != undefined) {
                loaded.UnknownEmailAddress(responseData.UnknownEmailAddress);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.SocietyModuleSettings', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ApplicationName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.SiteName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.UnknownEmailAddress.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PhoneCarrierModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            Organization: '',
            SMSGatewayFormat: '',
            MMSGatewayFormat: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.Organization = ko.validatedObservable(settings.Organization);
        this.SMSGatewayFormat = ko.validatedObservable(settings.SMSGatewayFormat);
        this.MMSGatewayFormat = ko.validatedObservable(settings.MMSGatewayFormat);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.Organization != undefined) {
                loaded.Organization(responseData.Organization);
            }
            if (responseData.SMSGatewayFormat != undefined) {
                loaded.SMSGatewayFormat(responseData.SMSGatewayFormat);
            }
            if (responseData.MMSGatewayFormat != undefined) {
                loaded.MMSGatewayFormat(responseData.MMSGatewayFormat);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.PhoneCarrier', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Organization.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 200,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '200')
            }
        });
        this.SMSGatewayFormat.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.MMSGatewayFormat.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AddressVerificationProviderModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            Global: false,
            Precendence: false,
            GeoCodeOnAV: false,
            CanSearchAddresses: false,
            GeoCodeOnSearch: false,
            DefaultProvider: false,
            ConfigurationEntityID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.Global = ko.validatedObservable(settings.Global);
        this.Precendence = ko.validatedObservable(settings.Precendence);
        this.GeoCodeOnAV = ko.validatedObservable(settings.GeoCodeOnAV);
        this.CanSearchAddresses = ko.validatedObservable(settings.CanSearchAddresses);
        this.GeoCodeOnSearch = ko.validatedObservable(settings.GeoCodeOnSearch);
        this.DefaultProvider = ko.validatedObservable(settings.DefaultProvider);
        this.ConfigurationEntityID = ko.validatedObservable(settings.ConfigurationEntityID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.ConfigurationEntity = ko.observable();
        this.CountriesCovered = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.Global != undefined) {
                loaded.Global(responseData.Global);
            }
            if (responseData.Precendence != undefined) {
                loaded.Precendence(responseData.Precendence);
            }
            if (responseData.GeoCodeOnAV != undefined) {
                loaded.GeoCodeOnAV(responseData.GeoCodeOnAV);
            }
            if (responseData.CanSearchAddresses != undefined) {
                loaded.CanSearchAddresses(responseData.CanSearchAddresses);
            }
            if (responseData.GeoCodeOnSearch != undefined) {
                loaded.GeoCodeOnSearch(responseData.GeoCodeOnSearch);
            }
            if (responseData.DefaultProvider != undefined) {
                loaded.DefaultProvider(responseData.DefaultProvider);
            }
            if (responseData.ConfigurationEntityID != undefined) {
                loaded.ConfigurationEntityID(responseData.ConfigurationEntityID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.ConfigurationEntity != null) {
                loaded.ConfigurationEntity(new smapi.entities.EntityModel().LoadFromResponse(responseData.ConfigurationEntity));
            }
            if (responseData.CountriesCovered != null && responseData.CountriesCovered.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.CountriesCovered.length; i++) {
                    items.push(new smapi.community.CountryModel().LoadFromResponse(responseData.CountriesCovered[i]));
                }
                loaded.CountriesCovered(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.AddressVerificationProvider', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ConfigurationEntityID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function SatoriAddOnsModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            ProductKeyID: '',
            SatoriID: 0,
            CountryID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.ProductKeyID = ko.validatedObservable(settings.ProductKeyID);
        this.SatoriID = ko.validatedObservable(settings.SatoriID);
        this.CountryID = ko.validatedObservable(settings.CountryID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Satori = ko.observable();
        this.Country = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.ProductKeyID != undefined) {
                loaded.ProductKeyID(responseData.ProductKeyID);
            }
            if (responseData.SatoriID != undefined) {
                loaded.SatoriID(responseData.SatoriID);
            }
            if (responseData.CountryID != undefined) {
                loaded.CountryID(responseData.CountryID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Satori != null) {
                loaded.Satori(new smapi.community.SatoriModel().LoadFromResponse(responseData.Satori));
            }
            if (responseData.Country != null) {
                loaded.Country(new smapi.community.CountryModel().LoadFromResponse(responseData.Country));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.SatoriAddOns', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ProductKeyID.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SatoriID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CountryID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function SatoriModel(options) {
        var defaults = {
            ProductKeyId: '',
            GeoCodeKeyId: '',
            ProductKeyExpDate: null,
            GeoCodeKeyExpDate: null,
            AVSingleWebServiceURL: '',
            AVBatchWebServiceURL: '',
            NCOAWebServiceURL: '',
            MailRoomServerHost: '',
            PortNumber: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ProductKeyId = ko.validatedObservable(settings.ProductKeyId);
        this.GeoCodeKeyId = ko.validatedObservable(settings.GeoCodeKeyId);
        this.ProductKeyExpDate = ko.validatedObservable(settings.ProductKeyExpDate);
        this.GeoCodeKeyExpDate = ko.validatedObservable(settings.GeoCodeKeyExpDate);
        this.AVSingleWebServiceURL = ko.validatedObservable(settings.AVSingleWebServiceURL);
        this.AVBatchWebServiceURL = ko.validatedObservable(settings.AVBatchWebServiceURL);
        this.NCOAWebServiceURL = ko.validatedObservable(settings.NCOAWebServiceURL);
        this.MailRoomServerHost = ko.validatedObservable(settings.MailRoomServerHost);
        this.PortNumber = ko.validatedObservable(settings.PortNumber);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.SatoriAddOns = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ProductKeyId != undefined) {
                loaded.ProductKeyId(responseData.ProductKeyId);
            }
            if (responseData.GeoCodeKeyId != undefined) {
                loaded.GeoCodeKeyId(responseData.GeoCodeKeyId);
            }
            if (responseData.ProductKeyExpDate != undefined) {
                loaded.ProductKeyExpDate(responseData.ProductKeyExpDate);
            }
            if (responseData.GeoCodeKeyExpDate != undefined) {
                loaded.GeoCodeKeyExpDate(responseData.GeoCodeKeyExpDate);
            }
            if (responseData.AVSingleWebServiceURL != undefined) {
                loaded.AVSingleWebServiceURL(responseData.AVSingleWebServiceURL);
            }
            if (responseData.AVBatchWebServiceURL != undefined) {
                loaded.AVBatchWebServiceURL(responseData.AVBatchWebServiceURL);
            }
            if (responseData.NCOAWebServiceURL != undefined) {
                loaded.NCOAWebServiceURL(responseData.NCOAWebServiceURL);
            }
            if (responseData.MailRoomServerHost != undefined) {
                loaded.MailRoomServerHost(responseData.MailRoomServerHost);
            }
            if (responseData.PortNumber != undefined) {
                loaded.PortNumber(responseData.PortNumber);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.SatoriAddOns != null && responseData.SatoriAddOns.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.SatoriAddOns.length; i++) {
                    items.push(new smapi.community.SatoriAddOnsModel().LoadFromResponse(responseData.SatoriAddOns[i]));
                }
                loaded.SatoriAddOns(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.Satori', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ProductKeyId.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.GeoCodeKeyId.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ProductKeyExpDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.GeoCodeKeyExpDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AVSingleWebServiceURL.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.AVBatchWebServiceURL.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.NCOAWebServiceURL.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.MailRoomServerHost.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.PortNumber.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function LoqateModel(options) {
        var defaults = {
            LqtKey: '',
            Geocode: false,
            Search: false,
            SearchAndGeocode: false,
            ServiceUrl: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.LqtKey = ko.validatedObservable(settings.LqtKey);
        this.Geocode = ko.validatedObservable(settings.Geocode);
        this.Search = ko.validatedObservable(settings.Search);
        this.SearchAndGeocode = ko.validatedObservable(settings.SearchAndGeocode);
        this.ServiceUrl = ko.validatedObservable(settings.ServiceUrl);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.LqtKey != undefined) {
                loaded.LqtKey(responseData.LqtKey);
            }
            if (responseData.Geocode != undefined) {
                loaded.Geocode(responseData.Geocode);
            }
            if (responseData.Search != undefined) {
                loaded.Search(responseData.Search);
            }
            if (responseData.SearchAndGeocode != undefined) {
                loaded.SearchAndGeocode(responseData.SearchAndGeocode);
            }
            if (responseData.ServiceUrl != undefined) {
                loaded.ServiceUrl(responseData.ServiceUrl);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.Loqate', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.LqtKey.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ServiceUrl.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function GoverningDistrictTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.GoverningDistrictType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function GoverningDistrictModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            ISOCode: '',
            BusinessMeaningName: '',
            GoverningDistrictTypeID: null,
            CountryID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.ISOCode = ko.validatedObservable(settings.ISOCode);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.GoverningDistrictTypeID = ko.validatedObservable(settings.GoverningDistrictTypeID);
        this.CountryID = ko.validatedObservable(settings.CountryID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.GoverningDistrictType = ko.observable();
        this.Country = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.ISOCode != undefined) {
                loaded.ISOCode(responseData.ISOCode);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.GoverningDistrictTypeID != undefined) {
                loaded.GoverningDistrictTypeID(responseData.GoverningDistrictTypeID);
            }
            if (responseData.CountryID != undefined) {
                loaded.CountryID(responseData.CountryID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.GoverningDistrictType != null) {
                loaded.GoverningDistrictType(new smapi.community.GoverningDistrictTypeModel().LoadFromResponse(responseData.GoverningDistrictType));
            }
            if (responseData.Country != null) {
                loaded.Country(new smapi.community.CountryModel().LoadFromResponse(responseData.Country));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.GoverningDistrict', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ISOCode.extend({
            maxLength: {
                params: 10,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '10')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.GoverningDistrictTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CountryID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function LeadTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            SystemProtected: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.SystemProtected = ko.validatedObservable(settings.SystemProtected);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.SystemProtected != undefined) {
                loaded.SystemProtected(responseData.SystemProtected);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.LeadType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ContactListCriteriaGroupModel(options) {
        var defaults = {
            SortOrder: 0,
            ContactListID: 0,
            ExternalOperator: null,
            InternalOperator: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.ContactListID = ko.validatedObservable(settings.ContactListID);
        this.ExternalOperator = ko.validatedObservable(settings.ExternalOperator);
        this.InternalOperator = ko.validatedObservable(settings.InternalOperator);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.ContactList = ko.observable();
        this.Criteria = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.ContactListID != undefined) {
                loaded.ContactListID(responseData.ContactListID);
            }
            if (responseData.ExternalOperator != undefined) {
                loaded.ExternalOperator(responseData.ExternalOperator);
            }
            if (responseData.InternalOperator != undefined) {
                loaded.InternalOperator(responseData.InternalOperator);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.ContactList != null) {
                loaded.ContactList(new smapi.community.ContactListModel().LoadFromResponse(responseData.ContactList));
            }
            if (responseData.Criteria != null && responseData.Criteria.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Criteria.length; i++) {
                    items.push(new smapi.entities.TRSExpressionFilterModel().LoadFromResponse(responseData.Criteria[i]));
                }
                loaded.Criteria(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.ContactListCriteriaGroup', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ContactListID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ExternalOperator.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.InternalOperator.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ContactListModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ModuleID: null,
            RuleSetStr: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ModuleID = ko.validatedObservable(settings.ModuleID);
        this.RuleSetStr = ko.validatedObservable(settings.RuleSetStr);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Module = ko.observable();
        this.CriteriaGroups = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ModuleID != undefined) {
                loaded.ModuleID(responseData.ModuleID);
            }
            if (responseData.RuleSetStr != undefined) {
                loaded.RuleSetStr(responseData.RuleSetStr);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Module != null) {
                loaded.Module(new smapi.entities.ModuleModel().LoadFromResponse(responseData.Module));
            }
            if (responseData.CriteriaGroups != null && responseData.CriteriaGroups.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.CriteriaGroups.length; i++) {
                    items.push(new smapi.community.ContactListCriteriaGroupModel().LoadFromResponse(responseData.CriteriaGroups[i]));
                }
                loaded.CriteriaGroups(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.ContactList', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ModuleID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ListCriteriaConditionCategoryModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.ListCriteriaConditionCategory', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ListCriteriaConditionModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ExpectedDataType: '',
            CategoryID: null,
            ExpressionID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ExpectedDataType = ko.validatedObservable(settings.ExpectedDataType);
        this.CategoryID = ko.validatedObservable(settings.CategoryID);
        this.ExpressionID = ko.validatedObservable(settings.ExpressionID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Category = ko.observable();
        this.Expression = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ExpectedDataType != undefined) {
                loaded.ExpectedDataType(responseData.ExpectedDataType);
            }
            if (responseData.CategoryID != undefined) {
                loaded.CategoryID(responseData.CategoryID);
            }
            if (responseData.ExpressionID != undefined) {
                loaded.ExpressionID(responseData.ExpressionID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Category != null) {
                loaded.Category(new smapi.community.ListCriteriaConditionCategoryModel().LoadFromResponse(responseData.Category));
            }
            if (responseData.Expression != null) {
                loaded.Expression(new smapi.entities.TRSExpressionModel().LoadFromResponse(responseData.Expression));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.ListCriteriaCondition', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ExpectedDataType.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.CategoryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ExpressionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function DocumentModel(options) {
        var defaults = {
            ContactID: 0,
            DocumentDate: null,
            ExpirationDate: null,
            Name: '',
            DocumentTypeID: null,
            DocumentContentsTypeID: null,
            DocumentURL: '',
            ExternalDocumentID: '',
            Contents: null,
            MIMEType: '',
            ThumbnailContents: null,
            ThumbnailMIMEType: '',
            FileName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ContactID = ko.validatedObservable(settings.ContactID);
        this.DocumentDate = ko.validatedObservable(settings.DocumentDate);
        this.ExpirationDate = ko.validatedObservable(settings.ExpirationDate);
        this.Name = ko.validatedObservable(settings.Name);
        this.DocumentTypeID = ko.validatedObservable(settings.DocumentTypeID);
        this.DocumentContentsTypeID = ko.validatedObservable(settings.DocumentContentsTypeID);
        this.DocumentURL = ko.validatedObservable(settings.DocumentURL);
        this.ExternalDocumentID = ko.validatedObservable(settings.ExternalDocumentID);
        this.Contents = ko.validatedObservable(settings.Contents);
        this.MIMEType = ko.validatedObservable(settings.MIMEType);
        this.ThumbnailContents = ko.validatedObservable(settings.ThumbnailContents);
        this.ThumbnailMIMEType = ko.validatedObservable(settings.ThumbnailMIMEType);
        this.FileName = ko.validatedObservable(settings.FileName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Contact = ko.observable();
        this.DocumentType = ko.observable();
        this.DocumentContentsType = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ContactID != undefined) {
                loaded.ContactID(responseData.ContactID);
            }
            if (responseData.DocumentDate != undefined) {
                loaded.DocumentDate(responseData.DocumentDate);
            }
            if (responseData.ExpirationDate != undefined) {
                loaded.ExpirationDate(responseData.ExpirationDate);
            }
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.DocumentTypeID != undefined) {
                loaded.DocumentTypeID(responseData.DocumentTypeID);
            }
            if (responseData.DocumentContentsTypeID != undefined) {
                loaded.DocumentContentsTypeID(responseData.DocumentContentsTypeID);
            }
            if (responseData.DocumentURL != undefined) {
                loaded.DocumentURL(responseData.DocumentURL);
            }
            if (responseData.ExternalDocumentID != undefined) {
                loaded.ExternalDocumentID(responseData.ExternalDocumentID);
            }
            if (responseData.Contents != undefined) {
                loaded.Contents(responseData.Contents);
            }
            if (responseData.MIMEType != undefined) {
                loaded.MIMEType(responseData.MIMEType);
            }
            if (responseData.ThumbnailContents != undefined) {
                loaded.ThumbnailContents(responseData.ThumbnailContents);
            }
            if (responseData.ThumbnailMIMEType != undefined) {
                loaded.ThumbnailMIMEType(responseData.ThumbnailMIMEType);
            }
            if (responseData.FileName != undefined) {
                loaded.FileName(responseData.FileName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Contact != null) {
                loaded.Contact(new smapi.community.ContactModel().LoadFromResponse(responseData.Contact));
            }
            if (responseData.DocumentType != null) {
                loaded.DocumentType(new smapi.community.DocumentTypeModel().LoadFromResponse(responseData.DocumentType));
            }
            if (responseData.DocumentContentsType != null) {
                loaded.DocumentContentsType(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.DocumentContentsType));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.Document', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ContactID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DocumentDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ExpirationDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.Name.extend({
            maxLength: {
                params: 120,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '120')
            }
        });
        this.DocumentTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DocumentContentsTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DocumentURL.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ExternalDocumentID.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.MIMEType.extend({
            maxLength: {
                params: 300,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '300')
            }
        });
        this.ThumbnailMIMEType.extend({
            maxLength: {
                params: 300,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '300')
            }
        });
        this.FileName.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function DocumentTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            CanExpire: false,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.CanExpire = ko.validatedObservable(settings.CanExpire);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Modules = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.CanExpire != undefined) {
                loaded.CanExpire(responseData.CanExpire);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Modules != null && responseData.Modules.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Modules.length; i++) {
                    items.push(new smapi.entities.ModuleModel().LoadFromResponse(responseData.Modules[i]));
                }
                loaded.Modules(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.DocumentType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function DocumentRepositoryTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            InclusionRulesetID: null,
            CompletionRulesetID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.InclusionRulesetID = ko.validatedObservable(settings.InclusionRulesetID);
        this.CompletionRulesetID = ko.validatedObservable(settings.CompletionRulesetID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.InclusionRuleset = ko.observable();
        this.CompletionRuleset = ko.observable();
        this.DataChangedWatchers = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.InclusionRulesetID != undefined) {
                loaded.InclusionRulesetID(responseData.InclusionRulesetID);
            }
            if (responseData.CompletionRulesetID != undefined) {
                loaded.CompletionRulesetID(responseData.CompletionRulesetID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.InclusionRuleset != null) {
                loaded.InclusionRuleset(new smapi.entities.TRSRuleSetModel().LoadFromResponse(responseData.InclusionRuleset));
            }
            if (responseData.CompletionRuleset != null) {
                loaded.CompletionRuleset(new smapi.entities.TRSRuleSetModel().LoadFromResponse(responseData.CompletionRuleset));
            }
            if (responseData.DataChangedWatchers != null && responseData.DataChangedWatchers.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.DataChangedWatchers.length; i++) {
                    items.push(new smapi.entities.DataChangedWatcherModel().LoadFromResponse(responseData.DataChangedWatchers[i]));
                }
                loaded.DataChangedWatchers(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.DocumentRepositoryType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.InclusionRulesetID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CompletionRulesetID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function DocumentRepositoryModel(options) {
        var defaults = {
            DocumentRepositoryTypeID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.DocumentRepositoryTypeID = ko.validatedObservable(settings.DocumentRepositoryTypeID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.DocumentRepositoryType = ko.observable();
        this.DocumentPlaceholder = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.DocumentRepositoryTypeID != undefined) {
                loaded.DocumentRepositoryTypeID(responseData.DocumentRepositoryTypeID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.DocumentRepositoryType != null) {
                loaded.DocumentRepositoryType(new smapi.community.DocumentRepositoryTypeModel().LoadFromResponse(responseData.DocumentRepositoryType));
            }
            if (responseData.DocumentPlaceholder != null && responseData.DocumentPlaceholder.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.DocumentPlaceholder.length; i++) {
                    items.push(new smapi.community.DocumentPlaceholderModel().LoadFromResponse(responseData.DocumentPlaceholder[i]));
                }
                loaded.DocumentPlaceholder(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.DocumentRepository', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.DocumentRepositoryTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function DocumentPlaceholderModel(options) {
        var defaults = {
            DocumentRepositoryID: 0,
            DateAdded: null,
            DateFulfilled: null,
            ExpirationDate: null,
            ProcessStage: '',
            DocumentTypeID: 0,
            InclusionRulesetID: null,
            CompletionRulesetID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.DocumentRepositoryID = ko.validatedObservable(settings.DocumentRepositoryID);
        this.DateAdded = ko.validatedObservable(settings.DateAdded);
        this.DateFulfilled = ko.validatedObservable(settings.DateFulfilled);
        this.ExpirationDate = ko.validatedObservable(settings.ExpirationDate);
        this.ProcessStage = ko.validatedObservable(settings.ProcessStage);
        this.DocumentTypeID = ko.validatedObservable(settings.DocumentTypeID);
        this.InclusionRulesetID = ko.validatedObservable(settings.InclusionRulesetID);
        this.CompletionRulesetID = ko.validatedObservable(settings.CompletionRulesetID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.DocumentRepository = ko.observable();
        this.DocumentType = ko.observable();
        this.InclusionRuleset = ko.observable();
        this.CompletionRuleset = ko.observable();
        this.Documents = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.DocumentRepositoryID != undefined) {
                loaded.DocumentRepositoryID(responseData.DocumentRepositoryID);
            }
            if (responseData.DateAdded != undefined) {
                loaded.DateAdded(responseData.DateAdded);
            }
            if (responseData.DateFulfilled != undefined) {
                loaded.DateFulfilled(responseData.DateFulfilled);
            }
            if (responseData.ExpirationDate != undefined) {
                loaded.ExpirationDate(responseData.ExpirationDate);
            }
            if (responseData.ProcessStage != undefined) {
                loaded.ProcessStage(responseData.ProcessStage);
            }
            if (responseData.DocumentTypeID != undefined) {
                loaded.DocumentTypeID(responseData.DocumentTypeID);
            }
            if (responseData.InclusionRulesetID != undefined) {
                loaded.InclusionRulesetID(responseData.InclusionRulesetID);
            }
            if (responseData.CompletionRulesetID != undefined) {
                loaded.CompletionRulesetID(responseData.CompletionRulesetID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.DocumentRepository != null) {
                loaded.DocumentRepository(new smapi.community.DocumentRepositoryModel().LoadFromResponse(responseData.DocumentRepository));
            }
            if (responseData.DocumentType != null) {
                loaded.DocumentType(new smapi.community.DocumentTypeModel().LoadFromResponse(responseData.DocumentType));
            }
            if (responseData.InclusionRuleset != null) {
                loaded.InclusionRuleset(new smapi.entities.TRSRuleSetModel().LoadFromResponse(responseData.InclusionRuleset));
            }
            if (responseData.CompletionRuleset != null) {
                loaded.CompletionRuleset(new smapi.entities.TRSRuleSetModel().LoadFromResponse(responseData.CompletionRuleset));
            }
            if (responseData.Documents != null && responseData.Documents.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Documents.length; i++) {
                    items.push(new smapi.community.DocumentModel().LoadFromResponse(responseData.Documents[i]));
                }
                loaded.Documents(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.DocumentPlaceholder', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.DocumentRepositoryID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DateAdded.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.DateFulfilled.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ExpirationDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ProcessStage.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.DocumentTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.InclusionRulesetID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CompletionRulesetID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PersonMatchingActionTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            SortOrder: 0,
            SystemProtected: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.SystemProtected = ko.validatedObservable(settings.SystemProtected);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.SystemProtected != undefined) {
                loaded.SystemProtected(responseData.SystemProtected);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.PersonMatchingActionType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PersonMatchedModel(options) {
        var defaults = {
            PersonID: 0,
            MatchedActionTypeID: 0,
            MatchedPersonID: 0,
            MatchingCriteriaID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.MatchedActionTypeID = ko.validatedObservable(settings.MatchedActionTypeID);
        this.MatchedPersonID = ko.validatedObservable(settings.MatchedPersonID);
        this.MatchingCriteriaID = ko.validatedObservable(settings.MatchingCriteriaID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        this.ActionType = ko.observable();
        this.MatchedPerson = ko.observable();
        this.MatchingCriteria = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.MatchedActionTypeID != undefined) {
                loaded.MatchedActionTypeID(responseData.MatchedActionTypeID);
            }
            if (responseData.MatchedPersonID != undefined) {
                loaded.MatchedPersonID(responseData.MatchedPersonID);
            }
            if (responseData.MatchingCriteriaID != undefined) {
                loaded.MatchingCriteriaID(responseData.MatchingCriteriaID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.ActionType != null) {
                loaded.ActionType(new smapi.community.PersonMatchingActionTypeModel().LoadFromResponse(responseData.ActionType));
            }
            if (responseData.MatchedPerson != null) {
                loaded.MatchedPerson(new smapi.community.PersonModel().LoadFromResponse(responseData.MatchedPerson));
            }
            if (responseData.MatchingCriteria != null) {
                loaded.MatchingCriteria(new smapi.community.MatchingCriteriaModel().LoadFromResponse(responseData.MatchingCriteria));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.PersonMatched', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MatchedActionTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MatchedPersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MatchingCriteriaID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function WebContentModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            HtmlFragment: '',
            Sequence: 0,
            CategoryID: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.HtmlFragment = ko.validatedObservable(settings.HtmlFragment);
        this.Sequence = ko.validatedObservable(settings.Sequence);
        this.CategoryID = ko.validatedObservable(settings.CategoryID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Category = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.HtmlFragment != undefined) {
                loaded.HtmlFragment(responseData.HtmlFragment);
            }
            if (responseData.Sequence != undefined) {
                loaded.Sequence(responseData.Sequence);
            }
            if (responseData.CategoryID != undefined) {
                loaded.CategoryID(responseData.CategoryID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Category != null) {
                loaded.Category(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.Category));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.WebContent', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Sequence.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CategoryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CommonModuleSettingsModel(options) {
        var defaults = {
            ApplicationName: '',
            SiteName: '',
            ImageNowStudentDrawerUrlToken: '',
            StateID: null,
            USCollege: false,
            SchoolAcronym: '',
            SystemCountryID: null,
            DefaultStartTime: null,
            DefaultEndTime: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ApplicationName = ko.validatedObservable(settings.ApplicationName);
        this.SiteName = ko.validatedObservable(settings.SiteName);
        this.ImageNowStudentDrawerUrlToken = ko.validatedObservable(settings.ImageNowStudentDrawerUrlToken);
        this.StateID = ko.validatedObservable(settings.StateID);
        this.USCollege = ko.validatedObservable(settings.USCollege);
        this.SchoolAcronym = ko.validatedObservable(settings.SchoolAcronym);
        this.SystemCountryID = ko.validatedObservable(settings.SystemCountryID);
        this.DefaultStartTime = ko.validatedObservable(settings.DefaultStartTime);
        this.DefaultEndTime = ko.validatedObservable(settings.DefaultEndTime);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.GoverningDistrict = ko.observable();
        this.SystemCountry = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ApplicationName != undefined) {
                loaded.ApplicationName(responseData.ApplicationName);
            }
            if (responseData.SiteName != undefined) {
                loaded.SiteName(responseData.SiteName);
            }
            if (responseData.ImageNowStudentDrawerUrlToken != undefined) {
                loaded.ImageNowStudentDrawerUrlToken(responseData.ImageNowStudentDrawerUrlToken);
            }
            if (responseData.StateID != undefined) {
                loaded.StateID(responseData.StateID);
            }
            if (responseData.USCollege != undefined) {
                loaded.USCollege(responseData.USCollege);
            }
            if (responseData.SchoolAcronym != undefined) {
                loaded.SchoolAcronym(responseData.SchoolAcronym);
            }
            if (responseData.SystemCountryID != undefined) {
                loaded.SystemCountryID(responseData.SystemCountryID);
            }
            if (responseData.DefaultStartTime != undefined) {
                loaded.DefaultStartTime(responseData.DefaultStartTime);
            }
            if (responseData.DefaultEndTime != undefined) {
                loaded.DefaultEndTime(responseData.DefaultEndTime);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.GoverningDistrict != null) {
                loaded.GoverningDistrict(new smapi.community.GoverningDistrictModel().LoadFromResponse(responseData.GoverningDistrict));
            }
            if (responseData.SystemCountry != null) {
                loaded.SystemCountry(new smapi.community.CountryModel().LoadFromResponse(responseData.SystemCountry));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.CommonModuleSettings', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ApplicationName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.SiteName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.ImageNowStudentDrawerUrlToken.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.StateID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SchoolAcronym.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 10,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '10')
            }
        });
        this.SystemCountryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DefaultStartTime.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.DefaultEndTime.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PeriodModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            StartDate: null,
            EndDate: null,
            SortOrder: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.StartDate = ko.validatedObservable(settings.StartDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.StartDate != undefined) {
                loaded.StartDate(responseData.StartDate);
            }
            if (responseData.EndDate != undefined) {
                loaded.EndDate(responseData.EndDate);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.Period', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.StartDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 12,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '12')
            }
        });
        this.BusinessMeaningName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function UserTaskNoteModel(options) {
        var defaults = {
            UserTaskID: 0,
            NoteDate: null,
            Starred: false,
            Note: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.UserTaskID = ko.validatedObservable(settings.UserTaskID);
        this.NoteDate = ko.validatedObservable(settings.NoteDate);
        this.Starred = ko.validatedObservable(settings.Starred);
        this.Note = ko.validatedObservable(settings.Note);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.UserTask = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.UserTaskID != undefined) {
                loaded.UserTaskID(responseData.UserTaskID);
            }
            if (responseData.NoteDate != undefined) {
                loaded.NoteDate(responseData.NoteDate);
            }
            if (responseData.Starred != undefined) {
                loaded.Starred(responseData.Starred);
            }
            if (responseData.Note != undefined) {
                loaded.Note(responseData.Note);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.UserTask != null) {
                loaded.UserTask(new smapi.community.UserTaskModel().LoadFromResponse(responseData.UserTask));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.UserTaskNote', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.UserTaskID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.NoteDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.Note.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function UserTaskModel(options) {
        var defaults = {
            MVCArea: '',
            MVCController: '',
            MVCAction: '',
            JSONParams: '',
            Tentative: false,
            Priority: 0,
            Comments: '',
            DueDate: null,
            OriginalDueDate: null,
            RescheduleCount: 0,
            StartDate: null,
            EndDate: null,
            CompletionDate: null,
            WorkflowInstanceID: null,
            CorrelationID: '',
            InstanceGID: null,
            InstanceString: '',
            InstanceEntityID: null,
            TaskTypeID: 0,
            StatusID: 0,
            ParentUserTaskID: null,
            ContextContactID: null,
            ContextEntityID: null,
            ContextGID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.MVCArea = ko.validatedObservable(settings.MVCArea);
        this.MVCController = ko.validatedObservable(settings.MVCController);
        this.MVCAction = ko.validatedObservable(settings.MVCAction);
        this.JSONParams = ko.validatedObservable(settings.JSONParams);
        this.Tentative = ko.validatedObservable(settings.Tentative);
        this.Priority = ko.validatedObservable(settings.Priority);
        this.Comments = ko.validatedObservable(settings.Comments);
        this.DueDate = ko.validatedObservable(settings.DueDate);
        this.OriginalDueDate = ko.validatedObservable(settings.OriginalDueDate);
        this.RescheduleCount = ko.validatedObservable(settings.RescheduleCount);
        this.StartDate = ko.validatedObservable(settings.StartDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.CompletionDate = ko.validatedObservable(settings.CompletionDate);
        this.WorkflowInstanceID = ko.validatedObservable(settings.WorkflowInstanceID);
        this.CorrelationID = ko.validatedObservable(settings.CorrelationID);
        this.InstanceGID = ko.validatedObservable(settings.InstanceGID);
        this.InstanceString = ko.validatedObservable(settings.InstanceString);
        this.InstanceEntityID = ko.validatedObservable(settings.InstanceEntityID);
        this.TaskTypeID = ko.validatedObservable(settings.TaskTypeID);
        this.StatusID = ko.validatedObservable(settings.StatusID);
        this.ParentUserTaskID = ko.validatedObservable(settings.ParentUserTaskID);
        this.ContextContactID = ko.validatedObservable(settings.ContextContactID);
        this.ContextEntityID = ko.validatedObservable(settings.ContextEntityID);
        this.ContextGID = ko.validatedObservable(settings.ContextGID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.TaskType = ko.observable();
        this.InstanceEntity = ko.observable();
        this.Status = ko.observable();
        this.ParentUserTask = ko.observable();
        this.ChildTasks = ko.observableArray([]);
        this.ContextContact = ko.observable();
        this.ContextEntity = ko.observable();
        this.Notes = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.MVCArea != undefined) {
                loaded.MVCArea(responseData.MVCArea);
            }
            if (responseData.MVCController != undefined) {
                loaded.MVCController(responseData.MVCController);
            }
            if (responseData.MVCAction != undefined) {
                loaded.MVCAction(responseData.MVCAction);
            }
            if (responseData.JSONParams != undefined) {
                loaded.JSONParams(responseData.JSONParams);
            }
            if (responseData.Tentative != undefined) {
                loaded.Tentative(responseData.Tentative);
            }
            if (responseData.Priority != undefined) {
                loaded.Priority(responseData.Priority);
            }
            if (responseData.Comments != undefined) {
                loaded.Comments(responseData.Comments);
            }
            if (responseData.DueDate != undefined) {
                loaded.DueDate(responseData.DueDate);
            }
            if (responseData.OriginalDueDate != undefined) {
                loaded.OriginalDueDate(responseData.OriginalDueDate);
            }
            if (responseData.RescheduleCount != undefined) {
                loaded.RescheduleCount(responseData.RescheduleCount);
            }
            if (responseData.StartDate != undefined) {
                loaded.StartDate(responseData.StartDate);
            }
            if (responseData.EndDate != undefined) {
                loaded.EndDate(responseData.EndDate);
            }
            if (responseData.CompletionDate != undefined) {
                loaded.CompletionDate(responseData.CompletionDate);
            }
            if (responseData.WorkflowInstanceID != undefined) {
                loaded.WorkflowInstanceID(responseData.WorkflowInstanceID);
            }
            if (responseData.CorrelationID != undefined) {
                loaded.CorrelationID(responseData.CorrelationID);
            }
            if (responseData.InstanceGID != undefined) {
                loaded.InstanceGID(responseData.InstanceGID);
            }
            if (responseData.InstanceString != undefined) {
                loaded.InstanceString(responseData.InstanceString);
            }
            if (responseData.InstanceEntityID != undefined) {
                loaded.InstanceEntityID(responseData.InstanceEntityID);
            }
            if (responseData.TaskTypeID != undefined) {
                loaded.TaskTypeID(responseData.TaskTypeID);
            }
            if (responseData.StatusID != undefined) {
                loaded.StatusID(responseData.StatusID);
            }
            if (responseData.ParentUserTaskID != undefined) {
                loaded.ParentUserTaskID(responseData.ParentUserTaskID);
            }
            if (responseData.ContextContactID != undefined) {
                loaded.ContextContactID(responseData.ContextContactID);
            }
            if (responseData.ContextEntityID != undefined) {
                loaded.ContextEntityID(responseData.ContextEntityID);
            }
            if (responseData.ContextGID != undefined) {
                loaded.ContextGID(responseData.ContextGID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.TaskType != null) {
                loaded.TaskType(new smapi.community.TaskTypeModel().LoadFromResponse(responseData.TaskType));
            }
            if (responseData.InstanceEntity != null) {
                loaded.InstanceEntity(new smapi.entities.EntityModel().LoadFromResponse(responseData.InstanceEntity));
            }
            if (responseData.Status != null) {
                loaded.Status(new smapi.community.TaskStatusModel().LoadFromResponse(responseData.Status));
            }
            if (responseData.ParentUserTask != null) {
                loaded.ParentUserTask(new smapi.community.UserTaskModel().LoadFromResponse(responseData.ParentUserTask));
            }
            if (responseData.ChildTasks != null && responseData.ChildTasks.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ChildTasks.length; i++) {
                    items.push(new smapi.community.UserTaskModel().LoadFromResponse(responseData.ChildTasks[i]));
                }
                loaded.ChildTasks(items);
            }
            if (responseData.ContextContact != null) {
                loaded.ContextContact(new smapi.community.ContactModel().LoadFromResponse(responseData.ContextContact));
            }
            if (responseData.ContextEntity != null) {
                loaded.ContextEntity(new smapi.entities.EntityModel().LoadFromResponse(responseData.ContextEntity));
            }
            if (responseData.Notes != null && responseData.Notes.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Notes.length; i++) {
                    items.push(new smapi.community.UserTaskNoteModel().LoadFromResponse(responseData.Notes[i]));
                }
                loaded.Notes(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.UserTask', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.MVCArea.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 128,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '128')
            }
        });
        this.MVCController.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 256,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '256')
            }
        });
        this.MVCAction.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 128,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '128')
            }
        });
        this.JSONParams.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 4000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '4000')
            }
        });
        this.Priority.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Comments.extend({
            maxLength: {
                params: 4000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '4000')
            }
        });
        this.DueDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.OriginalDueDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.RescheduleCount.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StartDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.CompletionDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.WorkflowInstanceID.extend({
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.CorrelationID.extend({
            maxLength: {
                params: 4000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '4000')
            }
        });
        this.InstanceGID.extend({
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.InstanceString.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.InstanceEntityID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TaskTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StatusID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentUserTaskID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ContextContactID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ContextEntityID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ContextGID.extend({
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function TaskTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            DefaultMVCArea: '',
            DefaultMVCController: '',
            DefaultMVCAction: '',
            SortOrder: 0,
            DefaultPriority: 0,
            DefaultOwnerGroupID: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.DefaultMVCArea = ko.validatedObservable(settings.DefaultMVCArea);
        this.DefaultMVCController = ko.validatedObservable(settings.DefaultMVCController);
        this.DefaultMVCAction = ko.validatedObservable(settings.DefaultMVCAction);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.DefaultPriority = ko.validatedObservable(settings.DefaultPriority);
        this.DefaultOwnerGroupID = ko.validatedObservable(settings.DefaultOwnerGroupID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.DefaultOwnerGroup = ko.observable();
        this.AvailableStatuses = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.DefaultMVCArea != undefined) {
                loaded.DefaultMVCArea(responseData.DefaultMVCArea);
            }
            if (responseData.DefaultMVCController != undefined) {
                loaded.DefaultMVCController(responseData.DefaultMVCController);
            }
            if (responseData.DefaultMVCAction != undefined) {
                loaded.DefaultMVCAction(responseData.DefaultMVCAction);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.DefaultPriority != undefined) {
                loaded.DefaultPriority(responseData.DefaultPriority);
            }
            if (responseData.DefaultOwnerGroupID != undefined) {
                loaded.DefaultOwnerGroupID(responseData.DefaultOwnerGroupID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.DefaultOwnerGroup != null) {
                loaded.DefaultOwnerGroup(new smapi.entities.GroupModel().LoadFromResponse(responseData.DefaultOwnerGroup));
            }
            if (responseData.AvailableStatuses != null && responseData.AvailableStatuses.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.AvailableStatuses.length; i++) {
                    items.push(new smapi.community.TaskStatusModel().LoadFromResponse(responseData.AvailableStatuses[i]));
                }
                loaded.AvailableStatuses(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.TaskType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.DefaultMVCArea.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 128,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '128')
            }
        });
        this.DefaultMVCController.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 256,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '256')
            }
        });
        this.DefaultMVCAction.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 128,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '128')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DefaultPriority.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DefaultOwnerGroupID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function TaskStatusModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            ForceObsolete: false,
            ForcesParentStatus: false,
            ImpactsParentsCounts: false,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.ForceObsolete = ko.validatedObservable(settings.ForceObsolete);
        this.ForcesParentStatus = ko.validatedObservable(settings.ForcesParentStatus);
        this.ImpactsParentsCounts = ko.validatedObservable(settings.ImpactsParentsCounts);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.ForceObsolete != undefined) {
                loaded.ForceObsolete(responseData.ForceObsolete);
            }
            if (responseData.ForcesParentStatus != undefined) {
                loaded.ForcesParentStatus(responseData.ForcesParentStatus);
            }
            if (responseData.ImpactsParentsCounts != undefined) {
                loaded.ImpactsParentsCounts(responseData.ImpactsParentsCounts);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.TaskStatus', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function FavoriteModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            BaseURL: '',
            MVCActionID: null,
            JSONParams: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BaseURL = ko.validatedObservable(settings.BaseURL);
        this.MVCActionID = ko.validatedObservable(settings.MVCActionID);
        this.JSONParams = ko.validatedObservable(settings.JSONParams);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.MVCAction = ko.observable();
        this.ApplicableModules = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BaseURL != undefined) {
                loaded.BaseURL(responseData.BaseURL);
            }
            if (responseData.MVCActionID != undefined) {
                loaded.MVCActionID(responseData.MVCActionID);
            }
            if (responseData.JSONParams != undefined) {
                loaded.JSONParams(responseData.JSONParams);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.MVCAction != null) {
                loaded.MVCAction(new smapi.entities.MVCActionModel().LoadFromResponse(responseData.MVCAction));
            }
            if (responseData.ApplicableModules != null && responseData.ApplicableModules.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ApplicableModules.length; i++) {
                    items.push(new smapi.entities.ModuleModel().LoadFromResponse(responseData.ApplicableModules[i]));
                }
                loaded.ApplicableModules(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.Favorite', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BaseURL.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.MVCActionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.JSONParams.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function TargetThresholdCatagoryModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.TargetThresholdCatagory', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function TargetThresholdModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ExpressionID: null,
            ModuleID: null,
            ThresholdEntityFieldID: null,
            ThresholdExpressionPath: '',
            ThresholdExpressionPathDisplay: '',
            ThresholdExpressionPathValue: '',
            TargetThresholdCatagoryID: 0,
            AssociatedValue: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ExpressionID = ko.validatedObservable(settings.ExpressionID);
        this.ModuleID = ko.validatedObservable(settings.ModuleID);
        this.ThresholdEntityFieldID = ko.validatedObservable(settings.ThresholdEntityFieldID);
        this.ThresholdExpressionPath = ko.validatedObservable(settings.ThresholdExpressionPath);
        this.ThresholdExpressionPathDisplay = ko.validatedObservable(settings.ThresholdExpressionPathDisplay);
        this.ThresholdExpressionPathValue = ko.validatedObservable(settings.ThresholdExpressionPathValue);
        this.TargetThresholdCatagoryID = ko.validatedObservable(settings.TargetThresholdCatagoryID);
        this.AssociatedValue = ko.validatedObservable(settings.AssociatedValue);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Expression = ko.observable();
        this.Module = ko.observable();
        this.ThresholdEntityField = ko.observable();
        this.ThresholdValues = ko.observableArray([]);
        this.ThresholdConditions = ko.observableArray([]);
        this.TargetThresholdCatagory = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ExpressionID != undefined) {
                loaded.ExpressionID(responseData.ExpressionID);
            }
            if (responseData.ModuleID != undefined) {
                loaded.ModuleID(responseData.ModuleID);
            }
            if (responseData.ThresholdEntityFieldID != undefined) {
                loaded.ThresholdEntityFieldID(responseData.ThresholdEntityFieldID);
            }
            if (responseData.ThresholdExpressionPath != undefined) {
                loaded.ThresholdExpressionPath(responseData.ThresholdExpressionPath);
            }
            if (responseData.ThresholdExpressionPathDisplay != undefined) {
                loaded.ThresholdExpressionPathDisplay(responseData.ThresholdExpressionPathDisplay);
            }
            if (responseData.ThresholdExpressionPathValue != undefined) {
                loaded.ThresholdExpressionPathValue(responseData.ThresholdExpressionPathValue);
            }
            if (responseData.TargetThresholdCatagoryID != undefined) {
                loaded.TargetThresholdCatagoryID(responseData.TargetThresholdCatagoryID);
            }
            if (responseData.AssociatedValue != undefined) {
                loaded.AssociatedValue(responseData.AssociatedValue);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Expression != null) {
                loaded.Expression(new smapi.entities.TRSExpressionModel().LoadFromResponse(responseData.Expression));
            }
            if (responseData.Module != null) {
                loaded.Module(new smapi.entities.ModuleModel().LoadFromResponse(responseData.Module));
            }
            if (responseData.ThresholdEntityField != null) {
                loaded.ThresholdEntityField(new smapi.entities.EntityFieldModel().LoadFromResponse(responseData.ThresholdEntityField));
            }
            if (responseData.ThresholdValues != null && responseData.ThresholdValues.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ThresholdValues.length; i++) {
                    items.push(new smapi.community.TargetThresholdValueModel().LoadFromResponse(responseData.ThresholdValues[i]));
                }
                loaded.ThresholdValues(items);
            }
            if (responseData.ThresholdConditions != null && responseData.ThresholdConditions.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ThresholdConditions.length; i++) {
                    items.push(new smapi.community.ThresholdConditionModel().LoadFromResponse(responseData.ThresholdConditions[i]));
                }
                loaded.ThresholdConditions(items);
            }
            if (responseData.TargetThresholdCatagory != null) {
                loaded.TargetThresholdCatagory(new smapi.community.TargetThresholdCatagoryModel().LoadFromResponse(responseData.TargetThresholdCatagory));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.TargetThreshold', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ExpressionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ModuleID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ThresholdEntityFieldID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ThresholdExpressionPath.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ThresholdExpressionPathDisplay.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.TargetThresholdCatagoryID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AssociatedValue.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function TargetThresholdValueModel(options) {
        var defaults = {
            StartDate: null,
            EndDate: null,
            LowerThreshold: 0,
            UpperThreshold: 0,
            TargetThresholdID: null,
            PeriodID: null,
            AssociatedValue: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.StartDate = ko.validatedObservable(settings.StartDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.LowerThreshold = ko.validatedObservable(settings.LowerThreshold);
        this.UpperThreshold = ko.validatedObservable(settings.UpperThreshold);
        this.TargetThresholdID = ko.validatedObservable(settings.TargetThresholdID);
        this.PeriodID = ko.validatedObservable(settings.PeriodID);
        this.AssociatedValue = ko.validatedObservable(settings.AssociatedValue);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Period = ko.observable();
        this.TargetThreshold = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.StartDate != undefined) {
                loaded.StartDate(responseData.StartDate);
            }
            if (responseData.EndDate != undefined) {
                loaded.EndDate(responseData.EndDate);
            }
            if (responseData.LowerThreshold != undefined) {
                loaded.LowerThreshold(responseData.LowerThreshold);
            }
            if (responseData.UpperThreshold != undefined) {
                loaded.UpperThreshold(responseData.UpperThreshold);
            }
            if (responseData.TargetThresholdID != undefined) {
                loaded.TargetThresholdID(responseData.TargetThresholdID);
            }
            if (responseData.PeriodID != undefined) {
                loaded.PeriodID(responseData.PeriodID);
            }
            if (responseData.AssociatedValue != undefined) {
                loaded.AssociatedValue(responseData.AssociatedValue);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Period != null) {
                loaded.Period(new smapi.community.PeriodModel().LoadFromResponse(responseData.Period));
            }
            if (responseData.TargetThreshold != null) {
                loaded.TargetThreshold(new smapi.community.TargetThresholdModel().LoadFromResponse(responseData.TargetThreshold));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.TargetThresholdValue', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.StartDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.LowerThreshold.extend({
            min: {
                params: -79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.UpperThreshold.extend({
            min: {
                params: -79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TargetThresholdID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PeriodID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AssociatedValue.extend({
            min: {
                params: -79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ThresholdConditionModel(options) {
        var defaults = {
            EntityFieldID: null,
            ExpressionID: null,
            ComparisonOperator: null,
            ComparisonValue: '',
            LogicalOperator: null,
            SortOrder: 0,
            AdvancedFieldName: '',
            ExpressionPath: '',
            ExpressionValue: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.EntityFieldID = ko.validatedObservable(settings.EntityFieldID);
        this.ExpressionID = ko.validatedObservable(settings.ExpressionID);
        this.ComparisonOperator = ko.validatedObservable(settings.ComparisonOperator);
        this.ComparisonValue = ko.validatedObservable(settings.ComparisonValue);
        this.LogicalOperator = ko.validatedObservable(settings.LogicalOperator);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.AdvancedFieldName = ko.validatedObservable(settings.AdvancedFieldName);
        this.ExpressionPath = ko.validatedObservable(settings.ExpressionPath);
        this.ExpressionValue = ko.validatedObservable(settings.ExpressionValue);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.EntityField = ko.observable();
        this.Expression = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.EntityFieldID != undefined) {
                loaded.EntityFieldID(responseData.EntityFieldID);
            }
            if (responseData.ExpressionID != undefined) {
                loaded.ExpressionID(responseData.ExpressionID);
            }
            if (responseData.ComparisonOperator != undefined) {
                loaded.ComparisonOperator(responseData.ComparisonOperator);
            }
            if (responseData.ComparisonValue != undefined) {
                loaded.ComparisonValue(responseData.ComparisonValue);
            }
            if (responseData.LogicalOperator != undefined) {
                loaded.LogicalOperator(responseData.LogicalOperator);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.AdvancedFieldName != undefined) {
                loaded.AdvancedFieldName(responseData.AdvancedFieldName);
            }
            if (responseData.ExpressionPath != undefined) {
                loaded.ExpressionPath(responseData.ExpressionPath);
            }
            if (responseData.ExpressionValue != undefined) {
                loaded.ExpressionValue(responseData.ExpressionValue);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.EntityField != null) {
                loaded.EntityField(new smapi.entities.EntityFieldModel().LoadFromResponse(responseData.EntityField));
            }
            if (responseData.Expression != null) {
                loaded.Expression(new smapi.entities.TRSExpressionModel().LoadFromResponse(responseData.Expression));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.ThresholdCondition', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.EntityFieldID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ExpressionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ComparisonOperator.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ComparisonValue.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdvancedFieldName.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ExpressionPath.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PeriodicityModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            BusinessMeaningName: '',
            TimeSpan: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.TimeSpan = ko.validatedObservable(settings.TimeSpan);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.TimeSpan != undefined) {
                loaded.TimeSpan(responseData.TimeSpan);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.Periodicity', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function WarmupUrlModel(options) {
        var defaults = {
            Url: '',
            IsRelative: false,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Url = ko.validatedObservable(settings.Url);
        this.IsRelative = ko.validatedObservable(settings.IsRelative);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Url != undefined) {
                loaded.Url(responseData.Url);
            }
            if (responseData.IsRelative != undefined) {
                loaded.IsRelative(responseData.IsRelative);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.WarmupUrl', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Url.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function RequestHeaderModel(options) {
        var defaults = {
            RequestUserID: 0,
            Url: '',
            IPAddress: '',
            RequestTime: null,
            ResponseTime: null,
            QueryString: '',
            RequestForm: '',
            RequestSession: '',
            TotalRequestTime: null,
            ContextEntityGID: null,
            ContextEntityId: 0,
            SessionHeaderID: null,
            RequestTypeID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.RequestUserID = ko.validatedObservable(settings.RequestUserID);
        this.Url = ko.validatedObservable(settings.Url);
        this.IPAddress = ko.validatedObservable(settings.IPAddress);
        this.RequestTime = ko.validatedObservable(settings.RequestTime);
        this.ResponseTime = ko.validatedObservable(settings.ResponseTime);
        this.QueryString = ko.validatedObservable(settings.QueryString);
        this.RequestForm = ko.validatedObservable(settings.RequestForm);
        this.RequestSession = ko.validatedObservable(settings.RequestSession);
        this.TotalRequestTime = ko.validatedObservable(settings.TotalRequestTime);
        this.ContextEntityGID = ko.validatedObservable(settings.ContextEntityGID);
        this.ContextEntityId = ko.validatedObservable(settings.ContextEntityId);
        this.SessionHeaderID = ko.validatedObservable(settings.SessionHeaderID);
        this.RequestTypeID = ko.validatedObservable(settings.RequestTypeID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.RequestUser = ko.observable();
        this.SessionHeader = ko.observable();
        this.RequestType = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.RequestUserID != undefined) {
                loaded.RequestUserID(responseData.RequestUserID);
            }
            if (responseData.Url != undefined) {
                loaded.Url(responseData.Url);
            }
            if (responseData.IPAddress != undefined) {
                loaded.IPAddress(responseData.IPAddress);
            }
            if (responseData.RequestTime != undefined) {
                loaded.RequestTime(responseData.RequestTime);
            }
            if (responseData.ResponseTime != undefined) {
                loaded.ResponseTime(responseData.ResponseTime);
            }
            if (responseData.QueryString != undefined) {
                loaded.QueryString(responseData.QueryString);
            }
            if (responseData.RequestForm != undefined) {
                loaded.RequestForm(responseData.RequestForm);
            }
            if (responseData.RequestSession != undefined) {
                loaded.RequestSession(responseData.RequestSession);
            }
            if (responseData.TotalRequestTime != undefined) {
                loaded.TotalRequestTime(responseData.TotalRequestTime);
            }
            if (responseData.ContextEntityGID != undefined) {
                loaded.ContextEntityGID(responseData.ContextEntityGID);
            }
            if (responseData.ContextEntityId != undefined) {
                loaded.ContextEntityId(responseData.ContextEntityId);
            }
            if (responseData.SessionHeaderID != undefined) {
                loaded.SessionHeaderID(responseData.SessionHeaderID);
            }
            if (responseData.RequestTypeID != undefined) {
                loaded.RequestTypeID(responseData.RequestTypeID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.RequestUser != null) {
                loaded.RequestUser(new smapi.entities.UserModel().LoadFromResponse(responseData.RequestUser));
            }
            if (responseData.SessionHeader != null) {
                loaded.SessionHeader(new smapi.community.SessionHeaderModel().LoadFromResponse(responseData.SessionHeader));
            }
            if (responseData.RequestType != null) {
                loaded.RequestType(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.RequestType));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.RequestHeader', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.RequestUserID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Url.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 4000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '4000')
            }
        });
        this.IPAddress.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.RequestTime.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ResponseTime.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.RequestSession.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.ContextEntityGID.extend({
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.ContextEntityId.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SessionHeaderID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RequestTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function SessionHeaderModel(options) {
        var defaults = {
            SessionID: '',
            LocaleID: 0,
            Contents: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.SessionID = ko.validatedObservable(settings.SessionID);
        this.LocaleID = ko.validatedObservable(settings.LocaleID);
        this.Contents = ko.validatedObservable(settings.Contents);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Requests = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.SessionID != undefined) {
                loaded.SessionID(responseData.SessionID);
            }
            if (responseData.LocaleID != undefined) {
                loaded.LocaleID(responseData.LocaleID);
            }
            if (responseData.Contents != undefined) {
                loaded.Contents(responseData.Contents);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Requests != null && responseData.Requests.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Requests.length; i++) {
                    items.push(new smapi.community.RequestHeaderModel().LoadFromResponse(responseData.Requests[i]));
                }
                loaded.Requests(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.SessionHeader', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.SessionID.extend({
            maxLength: {
                params: 30,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '30')
            }
        });
        this.LocaleID.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function RequestExceptionModel(options) {
        var defaults = {
            ErrorMessage: '',
            ErrorTime: null,
            ErrorCode: 0,
            Source: '',
            RequestHeaderID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ErrorMessage = ko.validatedObservable(settings.ErrorMessage);
        this.ErrorTime = ko.validatedObservable(settings.ErrorTime);
        this.ErrorCode = ko.validatedObservable(settings.ErrorCode);
        this.Source = ko.validatedObservable(settings.Source);
        this.RequestHeaderID = ko.validatedObservable(settings.RequestHeaderID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.RequestHeader = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ErrorMessage != undefined) {
                loaded.ErrorMessage(responseData.ErrorMessage);
            }
            if (responseData.ErrorTime != undefined) {
                loaded.ErrorTime(responseData.ErrorTime);
            }
            if (responseData.ErrorCode != undefined) {
                loaded.ErrorCode(responseData.ErrorCode);
            }
            if (responseData.Source != undefined) {
                loaded.Source(responseData.Source);
            }
            if (responseData.RequestHeaderID != undefined) {
                loaded.RequestHeaderID(responseData.RequestHeaderID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.RequestHeader != null) {
                loaded.RequestHeader(new smapi.community.RequestHeaderModel().LoadFromResponse(responseData.RequestHeader));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.RequestException', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ErrorMessage.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ErrorTime.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ErrorCode.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Source.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.RequestHeaderID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function RequestUrlProcessModel(options) {
        var defaults = {
            Url: '',
            RequestTypeID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Url = ko.validatedObservable(settings.Url);
        this.RequestTypeID = ko.validatedObservable(settings.RequestTypeID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.RequestType = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Url != undefined) {
                loaded.Url(responseData.Url);
            }
            if (responseData.RequestTypeID != undefined) {
                loaded.RequestTypeID(responseData.RequestTypeID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.RequestType != null) {
                loaded.RequestType(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.RequestType));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.RequestUrlProcess', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Url.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.RequestTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function DisplayNameOptionsModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            Value: 0,
            Formula: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.Value = ko.validatedObservable(settings.Value);
        this.Formula = ko.validatedObservable(settings.Formula);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.Value != undefined) {
                loaded.Value(responseData.Value);
            }
            if (responseData.Formula != undefined) {
                loaded.Formula(responseData.Formula);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.DisplayNameOptions', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Value.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Formula.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function MatchingCriteriaModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.MatchingCriteria', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function EducationAndQualificationTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.EducationAndQualificationType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 250,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '250')
            }
        });
        this.BusinessMeaningName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function TeachingPositionTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.TeachingPositionType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 250,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '250')
            }
        });
        this.BusinessMeaningName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function UnitOfTimeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.UnitOfTime', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function DepartmentContactTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.DepartmentContactType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ExternalOrganizationDepartmentModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.ExternalOrganizationDepartment', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function DepartmentalContactModel(options) {
        var defaults = {
            OrganizationID: 0,
            DepartmentID: 0,
            ExternalContactID: null,
            ExternalContactTitle: '',
            DepartmentContactTypeID: null,
            ExternalContactEmail: '',
            InternalContactID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.OrganizationID = ko.validatedObservable(settings.OrganizationID);
        this.DepartmentID = ko.validatedObservable(settings.DepartmentID);
        this.ExternalContactID = ko.validatedObservable(settings.ExternalContactID);
        this.ExternalContactTitle = ko.validatedObservable(settings.ExternalContactTitle);
        this.DepartmentContactTypeID = ko.validatedObservable(settings.DepartmentContactTypeID);
        this.ExternalContactEmail = ko.validatedObservable(settings.ExternalContactEmail);
        this.InternalContactID = ko.validatedObservable(settings.InternalContactID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Organization = ko.observable();
        this.Department = ko.observable();
        this.ExternalContact = ko.observable();
        this.DepartmentContactType = ko.observable();
        this.InternalContact = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.OrganizationID != undefined) {
                loaded.OrganizationID(responseData.OrganizationID);
            }
            if (responseData.DepartmentID != undefined) {
                loaded.DepartmentID(responseData.DepartmentID);
            }
            if (responseData.ExternalContactID != undefined) {
                loaded.ExternalContactID(responseData.ExternalContactID);
            }
            if (responseData.ExternalContactTitle != undefined) {
                loaded.ExternalContactTitle(responseData.ExternalContactTitle);
            }
            if (responseData.DepartmentContactTypeID != undefined) {
                loaded.DepartmentContactTypeID(responseData.DepartmentContactTypeID);
            }
            if (responseData.ExternalContactEmail != undefined) {
                loaded.ExternalContactEmail(responseData.ExternalContactEmail);
            }
            if (responseData.InternalContactID != undefined) {
                loaded.InternalContactID(responseData.InternalContactID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Organization != null) {
                loaded.Organization(new smapi.community.OrganizationModel().LoadFromResponse(responseData.Organization));
            }
            if (responseData.Department != null) {
                loaded.Department(new smapi.community.ExternalOrganizationDepartmentModel().LoadFromResponse(responseData.Department));
            }
            if (responseData.ExternalContact != null) {
                loaded.ExternalContact(new smapi.community.PersonModel().LoadFromResponse(responseData.ExternalContact));
            }
            if (responseData.DepartmentContactType != null) {
                loaded.DepartmentContactType(new smapi.community.DepartmentContactTypeModel().LoadFromResponse(responseData.DepartmentContactType));
            }
            if (responseData.InternalContact != null) {
                loaded.InternalContact(new smapi.community.PersonModel().LoadFromResponse(responseData.InternalContact));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.DepartmentalContact', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.OrganizationID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DepartmentID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ExternalContactID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ExternalContactTitle.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.DepartmentContactTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ExternalContactEmail.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.InternalContactID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AccessibilityNeedTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            SystemProtected: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.SystemProtected = ko.validatedObservable(settings.SystemProtected);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Conditions = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.SystemProtected != undefined) {
                loaded.SystemProtected(responseData.SystemProtected);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Conditions != null && responseData.Conditions.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Conditions.length; i++) {
                    items.push(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.Conditions[i]));
                }
                loaded.Conditions(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.AccessibilityNeedType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AccessibilityNeedModel(options) {
        var defaults = {
            PersonID: null,
            AccessibilityNeedTypeID: 0,
            DisabilityStatusID: 0,
            Description: '',
            BeginDate: null,
            EndDate: null,
            EffectsAssessments: false,
            ProvisionalNeeds: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.AccessibilityNeedTypeID = ko.validatedObservable(settings.AccessibilityNeedTypeID);
        this.DisabilityStatusID = ko.validatedObservable(settings.DisabilityStatusID);
        this.Description = ko.validatedObservable(settings.Description);
        this.BeginDate = ko.validatedObservable(settings.BeginDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.EffectsAssessments = ko.validatedObservable(settings.EffectsAssessments);
        this.ProvisionalNeeds = ko.validatedObservable(settings.ProvisionalNeeds);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        this.AccessibilityNeedType = ko.observable();
        this.DisabilityStatus = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.AccessibilityNeedTypeID != undefined) {
                loaded.AccessibilityNeedTypeID(responseData.AccessibilityNeedTypeID);
            }
            if (responseData.DisabilityStatusID != undefined) {
                loaded.DisabilityStatusID(responseData.DisabilityStatusID);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BeginDate != undefined) {
                loaded.BeginDate(responseData.BeginDate);
            }
            if (responseData.EndDate != undefined) {
                loaded.EndDate(responseData.EndDate);
            }
            if (responseData.EffectsAssessments != undefined) {
                loaded.EffectsAssessments(responseData.EffectsAssessments);
            }
            if (responseData.ProvisionalNeeds != undefined) {
                loaded.ProvisionalNeeds(responseData.ProvisionalNeeds);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.AccessibilityNeedType != null) {
                loaded.AccessibilityNeedType(new smapi.community.AccessibilityNeedTypeModel().LoadFromResponse(responseData.AccessibilityNeedType));
            }
            if (responseData.DisabilityStatus != null) {
                loaded.DisabilityStatus(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.DisabilityStatus));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.AccessibilityNeed', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AccessibilityNeedTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DisabilityStatusID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Description.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BeginDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ProvisionalNeeds.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function EmploymentModel(options) {
        var defaults = {
            PersonID: null,
            EmployerID: null,
            Title: '',
            BeginDate: null,
            EndDate: null,
            ContactNumber: '',
            Supervisor: '',
            EmploymentStatusID: null,
            OccupationID: null,
            DutyAFSC: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
            FlexiFieldValues: null
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.EmployerID = ko.validatedObservable(settings.EmployerID);
        this.Title = ko.validatedObservable(settings.Title);
        this.BeginDate = ko.validatedObservable(settings.BeginDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.ContactNumber = ko.validatedObservable(settings.ContactNumber);
        this.Supervisor = ko.validatedObservable(settings.Supervisor);
        this.EmploymentStatusID = ko.validatedObservable(settings.EmploymentStatusID);
        this.OccupationID = ko.validatedObservable(settings.OccupationID);
        this.DutyAFSC = ko.validatedObservable(settings.DutyAFSC);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        this.FlexiFieldValues = ko.observable(settings.FlexiFieldValues);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        this.Organization = ko.observable();
        this.EmploymentStatus = ko.observable();
        this.Occupation = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.EmployerID != undefined) {
                loaded.EmployerID(responseData.EmployerID);
            }
            if (responseData.Title != undefined) {
                loaded.Title(responseData.Title);
            }
            if (responseData.BeginDate != undefined) {
                loaded.BeginDate(responseData.BeginDate);
            }
            if (responseData.EndDate != undefined) {
                loaded.EndDate(responseData.EndDate);
            }
            if (responseData.ContactNumber != undefined) {
                loaded.ContactNumber(responseData.ContactNumber);
            }
            if (responseData.Supervisor != undefined) {
                loaded.Supervisor(responseData.Supervisor);
            }
            if (responseData.EmploymentStatusID != undefined) {
                loaded.EmploymentStatusID(responseData.EmploymentStatusID);
            }
            if (responseData.OccupationID != undefined) {
                loaded.OccupationID(responseData.OccupationID);
            }
            if (responseData.DutyAFSC != undefined) {
                loaded.DutyAFSC(responseData.DutyAFSC);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.FlexiFieldValues != undefined) {
                loaded.FlexiFieldValues(responseData.FlexiFieldValues);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.Organization != null) {
                loaded.Organization(new smapi.community.OrganizationModel().LoadFromResponse(responseData.Organization));
            }
            if (responseData.EmploymentStatus != null) {
                loaded.EmploymentStatus(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.EmploymentStatus));
            }
            if (responseData.Occupation != null) {
                loaded.Occupation(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.Occupation));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.Employment', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EmployerID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Title.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.BeginDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ContactNumber.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Supervisor.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.EmploymentStatusID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.OccupationID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DutyAFSC.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ContractTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            CanExpire: false,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.CanExpire = ko.validatedObservable(settings.CanExpire);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.CanExpire != undefined) {
                loaded.CanExpire(responseData.CanExpire);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.ContractType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ContractDocumentModel(options) {
        var defaults = {
            OrganizationID: 0,
            ContractID: 0,
            ContractDocumentTypeID: 0,
            ContractTitle: '',
            StartDate: null,
            EndDate: null,
            Comment: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.OrganizationID = ko.validatedObservable(settings.OrganizationID);
        this.ContractID = ko.validatedObservable(settings.ContractID);
        this.ContractDocumentTypeID = ko.validatedObservable(settings.ContractDocumentTypeID);
        this.ContractTitle = ko.validatedObservable(settings.ContractTitle);
        this.StartDate = ko.validatedObservable(settings.StartDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.Comment = ko.validatedObservable(settings.Comment);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Organization = ko.observable();
        this.ContractDocumentType = ko.observable();
        this.Contract = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.OrganizationID != undefined) {
                loaded.OrganizationID(responseData.OrganizationID);
            }
            if (responseData.ContractID != undefined) {
                loaded.ContractID(responseData.ContractID);
            }
            if (responseData.ContractDocumentTypeID != undefined) {
                loaded.ContractDocumentTypeID(responseData.ContractDocumentTypeID);
            }
            if (responseData.ContractTitle != undefined) {
                loaded.ContractTitle(responseData.ContractTitle);
            }
            if (responseData.StartDate != undefined) {
                loaded.StartDate(responseData.StartDate);
            }
            if (responseData.EndDate != undefined) {
                loaded.EndDate(responseData.EndDate);
            }
            if (responseData.Comment != undefined) {
                loaded.Comment(responseData.Comment);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Organization != null) {
                loaded.Organization(new smapi.community.OrganizationModel().LoadFromResponse(responseData.Organization));
            }
            if (responseData.ContractDocumentType != null) {
                loaded.ContractDocumentType(new smapi.community.ContractTypeModel().LoadFromResponse(responseData.ContractDocumentType));
            }
            if (responseData.Contract != null) {
                loaded.Contract(new smapi.community.DocumentModel().LoadFromResponse(responseData.Contract));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.ContractDocument', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.OrganizationID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ContractID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ContractDocumentTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ContractTitle.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.StartDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.Comment.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function OrganizationContactRelationshipModel(options) {
        var defaults = {
            OrganizationID: 0,
            RelationshipTypeID: null,
            ContactID: 0,
            Title: '',
            InternalExternal: '',
            DepartmentID: null,
            DepartmentContactTypeID: null,
            Email: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.OrganizationID = ko.validatedObservable(settings.OrganizationID);
        this.RelationshipTypeID = ko.validatedObservable(settings.RelationshipTypeID);
        this.ContactID = ko.validatedObservable(settings.ContactID);
        this.Title = ko.validatedObservable(settings.Title);
        this.InternalExternal = ko.validatedObservable(settings.InternalExternal);
        this.DepartmentID = ko.validatedObservable(settings.DepartmentID);
        this.DepartmentContactTypeID = ko.validatedObservable(settings.DepartmentContactTypeID);
        this.Email = ko.validatedObservable(settings.Email);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Contact = ko.observable();
        this.Department = ko.observable();
        this.Organization = ko.observable();
        this.DepartmentContactType = ko.observable();
        this.RelationshipType = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.OrganizationID != undefined) {
                loaded.OrganizationID(responseData.OrganizationID);
            }
            if (responseData.RelationshipTypeID != undefined) {
                loaded.RelationshipTypeID(responseData.RelationshipTypeID);
            }
            if (responseData.ContactID != undefined) {
                loaded.ContactID(responseData.ContactID);
            }
            if (responseData.Title != undefined) {
                loaded.Title(responseData.Title);
            }
            if (responseData.InternalExternal != undefined) {
                loaded.InternalExternal(responseData.InternalExternal);
            }
            if (responseData.DepartmentID != undefined) {
                loaded.DepartmentID(responseData.DepartmentID);
            }
            if (responseData.DepartmentContactTypeID != undefined) {
                loaded.DepartmentContactTypeID(responseData.DepartmentContactTypeID);
            }
            if (responseData.Email != undefined) {
                loaded.Email(responseData.Email);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Contact != null) {
                loaded.Contact(new smapi.community.ContactModel().LoadFromResponse(responseData.Contact));
            }
            if (responseData.Department != null) {
                loaded.Department(new smapi.community.ExternalOrganizationDepartmentModel().LoadFromResponse(responseData.Department));
            }
            if (responseData.Organization != null) {
                loaded.Organization(new smapi.community.OrganizationModel().LoadFromResponse(responseData.Organization));
            }
            if (responseData.DepartmentContactType != null) {
                loaded.DepartmentContactType(new smapi.community.DepartmentContactTypeModel().LoadFromResponse(responseData.DepartmentContactType));
            }
            if (responseData.RelationshipType != null) {
                loaded.RelationshipType(new smapi.community.RelationshipTypeModel().LoadFromResponse(responseData.RelationshipType));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.OrganizationContactRelationship', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.OrganizationID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RelationshipTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ContactID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Title.extend({
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.InternalExternal.extend({
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            }
        });
        this.DepartmentID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DepartmentContactTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Email.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function DocumentPermissionTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            SystemProtected: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.SystemProtected = ko.validatedObservable(settings.SystemProtected);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.SystemProtected != undefined) {
                loaded.SystemProtected(responseData.SystemProtected);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.DocumentPermissionType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CustomerTransactionEnterpriseDocumentKeyModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.CustomerTransactionEnterpriseDocumentKey', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ReversalTransactionEnterpriseDocumentKeyModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.ReversalTransactionEnterpriseDocumentKey', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function LoadTemplates(basePath, targetDiv) {
        var uri = basePath + '/SMAPI.community.combined-1.0.0.html';
        jQuery.ajax({
            url: uri,
            type: 'GET',
            async: false,
            success: function (template) {
                jQuery("#" + targetDiv).append(template);
            }
        });
    }
    function HesaQualificationResultModel(options) {
        var defaults = {
            PersonID: null,
            QualificationGrade: '',
            QualificationYear: null,
            QualificationSubjectID: null,
            QualificationSittingID: null,
            QualificationTypeID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.QualificationGrade = ko.validatedObservable(settings.QualificationGrade);
        this.QualificationYear = ko.validatedObservable(settings.QualificationYear);
        this.QualificationSubjectID = ko.validatedObservable(settings.QualificationSubjectID);
        this.QualificationSittingID = ko.validatedObservable(settings.QualificationSittingID);
        this.QualificationTypeID = ko.validatedObservable(settings.QualificationTypeID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        this.Organization = ko.observable();
        this.EmploymentStatus = ko.observable();
        this.Occupation = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.QualificationGrade != undefined) {
                loaded.QualificationGrade(responseData.QualificationGrade);
            }
            if (responseData.QualificationYear != undefined) {
                loaded.QualificationYear(responseData.QualificationYear);
            }
            if (responseData.QualificationSubjectID != undefined) {
                loaded.QualificationSubjectID(responseData.QualificationSubjectID);
            }
            if (responseData.QualificationSittingID != undefined) {
                loaded.QualificationSittingID(responseData.QualificationSittingID);
            }
            if (responseData.QualificationTypeID != undefined) {
                loaded.QualificationTypeID(responseData.QualificationTypeID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            var custmdata = {
                defaults : defaults,
                settings : settings,
                self : self,
                responseData : responseData,
                loaded : loaded
            }
            sm.portal.vm.custom.callCustomization('ResponseHandlingForHesaQualification', custmdata);
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Community.Entity.HesaQualificationResult', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.PersonID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.QualificationSubjectID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.QualificationSittingID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.QualificationTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }
   
    
    $.extend(true, smapi.community, {
        AddressAssociationModel: AddressAssociationModel,
        AddressTypeAssociationModel: AddressTypeAssociationModel,
        ElectronicAddressModel: ElectronicAddressModel,
        RegionModel: RegionModel,
        CountryModel: CountryModel,
        UTCTimezoneModel: UTCTimezoneModel,
        MailingAddressModel: MailingAddressModel,
        PhoneNumberModel: PhoneNumberModel,
        ContactNoteModel: ContactNoteModel,
        ContactInterestModel: ContactInterestModel,
        EventManagementModel: EventManagementModel,
        EventTypeModel: EventTypeModel,
        ContactGreetingTypeModel: ContactGreetingTypeModel,
        ContactPronounSetModel: ContactPronounSetModel,
        ContactGreetingModel: ContactGreetingModel,
        MailingAddressTemplateModel: MailingAddressTemplateModel,
        MailingAddressTemplateCountryModel: MailingAddressTemplateCountryModel,
        MailingAddressTemplateFieldModel: MailingAddressTemplateFieldModel,
        MailingAddressTemplateFieldSeparatorModel: MailingAddressTemplateFieldSeparatorModel,
        StreetSuffixModel: StreetSuffixModel,
        MailingAddressFieldTypeModel: MailingAddressFieldTypeModel,
        MailingAddressTemplateFieldSeparatorTypeModel: MailingAddressTemplateFieldSeparatorTypeModel,
        HoldCategoryLocationModel: HoldCategoryLocationModel,
        HoldCategoryModel: HoldCategoryModel,
        HoldStatusModel: HoldStatusModel,
        ContactHoldModel: ContactHoldModel,
        ContactAlertModel: ContactAlertModel,
        UserContactNoteModel: UserContactNoteModel,
        CRMRankModel: CRMRankModel,
        ContactModel: ContactModel,
        PersonPreviousModel: PersonPreviousModel,
        ContactPictureModel: ContactPictureModel,
        EmergencyContactModel: EmergencyContactModel,
        FavoriteGroupModel: FavoriteGroupModel,
        ContactFavoriteModel: ContactFavoriteModel,
        PersonIdentifierTypeModel: PersonIdentifierTypeModel,
        OrganizationIdentifierTypeModel: OrganizationIdentifierTypeModel,
        PersonIdentifierModel: PersonIdentifierModel,
        PersonModel: PersonModel,
        OrganizationIdentifierModel: OrganizationIdentifierModel,
        OrganizationModel: OrganizationModel,
        ReligiousDenominationModel: ReligiousDenominationModel,
        PlaceOfWorshipModel: PlaceOfWorshipModel,
        RelationshipTypeModel: RelationshipTypeModel,
        RelationshipCategoryModel: RelationshipCategoryModel,
        ContactRelationshipModel: ContactRelationshipModel,
        ComputerModel: ComputerModel,
        DemographicDataModel: DemographicDataModel,
        CitizenshipModel: CitizenshipModel,
        MilitaryClassificationModel: MilitaryClassificationModel,
        MilitaryPayGradeModel: MilitaryPayGradeModel,
        MilitaryRankModel: MilitaryRankModel,
        MilitaryServiceModel: MilitaryServiceModel,
        LanguagesModel: LanguagesModel,
        SocietyModuleSettingsModel: SocietyModuleSettingsModel,
        PhoneCarrierModel: PhoneCarrierModel,
        AddressVerificationProviderModel: AddressVerificationProviderModel,
        SatoriAddOnsModel: SatoriAddOnsModel,
        SatoriModel: SatoriModel,
        LoqateModel: LoqateModel,
        GoverningDistrictTypeModel: GoverningDistrictTypeModel,
        GoverningDistrictModel: GoverningDistrictModel,
        LeadTypeModel: LeadTypeModel,
        ContactListCriteriaGroupModel: ContactListCriteriaGroupModel,
        ContactListModel: ContactListModel,
        ListCriteriaConditionCategoryModel: ListCriteriaConditionCategoryModel,
        ListCriteriaConditionModel: ListCriteriaConditionModel,
        DocumentModel: DocumentModel,
        DocumentTypeModel: DocumentTypeModel,
        DocumentRepositoryTypeModel: DocumentRepositoryTypeModel,
        DocumentRepositoryModel: DocumentRepositoryModel,
        DocumentPlaceholderModel: DocumentPlaceholderModel,
        PersonMatchingActionTypeModel: PersonMatchingActionTypeModel,
        PersonMatchedModel: PersonMatchedModel,
        WebContentModel: WebContentModel,
        CommonModuleSettingsModel: CommonModuleSettingsModel,
        PeriodModel: PeriodModel,
        UserTaskNoteModel: UserTaskNoteModel,
        UserTaskModel: UserTaskModel,
        TaskTypeModel: TaskTypeModel,
        TaskStatusModel: TaskStatusModel,
        FavoriteModel: FavoriteModel,
        TargetThresholdCatagoryModel: TargetThresholdCatagoryModel,
        TargetThresholdModel: TargetThresholdModel,
        TargetThresholdValueModel: TargetThresholdValueModel,
        ThresholdConditionModel: ThresholdConditionModel,
        PeriodicityModel: PeriodicityModel,
        WarmupUrlModel: WarmupUrlModel,
        RequestHeaderModel: RequestHeaderModel,
        SessionHeaderModel: SessionHeaderModel,
        RequestExceptionModel: RequestExceptionModel,
        RequestUrlProcessModel: RequestUrlProcessModel,
        DisplayNameOptionsModel: DisplayNameOptionsModel,
        MatchingCriteriaModel: MatchingCriteriaModel,
        EducationAndQualificationTypeModel: EducationAndQualificationTypeModel,
        TeachingPositionTypeModel: TeachingPositionTypeModel,
        UnitOfTimeModel: UnitOfTimeModel,
        DepartmentContactTypeModel: DepartmentContactTypeModel,
        ExternalOrganizationDepartmentModel: ExternalOrganizationDepartmentModel,
        DepartmentalContactModel: DepartmentalContactModel,
        AccessibilityNeedTypeModel: AccessibilityNeedTypeModel,
        AccessibilityNeedModel: AccessibilityNeedModel,
        EmploymentModel: EmploymentModel,
        ContractTypeModel: ContractTypeModel,
        ContractDocumentModel: ContractDocumentModel,
        OrganizationContactRelationshipModel: OrganizationContactRelationshipModel,
        DocumentPermissionTypeModel: DocumentPermissionTypeModel,
        CustomerTransactionEnterpriseDocumentKeyModel: CustomerTransactionEnterpriseDocumentKeyModel,
        ReversalTransactionEnterpriseDocumentKeyModel: ReversalTransactionEnterpriseDocumentKeyModel,
        LoadTemplates: LoadTemplates,
        HesaQualificationResultModel: HesaQualificationResultModel
    });
})(jQuery);
